/*!
	Browser.mobile
	Copyright	Chad Smith
	License		Unlicense
	Version		0.4.0

	http://detectmobilebrowsers.com
*/
window.mobileCheck = function () {
  var check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};
/*!
	Yall - IntersectionObserver
	Copyright	Jeremy Wagner
	License		MIT
	Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions: The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	Version		2.3.0

	https://github.com/malchata/yall.js
*/
var yall = (function () {
  "use strict";
  return function (e) {
    var n = (e = e || {}).lazyClass || "lazy",
      t = e.lazyBackgroundClass || "lazy-bg",
      o = "idleLoadTimeout" in e ? e.idleLoadTimeout : 200,
      i = e.observeChanges || !1,
      r = e.events || {},
      a = e.noPolyfill || !1,
      s = window,
      c = "requestIdleCallback",
      u = "IntersectionObserver",
      l = u in s && u + "Entry" in s,
      d = /baidu|(?:google|bing|yandex|duckduck)bot/i.test(navigator.userAgent),
      v = ["srcset", "src", "poster"],
      f = [],
      queryDOM = function (e, o) {
        return f.slice.call(
          (o || document).querySelectorAll(
            e || "img." + n + ",video." + n + ",iframe." + n + ",." + t,
          ),
        );
      },
      yallLoad = function (n) {
        var o = n.parentNode;
        ("PICTURE" == o.nodeName && yallApplyFn(queryDOM("source", o), yallFlipDataAttrs),
          "VIDEO" == n.nodeName && yallApplyFn(queryDOM("source", n), yallFlipDataAttrs),
          yallFlipDataAttrs(n));
        var i = n.classList;
        i.contains(t) && (i.remove(t), i.add(e.lazyBackgroundLoaded || "lazy-bg-loaded"));
      },
      yallBindEvents = function (e) {
        for (var n in r) e.addEventListener(n, r[n].listener || r[n], r[n].options || void 0);
      },
      yallFlipDataAttrs = function (e) {
        for (var t in v)
          if (v[t] in e.dataset) {
            e.setAttribute(v[t], e.dataset[v[t]]);
            var o = e.parentNode;
            ("SOURCE" === e.nodeName &&
              o.autoplay &&
              (o.load(), /Trident/.test(navigator.userAgent) && o.play(), o.classList.remove(n)),
              e.classList.remove(n));
          }
      },
      yallApplyFn = function (e, n) {
        for (var t = 0; t < e.length; t++) s[u] && n instanceof s[u] ? n.observe(e[t]) : n(e[t]);
      },
      b = queryDOM();
    if ((yallApplyFn(b, yallBindEvents), l && !d)) {
      var g = new s[u](
        function (e) {
          yallApplyFn(e, function (e) {
            if (e.isIntersecting || e.intersectionRatio) {
              var n = e.target;
              (c in s && o
                ? s[c](
                    function () {
                      yallLoad(n);
                    },
                    { timeout: o },
                  )
                : yallLoad(n),
                g.unobserve(n),
                (b = b.filter(function (e) {
                  return e != n;
                })).length ||
                  i ||
                  g.disconnect());
            }
          });
        },
        { rootMargin: ("threshold" in e ? e.threshold : 200) + "px 0%" },
      );
      (yallApplyFn(b, g),
        i &&
          yallApplyFn(queryDOM(e.observeRootSelector || "body"), function (n) {
            new MutationObserver(function () {
              yallApplyFn(queryDOM(), function (e) {
                b.indexOf(e) < 0 &&
                  (b.push(e),
                  yallBindEvents(e),
                  l && !d ? g.observe(e) : (a || d) && yallApplyFn(b, yallLoad));
              });
            }).observe(n, e.mutationObserverOptions || { childList: !0, subtree: !0 });
          }));
    } else (a || d) && yallApplyFn(b, yallLoad);
  };
})();

/*!
	Swiper
	Copyright	Vladimir Kharlampidi
	License		MIT
	Version		7.0.6

	https://github.com/nolimits4web/swiper
*/
!(function (e, t) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = t())
    : "function" == typeof define && define.amd
      ? define(t)
      : ((e = "undefined" != typeof globalThis ? globalThis : e || self).Swiper = t());
})(this, function () {
  "use strict";
  function e(e) {
    return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object;
  }
  function t(s = {}, i = {}) {
    Object.keys(i).forEach((a) => {
      void 0 === s[a]
        ? (s[a] = i[a])
        : e(i[a]) && e(s[a]) && Object.keys(i[a]).length > 0 && t(s[a], i[a]);
    });
  }
  const s = {
    body: {},
    addEventListener() {},
    removeEventListener() {},
    activeElement: { blur() {}, nodeName: "" },
    querySelector: () => null,
    querySelectorAll: () => [],
    getElementById: () => null,
    createEvent: () => ({ initEvent() {} }),
    createElement: () => ({
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {},
      getElementsByTagName: () => [],
    }),
    createElementNS: () => ({}),
    importNode: () => null,
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: "",
    },
  };
  function i() {
    const e = "undefined" != typeof document ? document : {};
    return (t(e, s), e);
  }
  const a = {
    document: s,
    navigator: { userAgent: "" },
    location: {
      hash: "",
      host: "",
      hostname: "",
      href: "",
      origin: "",
      pathname: "",
      protocol: "",
      search: "",
    },
    history: { replaceState() {}, pushState() {}, go() {}, back() {} },
    CustomEvent: function () {
      return this;
    },
    addEventListener() {},
    removeEventListener() {},
    getComputedStyle: () => ({ getPropertyValue: () => "" }),
    Image() {},
    Date() {},
    screen: {},
    setTimeout() {},
    clearTimeout() {},
    matchMedia: () => ({}),
    requestAnimationFrame: (e) =>
      "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0),
    cancelAnimationFrame(e) {
      "undefined" != typeof setTimeout && clearTimeout(e);
    },
  };
  function n() {
    const e = "undefined" != typeof window ? window : {};
    return (t(e, a), e);
  }
  class r extends Array {
    constructor(e) {
      (super(...(e || [])),
        (function (e) {
          const t = e.__proto__;
          Object.defineProperty(e, "__proto__", {
            get: () => t,
            set(e) {
              t.__proto__ = e;
            },
          });
        })(this));
    }
  }
  function l(e = []) {
    const t = [];
    return (
      e.forEach((e) => {
        Array.isArray(e) ? t.push(...l(e)) : t.push(e);
      }),
      t
    );
  }
  function o(e, t) {
    return Array.prototype.filter.call(e, t);
  }
  function d(e, t) {
    const s = n(),
      a = i();
    let l = [];
    if (!t && e instanceof r) return e;
    if (!e) return new r(l);
    if ("string" == typeof e) {
      const s = e.trim();
      if (s.indexOf("<") >= 0 && s.indexOf(">") >= 0) {
        let e = "div";
        (0 === s.indexOf("<li") && (e = "ul"),
          0 === s.indexOf("<tr") && (e = "tbody"),
          (0 !== s.indexOf("<td") && 0 !== s.indexOf("<th")) || (e = "tr"),
          0 === s.indexOf("<tbody") && (e = "table"),
          0 === s.indexOf("<option") && (e = "select"));
        const t = a.createElement(e);
        t.innerHTML = s;
        for (let e = 0; e < t.childNodes.length; e += 1) l.push(t.childNodes[e]);
      } else
        l = (function (e, t) {
          if ("string" != typeof e) return [e];
          const s = [],
            i = t.querySelectorAll(e);
          for (let e = 0; e < i.length; e += 1) s.push(i[e]);
          return s;
        })(e.trim(), t || a);
    } else if (e.nodeType || e === s || e === a) l.push(e);
    else if (Array.isArray(e)) {
      if (e instanceof r) return e;
      l = e;
    }
    return new r(
      (function (e) {
        const t = [];
        for (let s = 0; s < e.length; s += 1) -1 === t.indexOf(e[s]) && t.push(e[s]);
        return t;
      })(l),
    );
  }
  d.fn = r.prototype;
  const p = {
    addClass: function (...e) {
      const t = l(e.map((e) => e.split(" ")));
      return (
        this.forEach((e) => {
          e.classList.add(...t);
        }),
        this
      );
    },
    removeClass: function (...e) {
      const t = l(e.map((e) => e.split(" ")));
      return (
        this.forEach((e) => {
          e.classList.remove(...t);
        }),
        this
      );
    },
    hasClass: function (...e) {
      const t = l(e.map((e) => e.split(" ")));
      return o(this, (e) => t.filter((t) => e.classList.contains(t)).length > 0).length > 0;
    },
    toggleClass: function (...e) {
      const t = l(e.map((e) => e.split(" ")));
      this.forEach((e) => {
        t.forEach((t) => {
          e.classList.toggle(t);
        });
      });
    },
    attr: function (e, t) {
      if (1 === arguments.length && "string" == typeof e)
        return this[0] ? this[0].getAttribute(e) : void 0;
      for (let s = 0; s < this.length; s += 1)
        if (2 === arguments.length) this[s].setAttribute(e, t);
        else for (const t in e) ((this[s][t] = e[t]), this[s].setAttribute(t, e[t]));
      return this;
    },
    removeAttr: function (e) {
      for (let t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
      return this;
    },
    transform: function (e) {
      for (let t = 0; t < this.length; t += 1) this[t].style.transform = e;
      return this;
    },
    transition: function (e) {
      for (let t = 0; t < this.length; t += 1)
        this[t].style.transitionDuration = "string" != typeof e ? `${e}ms` : e;
      return this;
    },
    on: function (...e) {
      let [t, s, i, a] = e;
      function n(e) {
        const t = e.target;
        if (!t) return;
        const a = e.target.dom7EventData || [];
        if ((a.indexOf(e) < 0 && a.unshift(e), d(t).is(s))) i.apply(t, a);
        else {
          const e = d(t).parents();
          for (let t = 0; t < e.length; t += 1) d(e[t]).is(s) && i.apply(e[t], a);
        }
      }
      function r(e) {
        const t = (e && e.target && e.target.dom7EventData) || [];
        (t.indexOf(e) < 0 && t.unshift(e), i.apply(this, t));
      }
      ("function" == typeof e[1] && (([t, i, a] = e), (s = void 0)), a || (a = !1));
      const l = t.split(" ");
      let o;
      for (let e = 0; e < this.length; e += 1) {
        const t = this[e];
        if (s)
          for (o = 0; o < l.length; o += 1) {
            const e = l[o];
            (t.dom7LiveListeners || (t.dom7LiveListeners = {}),
              t.dom7LiveListeners[e] || (t.dom7LiveListeners[e] = []),
              t.dom7LiveListeners[e].push({ listener: i, proxyListener: n }),
              t.addEventListener(e, n, a));
          }
        else
          for (o = 0; o < l.length; o += 1) {
            const e = l[o];
            (t.dom7Listeners || (t.dom7Listeners = {}),
              t.dom7Listeners[e] || (t.dom7Listeners[e] = []),
              t.dom7Listeners[e].push({ listener: i, proxyListener: r }),
              t.addEventListener(e, r, a));
          }
      }
      return this;
    },
    off: function (...e) {
      let [t, s, i, a] = e;
      ("function" == typeof e[1] && (([t, i, a] = e), (s = void 0)), a || (a = !1));
      const n = t.split(" ");
      for (let e = 0; e < n.length; e += 1) {
        const t = n[e];
        for (let e = 0; e < this.length; e += 1) {
          const n = this[e];
          let r;
          if (
            (!s && n.dom7Listeners
              ? (r = n.dom7Listeners[t])
              : s && n.dom7LiveListeners && (r = n.dom7LiveListeners[t]),
            r && r.length)
          )
            for (let e = r.length - 1; e >= 0; e -= 1) {
              const s = r[e];
              (i && s.listener === i) ||
              (i && s.listener && s.listener.dom7proxy && s.listener.dom7proxy === i)
                ? (n.removeEventListener(t, s.proxyListener, a), r.splice(e, 1))
                : i || (n.removeEventListener(t, s.proxyListener, a), r.splice(e, 1));
            }
        }
      }
      return this;
    },
    trigger: function (...e) {
      const t = n(),
        s = e[0].split(" "),
        i = e[1];
      for (let a = 0; a < s.length; a += 1) {
        const n = s[a];
        for (let s = 0; s < this.length; s += 1) {
          const a = this[s];
          if (t.CustomEvent) {
            const s = new t.CustomEvent(n, { detail: i, bubbles: !0, cancelable: !0 });
            ((a.dom7EventData = e.filter((e, t) => t > 0)),
              a.dispatchEvent(s),
              (a.dom7EventData = []),
              delete a.dom7EventData);
          }
        }
      }
      return this;
    },
    transitionEnd: function (e) {
      const t = this;
      return (
        e &&
          t.on("transitionend", function s(i) {
            i.target === this && (e.call(this, i), t.off("transitionend", s));
          }),
        this
      );
    },
    outerWidth: function (e) {
      if (this.length > 0) {
        if (e) {
          const e = this.styles();
          return (
            this[0].offsetWidth +
            parseFloat(e.getPropertyValue("margin-right")) +
            parseFloat(e.getPropertyValue("margin-left"))
          );
        }
        return this[0].offsetWidth;
      }
      return null;
    },
    outerHeight: function (e) {
      if (this.length > 0) {
        if (e) {
          const e = this.styles();
          return (
            this[0].offsetHeight +
            parseFloat(e.getPropertyValue("margin-top")) +
            parseFloat(e.getPropertyValue("margin-bottom"))
          );
        }
        return this[0].offsetHeight;
      }
      return null;
    },
    styles: function () {
      const e = n();
      return this[0] ? e.getComputedStyle(this[0], null) : {};
    },
    offset: function () {
      if (this.length > 0) {
        const e = n(),
          t = i(),
          s = this[0],
          a = s.getBoundingClientRect(),
          r = t.body,
          l = s.clientTop || r.clientTop || 0,
          o = s.clientLeft || r.clientLeft || 0,
          d = s === e ? e.scrollY : s.scrollTop,
          p = s === e ? e.scrollX : s.scrollLeft;
        return { top: a.top + d - l, left: a.left + p - o };
      }
      return null;
    },
    css: function (e, t) {
      const s = n();
      let i;
      if (1 === arguments.length) {
        if ("string" != typeof e) {
          for (i = 0; i < this.length; i += 1) for (const t in e) this[i].style[t] = e[t];
          return this;
        }
        if (this[0]) return s.getComputedStyle(this[0], null).getPropertyValue(e);
      }
      if (2 === arguments.length && "string" == typeof e) {
        for (i = 0; i < this.length; i += 1) this[i].style[e] = t;
        return this;
      }
      return this;
    },
    each: function (e) {
      return e
        ? (this.forEach((t, s) => {
            e.apply(t, [t, s]);
          }),
          this)
        : this;
    },
    html: function (e) {
      if (void 0 === e) return this[0] ? this[0].innerHTML : null;
      for (let t = 0; t < this.length; t += 1) this[t].innerHTML = e;
      return this;
    },
    text: function (e) {
      if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
      for (let t = 0; t < this.length; t += 1) this[t].textContent = e;
      return this;
    },
    is: function (e) {
      const t = n(),
        s = i(),
        a = this[0];
      let l, o;
      if (!a || void 0 === e) return !1;
      if ("string" == typeof e) {
        if (a.matches) return a.matches(e);
        if (a.webkitMatchesSelector) return a.webkitMatchesSelector(e);
        if (a.msMatchesSelector) return a.msMatchesSelector(e);
        for (l = d(e), o = 0; o < l.length; o += 1) if (l[o] === a) return !0;
        return !1;
      }
      if (e === s) return a === s;
      if (e === t) return a === t;
      if (e.nodeType || e instanceof r) {
        for (l = e.nodeType ? [e] : e, o = 0; o < l.length; o += 1) if (l[o] === a) return !0;
        return !1;
      }
      return !1;
    },
    index: function () {
      let e,
        t = this[0];
      if (t) {
        for (e = 0; null !== (t = t.previousSibling); ) 1 === t.nodeType && (e += 1);
        return e;
      }
    },
    eq: function (e) {
      if (void 0 === e) return this;
      const t = this.length;
      if (e > t - 1) return d([]);
      if (e < 0) {
        const s = t + e;
        return d(s < 0 ? [] : [this[s]]);
      }
      return d([this[e]]);
    },
    append: function (...e) {
      let t;
      const s = i();
      for (let i = 0; i < e.length; i += 1) {
        t = e[i];
        for (let e = 0; e < this.length; e += 1)
          if ("string" == typeof t) {
            const i = s.createElement("div");
            for (i.innerHTML = t; i.firstChild; ) this[e].appendChild(i.firstChild);
          } else if (t instanceof r)
            for (let s = 0; s < t.length; s += 1) this[e].appendChild(t[s]);
          else this[e].appendChild(t);
      }
      return this;
    },
    prepend: function (e) {
      const t = i();
      let s, a;
      for (s = 0; s < this.length; s += 1)
        if ("string" == typeof e) {
          const i = t.createElement("div");
          for (i.innerHTML = e, a = i.childNodes.length - 1; a >= 0; a -= 1)
            this[s].insertBefore(i.childNodes[a], this[s].childNodes[0]);
        } else if (e instanceof r)
          for (a = 0; a < e.length; a += 1) this[s].insertBefore(e[a], this[s].childNodes[0]);
        else this[s].insertBefore(e, this[s].childNodes[0]);
      return this;
    },
    next: function (e) {
      return this.length > 0
        ? e
          ? this[0].nextElementSibling && d(this[0].nextElementSibling).is(e)
            ? d([this[0].nextElementSibling])
            : d([])
          : this[0].nextElementSibling
            ? d([this[0].nextElementSibling])
            : d([])
        : d([]);
    },
    nextAll: function (e) {
      const t = [];
      let s = this[0];
      if (!s) return d([]);
      for (; s.nextElementSibling; ) {
        const i = s.nextElementSibling;
        (e ? d(i).is(e) && t.push(i) : t.push(i), (s = i));
      }
      return d(t);
    },
    prev: function (e) {
      if (this.length > 0) {
        const t = this[0];
        return e
          ? t.previousElementSibling && d(t.previousElementSibling).is(e)
            ? d([t.previousElementSibling])
            : d([])
          : t.previousElementSibling
            ? d([t.previousElementSibling])
            : d([]);
      }
      return d([]);
    },
    prevAll: function (e) {
      const t = [];
      let s = this[0];
      if (!s) return d([]);
      for (; s.previousElementSibling; ) {
        const i = s.previousElementSibling;
        (e ? d(i).is(e) && t.push(i) : t.push(i), (s = i));
      }
      return d(t);
    },
    parent: function (e) {
      const t = [];
      for (let s = 0; s < this.length; s += 1)
        null !== this[s].parentNode &&
          (e
            ? d(this[s].parentNode).is(e) && t.push(this[s].parentNode)
            : t.push(this[s].parentNode));
      return d(t);
    },
    parents: function (e) {
      const t = [];
      for (let s = 0; s < this.length; s += 1) {
        let i = this[s].parentNode;
        for (; i; ) (e ? d(i).is(e) && t.push(i) : t.push(i), (i = i.parentNode));
      }
      return d(t);
    },
    closest: function (e) {
      let t = this;
      return void 0 === e ? d([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
    },
    find: function (e) {
      const t = [];
      for (let s = 0; s < this.length; s += 1) {
        const i = this[s].querySelectorAll(e);
        for (let e = 0; e < i.length; e += 1) t.push(i[e]);
      }
      return d(t);
    },
    children: function (e) {
      const t = [];
      for (let s = 0; s < this.length; s += 1) {
        const i = this[s].children;
        for (let s = 0; s < i.length; s += 1) (e && !d(i[s]).is(e)) || t.push(i[s]);
      }
      return d(t);
    },
    filter: function (e) {
      return d(o(this, e));
    },
    remove: function () {
      for (let e = 0; e < this.length; e += 1)
        this[e].parentNode && this[e].parentNode.removeChild(this[e]);
      return this;
    },
  };
  function c(e, t = 0) {
    return setTimeout(e, t);
  }
  function u() {
    return Date.now();
  }
  function h(e, t = "x") {
    const s = n();
    let i, a, r;
    const l = (function (e) {
      const t = n();
      let s;
      return (
        t.getComputedStyle && (s = t.getComputedStyle(e, null)),
        !s && e.currentStyle && (s = e.currentStyle),
        s || (s = e.style),
        s
      );
    })(e);
    return (
      s.WebKitCSSMatrix
        ? ((a = l.transform || l.webkitTransform),
          a.split(",").length > 6 &&
            (a = a
              .split(", ")
              .map((e) => e.replace(",", "."))
              .join(", ")),
          (r = new s.WebKitCSSMatrix("none" === a ? "" : a)))
        : ((r =
            l.MozTransform ||
            l.OTransform ||
            l.MsTransform ||
            l.msTransform ||
            l.transform ||
            l.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")),
          (i = r.toString().split(","))),
      "x" === t &&
        (a = s.WebKitCSSMatrix ? r.m41 : 16 === i.length ? parseFloat(i[12]) : parseFloat(i[4])),
      "y" === t &&
        (a = s.WebKitCSSMatrix ? r.m42 : 16 === i.length ? parseFloat(i[13]) : parseFloat(i[5])),
      a || 0
    );
  }
  function f(e) {
    return (
      "object" == typeof e &&
      null !== e &&
      e.constructor &&
      "Object" === Object.prototype.toString.call(e).slice(8, -1)
    );
  }
  function m(...e) {
    const t = Object(e[0]),
      s = ["__proto__", "constructor", "prototype"];
    for (let a = 1; a < e.length; a += 1) {
      const n = e[a];
      if (
        null != n &&
        ((i = n),
        !("undefined" != typeof window && void 0 !== window.HTMLElement
          ? i instanceof HTMLElement
          : i && (1 === i.nodeType || 11 === i.nodeType)))
      ) {
        const e = Object.keys(Object(n)).filter((e) => s.indexOf(e) < 0);
        for (let s = 0, i = e.length; s < i; s += 1) {
          const i = e[s],
            a = Object.getOwnPropertyDescriptor(n, i);
          void 0 !== a &&
            a.enumerable &&
            (f(t[i]) && f(n[i])
              ? n[i].__swiper__
                ? (t[i] = n[i])
                : m(t[i], n[i])
              : !f(t[i]) && f(n[i])
                ? ((t[i] = {}), n[i].__swiper__ ? (t[i] = n[i]) : m(t[i], n[i]))
                : (t[i] = n[i]));
        }
      }
    }
    var i;
    return t;
  }
  function g(e, t, s) {
    e.style.setProperty(t, s);
  }
  function v({ swiper: e, targetPosition: t, side: s }) {
    const i = n(),
      a = -e.translate;
    let r,
      l = null;
    const o = e.params.speed;
    ((e.wrapperEl.style.scrollSnapType = "none"), i.cancelAnimationFrame(e.cssModeFrameID));
    const d = t > a ? "next" : "prev",
      p = (e, t) => ("next" === d && e >= t) || ("prev" === d && e <= t),
      c = () => {
        ((r = new Date().getTime()), null === l && (l = r));
        const n = Math.max(Math.min((r - l) / o, 1), 0),
          d = 0.5 - Math.cos(n * Math.PI) / 2;
        let u = a + d * (t - a);
        if ((p(u, t) && (u = t), e.wrapperEl.scrollTo({ [s]: u }), p(u, t)))
          return (
            (e.wrapperEl.style.overflow = "hidden"),
            (e.wrapperEl.style.scrollSnapType = ""),
            setTimeout(() => {
              ((e.wrapperEl.style.overflow = ""), e.wrapperEl.scrollTo({ [s]: u }));
            }),
            void i.cancelAnimationFrame(e.cssModeFrameID)
          );
        e.cssModeFrameID = i.requestAnimationFrame(c);
      };
    c();
  }
  let b, w, y;
  function T() {
    return (
      b ||
        (b = (function () {
          const e = n(),
            t = i();
          return {
            smoothScroll: t.documentElement && "scrollBehavior" in t.documentElement.style,
            touch: !!("ontouchstart" in e || (e.DocumentTouch && t instanceof e.DocumentTouch)),
            passiveListener: (function () {
              let t = !1;
              try {
                const s = Object.defineProperty({}, "passive", {
                  get() {
                    t = !0;
                  },
                });
                e.addEventListener("testPassiveListener", null, s);
              } catch (e) {}
              return t;
            })(),
            gestures: "ongesturestart" in e,
          };
        })()),
      b
    );
  }
  function C(e = {}) {
    return (
      w ||
        (w = (function ({ userAgent: e } = {}) {
          const t = T(),
            s = n(),
            i = s.navigator.platform,
            a = e || s.navigator.userAgent,
            r = { ios: !1, android: !1 },
            l = s.screen.width,
            o = s.screen.height,
            d = a.match(/(Android);?[\s\/]+([\d.]+)?/);
          let p = a.match(/(iPad).*OS\s([\d_]+)/);
          const c = a.match(/(iPod)(.*OS\s([\d_]+))?/),
            u = !p && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
            h = "Win32" === i;
          let f = "MacIntel" === i;
          return (
            !p &&
              f &&
              t.touch &&
              [
                "1024x1366",
                "1366x1024",
                "834x1194",
                "1194x834",
                "834x1112",
                "1112x834",
                "768x1024",
                "1024x768",
                "820x1180",
                "1180x820",
                "810x1080",
                "1080x810",
              ].indexOf(`${l}x${o}`) >= 0 &&
              ((p = a.match(/(Version)\/([\d.]+)/)), p || (p = [0, 1, "13_0_0"]), (f = !1)),
            d && !h && ((r.os = "android"), (r.android = !0)),
            (p || u || c) && ((r.os = "ios"), (r.ios = !0)),
            r
          );
        })(e)),
      w
    );
  }
  function x() {
    return (
      y ||
        (y = (function () {
          const e = n();
          return {
            isSafari: (function () {
              const t = e.navigator.userAgent.toLowerCase();
              return (
                t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0
              );
            })(),
            isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent),
          };
        })()),
      y
    );
  }
  Object.keys(p).forEach((e) => {
    Object.defineProperty(d.fn, e, { value: p[e], writable: !0 });
  });
  var S = {
    on(e, t, s) {
      const i = this;
      if ("function" != typeof t) return i;
      const a = s ? "unshift" : "push";
      return (
        e.split(" ").forEach((e) => {
          (i.eventsListeners[e] || (i.eventsListeners[e] = []), i.eventsListeners[e][a](t));
        }),
        i
      );
    },
    once(e, t, s) {
      const i = this;
      if ("function" != typeof t) return i;
      function a(...s) {
        (i.off(e, a), a.__emitterProxy && delete a.__emitterProxy, t.apply(i, s));
      }
      return ((a.__emitterProxy = t), i.on(e, a, s));
    },
    onAny(e, t) {
      const s = this;
      if ("function" != typeof e) return s;
      const i = t ? "unshift" : "push";
      return (s.eventsAnyListeners.indexOf(e) < 0 && s.eventsAnyListeners[i](e), s);
    },
    offAny(e) {
      const t = this;
      if (!t.eventsAnyListeners) return t;
      const s = t.eventsAnyListeners.indexOf(e);
      return (s >= 0 && t.eventsAnyListeners.splice(s, 1), t);
    },
    off(e, t) {
      const s = this;
      return s.eventsListeners
        ? (e.split(" ").forEach((e) => {
            void 0 === t
              ? (s.eventsListeners[e] = [])
              : s.eventsListeners[e] &&
                s.eventsListeners[e].forEach((i, a) => {
                  (i === t || (i.__emitterProxy && i.__emitterProxy === t)) &&
                    s.eventsListeners[e].splice(a, 1);
                });
          }),
          s)
        : s;
    },
    emit(...e) {
      const t = this;
      if (!t.eventsListeners) return t;
      let s, i, a;
      ("string" == typeof e[0] || Array.isArray(e[0])
        ? ((s = e[0]), (i = e.slice(1, e.length)), (a = t))
        : ((s = e[0].events), (i = e[0].data), (a = e[0].context || t)),
        i.unshift(a));
      return (
        (Array.isArray(s) ? s : s.split(" ")).forEach((e) => {
          (t.eventsAnyListeners &&
            t.eventsAnyListeners.length &&
            t.eventsAnyListeners.forEach((t) => {
              t.apply(a, [e, ...i]);
            }),
            t.eventsListeners &&
              t.eventsListeners[e] &&
              t.eventsListeners[e].forEach((e) => {
                e.apply(a, i);
              }));
        }),
        t
      );
    },
  };
  function E({ swiper: e, runCallbacks: t, direction: s, step: i }) {
    const { activeIndex: a, previousIndex: n } = e;
    let r = s;
    if (
      (r || (r = a > n ? "next" : a < n ? "prev" : "reset"), e.emit(`transition${i}`), t && a !== n)
    ) {
      if ("reset" === r) return void e.emit(`slideResetTransition${i}`);
      (e.emit(`slideChangeTransition${i}`),
        "next" === r ? e.emit(`slideNextTransition${i}`) : e.emit(`slidePrevTransition${i}`));
    }
  }
  function M(e) {
    const t = this,
      s = i(),
      a = n(),
      r = t.touchEventsData,
      { params: l, touches: o, enabled: p } = t;
    if (!p) return;
    if (t.animating && l.preventInteractionOnTransition) return;
    !t.animating && l.cssMode && l.loop && t.loopFix();
    let c = e;
    c.originalEvent && (c = c.originalEvent);
    let h = d(c.target);
    if ("wrapper" === l.touchEventsTarget && !h.closest(t.wrapperEl).length) return;
    if (
      ((r.isTouchEvent = "touchstart" === c.type), !r.isTouchEvent && "which" in c && 3 === c.which)
    )
      return;
    if (!r.isTouchEvent && "button" in c && c.button > 0) return;
    if (r.isTouched && r.isMoved) return;
    !!l.noSwipingClass &&
      "" !== l.noSwipingClass &&
      c.target &&
      c.target.shadowRoot &&
      e.path &&
      e.path[0] &&
      (h = d(e.path[0]));
    const f = l.noSwipingSelector ? l.noSwipingSelector : `.${l.noSwipingClass}`,
      m = !(!c.target || !c.target.shadowRoot);
    if (
      l.noSwiping &&
      (m
        ? (function (e, t = this) {
            return (function t(s) {
              return s && s !== i() && s !== n()
                ? (s.assignedSlot && (s = s.assignedSlot), s.closest(e) || t(s.getRootNode().host))
                : null;
            })(t);
          })(f, c.target)
        : h.closest(f)[0])
    )
      return void (t.allowClick = !0);
    if (l.swipeHandler && !h.closest(l.swipeHandler)[0]) return;
    ((o.currentX = "touchstart" === c.type ? c.targetTouches[0].pageX : c.pageX),
      (o.currentY = "touchstart" === c.type ? c.targetTouches[0].pageY : c.pageY));
    const g = o.currentX,
      v = o.currentY,
      b = l.edgeSwipeDetection || l.iOSEdgeSwipeDetection,
      w = l.edgeSwipeThreshold || l.iOSEdgeSwipeThreshold;
    if (b && (g <= w || g >= a.innerWidth - w)) {
      if ("prevent" !== b) return;
      e.preventDefault();
    }
    if (
      (Object.assign(r, {
        isTouched: !0,
        isMoved: !1,
        allowTouchCallbacks: !0,
        isScrolling: void 0,
        startMoving: void 0,
      }),
      (o.startX = g),
      (o.startY = v),
      (r.touchStartTime = u()),
      (t.allowClick = !0),
      t.updateSize(),
      (t.swipeDirection = void 0),
      l.threshold > 0 && (r.allowThresholdMove = !1),
      "touchstart" !== c.type)
    ) {
      let e = !0;
      (h.is(r.focusableElements) && (e = !1),
        s.activeElement &&
          d(s.activeElement).is(r.focusableElements) &&
          s.activeElement !== h[0] &&
          s.activeElement.blur());
      const i = e && t.allowTouchMove && l.touchStartPreventDefault;
      (!l.touchStartForcePreventDefault && !i) || h[0].isContentEditable || c.preventDefault();
    }
    t.emit("touchStart", c);
  }
  function $(e) {
    const t = i(),
      s = this,
      a = s.touchEventsData,
      { params: n, touches: r, rtlTranslate: l, enabled: o } = s;
    if (!o) return;
    let p = e;
    if ((p.originalEvent && (p = p.originalEvent), !a.isTouched))
      return void (a.startMoving && a.isScrolling && s.emit("touchMoveOpposite", p));
    if (a.isTouchEvent && "touchmove" !== p.type) return;
    const c =
        "touchmove" === p.type && p.targetTouches && (p.targetTouches[0] || p.changedTouches[0]),
      h = "touchmove" === p.type ? c.pageX : p.pageX,
      f = "touchmove" === p.type ? c.pageY : p.pageY;
    if (p.preventedByNestedSwiper) return ((r.startX = h), void (r.startY = f));
    if (!s.allowTouchMove)
      return (
        (s.allowClick = !1),
        void (
          a.isTouched &&
          (Object.assign(r, { startX: h, startY: f, currentX: h, currentY: f }),
          (a.touchStartTime = u()))
        )
      );
    if (a.isTouchEvent && n.touchReleaseOnEdges && !n.loop)
      if (s.isVertical()) {
        if (
          (f < r.startY && s.translate <= s.maxTranslate()) ||
          (f > r.startY && s.translate >= s.minTranslate())
        )
          return ((a.isTouched = !1), void (a.isMoved = !1));
      } else if (
        (h < r.startX && s.translate <= s.maxTranslate()) ||
        (h > r.startX && s.translate >= s.minTranslate())
      )
        return;
    if (
      a.isTouchEvent &&
      t.activeElement &&
      p.target === t.activeElement &&
      d(p.target).is(a.focusableElements)
    )
      return ((a.isMoved = !0), void (s.allowClick = !1));
    if (
      (a.allowTouchCallbacks && s.emit("touchMove", p),
      p.targetTouches && p.targetTouches.length > 1)
    )
      return;
    ((r.currentX = h), (r.currentY = f));
    const m = r.currentX - r.startX,
      g = r.currentY - r.startY;
    if (s.params.threshold && Math.sqrt(m ** 2 + g ** 2) < s.params.threshold) return;
    if (void 0 === a.isScrolling) {
      let e;
      (s.isHorizontal() && r.currentY === r.startY) || (s.isVertical() && r.currentX === r.startX)
        ? (a.isScrolling = !1)
        : m * m + g * g >= 25 &&
          ((e = (180 * Math.atan2(Math.abs(g), Math.abs(m))) / Math.PI),
          (a.isScrolling = s.isHorizontal() ? e > n.touchAngle : 90 - e > n.touchAngle));
    }
    if (
      (a.isScrolling && s.emit("touchMoveOpposite", p),
      void 0 === a.startMoving &&
        ((r.currentX === r.startX && r.currentY === r.startY) || (a.startMoving = !0)),
      a.isScrolling)
    )
      return void (a.isTouched = !1);
    if (!a.startMoving) return;
    ((s.allowClick = !1),
      !n.cssMode && p.cancelable && p.preventDefault(),
      n.touchMoveStopPropagation && !n.nested && p.stopPropagation(),
      a.isMoved ||
        (n.loop && !n.cssMode && s.loopFix(),
        (a.startTranslate = s.getTranslate()),
        s.setTransition(0),
        s.animating && s.$wrapperEl.trigger("webkitTransitionEnd transitionend"),
        (a.allowMomentumBounce = !1),
        !n.grabCursor ||
          (!0 !== s.allowSlideNext && !0 !== s.allowSlidePrev) ||
          s.setGrabCursor(!0),
        s.emit("sliderFirstMove", p)),
      s.emit("sliderMove", p),
      (a.isMoved = !0));
    let v = s.isHorizontal() ? m : g;
    ((r.diff = v),
      (v *= n.touchRatio),
      l && (v = -v),
      (s.swipeDirection = v > 0 ? "prev" : "next"),
      (a.currentTranslate = v + a.startTranslate));
    let b = !0,
      w = n.resistanceRatio;
    if (
      (n.touchReleaseOnEdges && (w = 0),
      v > 0 && a.currentTranslate > s.minTranslate()
        ? ((b = !1),
          n.resistance &&
            (a.currentTranslate =
              s.minTranslate() - 1 + (-s.minTranslate() + a.startTranslate + v) ** w))
        : v < 0 &&
          a.currentTranslate < s.maxTranslate() &&
          ((b = !1),
          n.resistance &&
            (a.currentTranslate =
              s.maxTranslate() + 1 - (s.maxTranslate() - a.startTranslate - v) ** w)),
      b && (p.preventedByNestedSwiper = !0),
      !s.allowSlideNext &&
        "next" === s.swipeDirection &&
        a.currentTranslate < a.startTranslate &&
        (a.currentTranslate = a.startTranslate),
      !s.allowSlidePrev &&
        "prev" === s.swipeDirection &&
        a.currentTranslate > a.startTranslate &&
        (a.currentTranslate = a.startTranslate),
      s.allowSlidePrev || s.allowSlideNext || (a.currentTranslate = a.startTranslate),
      n.threshold > 0)
    ) {
      if (!(Math.abs(v) > n.threshold || a.allowThresholdMove))
        return void (a.currentTranslate = a.startTranslate);
      if (!a.allowThresholdMove)
        return (
          (a.allowThresholdMove = !0),
          (r.startX = r.currentX),
          (r.startY = r.currentY),
          (a.currentTranslate = a.startTranslate),
          void (r.diff = s.isHorizontal() ? r.currentX - r.startX : r.currentY - r.startY)
        );
    }
    n.followFinger &&
      !n.cssMode &&
      (((n.freeMode && n.freeMode.enabled && s.freeMode) || n.watchSlidesProgress) &&
        (s.updateActiveIndex(), s.updateSlidesClasses()),
      s.params.freeMode && n.freeMode.enabled && s.freeMode && s.freeMode.onTouchMove(),
      s.updateProgress(a.currentTranslate),
      s.setTranslate(a.currentTranslate));
  }
  function k(e) {
    const t = this,
      s = t.touchEventsData,
      { params: i, touches: a, rtlTranslate: n, slidesGrid: r, enabled: l } = t;
    if (!l) return;
    let o = e;
    if (
      (o.originalEvent && (o = o.originalEvent),
      s.allowTouchCallbacks && t.emit("touchEnd", o),
      (s.allowTouchCallbacks = !1),
      !s.isTouched)
    )
      return (
        s.isMoved && i.grabCursor && t.setGrabCursor(!1),
        (s.isMoved = !1),
        void (s.startMoving = !1)
      );
    i.grabCursor &&
      s.isMoved &&
      s.isTouched &&
      (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
      t.setGrabCursor(!1);
    const d = u(),
      p = d - s.touchStartTime;
    if (
      (t.allowClick &&
        (t.updateClickedSlide(o),
        t.emit("tap click", o),
        p < 300 && d - s.lastClickTime < 300 && t.emit("doubleTap doubleClick", o)),
      (s.lastClickTime = u()),
      c(() => {
        t.destroyed || (t.allowClick = !0);
      }),
      !s.isTouched ||
        !s.isMoved ||
        !t.swipeDirection ||
        0 === a.diff ||
        s.currentTranslate === s.startTranslate)
    )
      return ((s.isTouched = !1), (s.isMoved = !1), void (s.startMoving = !1));
    let h;
    if (
      ((s.isTouched = !1),
      (s.isMoved = !1),
      (s.startMoving = !1),
      (h = i.followFinger ? (n ? t.translate : -t.translate) : -s.currentTranslate),
      i.cssMode)
    )
      return;
    if (t.params.freeMode && i.freeMode.enabled)
      return void t.freeMode.onTouchEnd({ currentPos: h });
    let f = 0,
      m = t.slidesSizesGrid[0];
    for (let e = 0; e < r.length; e += e < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup) {
      const t = e < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
      void 0 !== r[e + t]
        ? h >= r[e] && h < r[e + t] && ((f = e), (m = r[e + t] - r[e]))
        : h >= r[e] && ((f = e), (m = r[r.length - 1] - r[r.length - 2]));
    }
    const g = (h - r[f]) / m,
      v = f < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
    if (p > i.longSwipesMs) {
      if (!i.longSwipes) return void t.slideTo(t.activeIndex);
      ("next" === t.swipeDirection && (g >= i.longSwipesRatio ? t.slideTo(f + v) : t.slideTo(f)),
        "prev" === t.swipeDirection &&
          (g > 1 - i.longSwipesRatio ? t.slideTo(f + v) : t.slideTo(f)));
    } else {
      if (!i.shortSwipes) return void t.slideTo(t.activeIndex);
      t.navigation && (o.target === t.navigation.nextEl || o.target === t.navigation.prevEl)
        ? o.target === t.navigation.nextEl
          ? t.slideTo(f + v)
          : t.slideTo(f)
        : ("next" === t.swipeDirection && t.slideTo(f + v),
          "prev" === t.swipeDirection && t.slideTo(f));
    }
  }
  function P() {
    const e = this,
      { params: t, el: s } = e;
    if (s && 0 === s.offsetWidth) return;
    t.breakpoints && e.setBreakpoint();
    const { allowSlideNext: i, allowSlidePrev: a, snapGrid: n } = e;
    ((e.allowSlideNext = !0),
      (e.allowSlidePrev = !0),
      e.updateSize(),
      e.updateSlides(),
      e.updateSlidesClasses(),
      ("auto" === t.slidesPerView || t.slidesPerView > 1) &&
      e.isEnd &&
      !e.isBeginning &&
      !e.params.centeredSlides
        ? e.slideTo(e.slides.length - 1, 0, !1, !0)
        : e.slideTo(e.activeIndex, 0, !1, !0),
      e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.run(),
      (e.allowSlidePrev = a),
      (e.allowSlideNext = i),
      e.params.watchOverflow && n !== e.snapGrid && e.checkOverflow());
  }
  function O(e) {
    const t = this;
    t.enabled &&
      (t.allowClick ||
        (t.params.preventClicks && e.preventDefault(),
        t.params.preventClicksPropagation &&
          t.animating &&
          (e.stopPropagation(), e.stopImmediatePropagation())));
  }
  function L() {
    const e = this,
      { wrapperEl: t, rtlTranslate: s, enabled: i } = e;
    if (!i) return;
    let a;
    ((e.previousTranslate = e.translate),
      e.isHorizontal() ? (e.translate = -t.scrollLeft) : (e.translate = -t.scrollTop),
      -0 === e.translate && (e.translate = 0),
      e.updateActiveIndex(),
      e.updateSlidesClasses());
    const n = e.maxTranslate() - e.minTranslate();
    ((a = 0 === n ? 0 : (e.translate - e.minTranslate()) / n),
      a !== e.progress && e.updateProgress(s ? -e.translate : e.translate),
      e.emit("setTranslate", e.translate, !1));
  }
  let I = !1;
  function z() {}
  const A = (e, t) => {
    const s = i(),
      { params: a, touchEvents: n, el: r, wrapperEl: l, device: o, support: d } = e,
      p = !!a.nested,
      c = "on" === t ? "addEventListener" : "removeEventListener",
      u = t;
    if (d.touch) {
      const t = !("touchstart" !== n.start || !d.passiveListener || !a.passiveListeners) && {
        passive: !0,
        capture: !1,
      };
      (r[c](n.start, e.onTouchStart, t),
        r[c](n.move, e.onTouchMove, d.passiveListener ? { passive: !1, capture: p } : p),
        r[c](n.end, e.onTouchEnd, t),
        n.cancel && r[c](n.cancel, e.onTouchEnd, t));
    } else
      (r[c](n.start, e.onTouchStart, !1),
        s[c](n.move, e.onTouchMove, p),
        s[c](n.end, e.onTouchEnd, !1));
    ((a.preventClicks || a.preventClicksPropagation) && r[c]("click", e.onClick, !0),
      a.cssMode && l[c]("scroll", e.onScroll),
      a.updateOnWindowResize
        ? e[u](
            o.ios || o.android
              ? "resize orientationchange observerUpdate"
              : "resize observerUpdate",
            P,
            !0,
          )
        : e[u]("observerUpdate", P, !0));
  };
  const D = (e, t) => e.grid && t.grid && t.grid.rows > 1;
  var G = {
    init: !0,
    direction: "horizontal",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    enabled: !0,
    focusableElements: "input, select, option, textarea, button, video, label",
    width: null,
    height: null,
    preventInteractionOnTransition: !1,
    userAgent: null,
    url: null,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: "slide",
    breakpoints: void 0,
    breakpointsBase: "window",
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    watchOverflow: !0,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 0,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: 0.85,
    watchSlidesProgress: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    preloadImages: !0,
    updateOnImagesReady: !0,
    loop: !1,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: !1,
    loopPreventsSlide: !0,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    passiveListeners: !0,
    containerModifierClass: "swiper-",
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-invisible-blank",
    slideActiveClass: "swiper-slide-active",
    slideDuplicateActiveClass: "swiper-slide-duplicate-active",
    slideVisibleClass: "swiper-slide-visible",
    slideDuplicateClass: "swiper-slide-duplicate",
    slideNextClass: "swiper-slide-next",
    slideDuplicateNextClass: "swiper-slide-duplicate-next",
    slidePrevClass: "swiper-slide-prev",
    slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
    wrapperClass: "swiper-wrapper",
    runCallbacksOnInit: !0,
    _emitClasses: !1,
  };
  function N(e, t) {
    return function (s = {}) {
      const i = Object.keys(s)[0],
        a = s[i];
      "object" == typeof a && null !== a
        ? (["navigation", "pagination", "scrollbar"].indexOf(i) >= 0 &&
            !0 === e[i] &&
            (e[i] = { auto: !0 }),
          i in e && "enabled" in a
            ? (!0 === e[i] && (e[i] = { enabled: !0 }),
              "object" != typeof e[i] || "enabled" in e[i] || (e[i].enabled = !0),
              e[i] || (e[i] = { enabled: !1 }),
              m(t, s))
            : m(t, s))
        : m(t, s);
    };
  }
  const B = {
      eventsEmitter: S,
      update: {
        updateSize: function () {
          const e = this;
          let t, s;
          const i = e.$el;
          ((t =
            void 0 !== e.params.width && null !== e.params.width
              ? e.params.width
              : i[0].clientWidth),
            (s =
              void 0 !== e.params.height && null !== e.params.height
                ? e.params.height
                : i[0].clientHeight),
            (0 === t && e.isHorizontal()) ||
              (0 === s && e.isVertical()) ||
              ((t =
                t -
                parseInt(i.css("padding-left") || 0, 10) -
                parseInt(i.css("padding-right") || 0, 10)),
              (s =
                s -
                parseInt(i.css("padding-top") || 0, 10) -
                parseInt(i.css("padding-bottom") || 0, 10)),
              Number.isNaN(t) && (t = 0),
              Number.isNaN(s) && (s = 0),
              Object.assign(e, { width: t, height: s, size: e.isHorizontal() ? t : s })));
        },
        updateSlides: function () {
          const e = this;
          function t(t) {
            return e.isHorizontal()
              ? t
              : {
                  width: "height",
                  "margin-top": "margin-left",
                  "margin-bottom ": "margin-right",
                  "margin-left": "margin-top",
                  "margin-right": "margin-bottom",
                  "padding-left": "padding-top",
                  "padding-right": "padding-bottom",
                  marginRight: "marginBottom",
                }[t];
          }
          function s(e, s) {
            return parseFloat(e.getPropertyValue(t(s)) || 0);
          }
          const i = e.params,
            { $wrapperEl: a, size: n, rtlTranslate: r, wrongRTL: l } = e,
            o = e.virtual && i.virtual.enabled,
            d = o ? e.virtual.slides.length : e.slides.length,
            p = a.children(`.${e.params.slideClass}`),
            c = o ? e.virtual.slides.length : p.length;
          let u = [];
          const h = [],
            f = [];
          let m = i.slidesOffsetBefore;
          "function" == typeof m && (m = i.slidesOffsetBefore.call(e));
          let v = i.slidesOffsetAfter;
          "function" == typeof v && (v = i.slidesOffsetAfter.call(e));
          const b = e.snapGrid.length,
            w = e.slidesGrid.length;
          let y = i.spaceBetween,
            T = -m,
            C = 0,
            x = 0;
          if (void 0 === n) return;
          ("string" == typeof y &&
            y.indexOf("%") >= 0 &&
            (y = (parseFloat(y.replace("%", "")) / 100) * n),
            (e.virtualSize = -y),
            r
              ? p.css({ marginLeft: "", marginBottom: "", marginTop: "" })
              : p.css({ marginRight: "", marginBottom: "", marginTop: "" }),
            i.centeredSlides &&
              i.cssMode &&
              (g(e.wrapperEl, "--swiper-centered-offset-before", ""),
              g(e.wrapperEl, "--swiper-centered-offset-after", "")));
          const S = i.grid && i.grid.rows > 1 && e.grid;
          let E;
          S && e.grid.initSlides(c);
          const M =
            "auto" === i.slidesPerView &&
            i.breakpoints &&
            Object.keys(i.breakpoints).filter((e) => void 0 !== i.breakpoints[e].slidesPerView)
              .length > 0;
          for (let a = 0; a < c; a += 1) {
            E = 0;
            const r = p.eq(a);
            if ((S && e.grid.updateSlide(a, r, c, t), "none" !== r.css("display"))) {
              if ("auto" === i.slidesPerView) {
                M && (p[a].style[t("width")] = "");
                const n = getComputedStyle(r[0]),
                  l = r[0].style.transform,
                  o = r[0].style.webkitTransform;
                if (
                  (l && (r[0].style.transform = "none"),
                  o && (r[0].style.webkitTransform = "none"),
                  i.roundLengths)
                )
                  E = e.isHorizontal() ? r.outerWidth(!0) : r.outerHeight(!0);
                else {
                  const e = s(n, "width"),
                    t = s(n, "padding-left"),
                    i = s(n, "padding-right"),
                    a = s(n, "margin-left"),
                    l = s(n, "margin-right"),
                    o = n.getPropertyValue("box-sizing");
                  if (o && "border-box" === o) E = e + a + l;
                  else {
                    const { clientWidth: s, offsetWidth: n } = r[0];
                    E = e + t + i + a + l + (n - s);
                  }
                }
                (l && (r[0].style.transform = l),
                  o && (r[0].style.webkitTransform = o),
                  i.roundLengths && (E = Math.floor(E)));
              } else
                ((E = (n - (i.slidesPerView - 1) * y) / i.slidesPerView),
                  i.roundLengths && (E = Math.floor(E)),
                  p[a] && (p[a].style[t("width")] = `${E}px`));
              (p[a] && (p[a].swiperSlideSize = E),
                f.push(E),
                i.centeredSlides
                  ? ((T = T + E / 2 + C / 2 + y),
                    0 === C && 0 !== a && (T = T - n / 2 - y),
                    0 === a && (T = T - n / 2 - y),
                    Math.abs(T) < 0.001 && (T = 0),
                    i.roundLengths && (T = Math.floor(T)),
                    x % i.slidesPerGroup == 0 && u.push(T),
                    h.push(T))
                  : (i.roundLengths && (T = Math.floor(T)),
                    (x - Math.min(e.params.slidesPerGroupSkip, x)) % e.params.slidesPerGroup == 0 &&
                      u.push(T),
                    h.push(T),
                    (T = T + E + y)),
                (e.virtualSize += E + y),
                (C = E),
                (x += 1));
            }
          }
          if (
            ((e.virtualSize = Math.max(e.virtualSize, n) + v),
            r &&
              l &&
              ("slide" === i.effect || "coverflow" === i.effect) &&
              a.css({ width: `${e.virtualSize + i.spaceBetween}px` }),
            i.setWrapperSize && a.css({ [t("width")]: `${e.virtualSize + i.spaceBetween}px` }),
            S && e.grid.updateWrapperSize(E, u, t),
            !i.centeredSlides)
          ) {
            const t = [];
            for (let s = 0; s < u.length; s += 1) {
              let a = u[s];
              (i.roundLengths && (a = Math.floor(a)), u[s] <= e.virtualSize - n && t.push(a));
            }
            ((u = t),
              Math.floor(e.virtualSize - n) - Math.floor(u[u.length - 1]) > 1 &&
                u.push(e.virtualSize - n));
          }
          if ((0 === u.length && (u = [0]), 0 !== i.spaceBetween)) {
            const s = e.isHorizontal() && r ? "marginLeft" : t("marginRight");
            p.filter((e, t) => !i.cssMode || t !== p.length - 1).css({ [s]: `${y}px` });
          }
          if (i.centeredSlides && i.centeredSlidesBounds) {
            let e = 0;
            (f.forEach((t) => {
              e += t + (i.spaceBetween ? i.spaceBetween : 0);
            }),
              (e -= i.spaceBetween));
            const t = e - n;
            u = u.map((e) => (e < 0 ? -m : e > t ? t + v : e));
          }
          if (i.centerInsufficientSlides) {
            let e = 0;
            if (
              (f.forEach((t) => {
                e += t + (i.spaceBetween ? i.spaceBetween : 0);
              }),
              (e -= i.spaceBetween),
              e < n)
            ) {
              const t = (n - e) / 2;
              (u.forEach((e, s) => {
                u[s] = e - t;
              }),
                h.forEach((e, s) => {
                  h[s] = e + t;
                }));
            }
          }
          if (
            (Object.assign(e, { slides: p, snapGrid: u, slidesGrid: h, slidesSizesGrid: f }),
            i.centeredSlides && i.cssMode && !i.centeredSlidesBounds)
          ) {
            (g(e.wrapperEl, "--swiper-centered-offset-before", -u[0] + "px"),
              g(
                e.wrapperEl,
                "--swiper-centered-offset-after",
                e.size / 2 - f[f.length - 1] / 2 + "px",
              ));
            const t = -e.snapGrid[0],
              s = -e.slidesGrid[0];
            ((e.snapGrid = e.snapGrid.map((e) => e + t)),
              (e.slidesGrid = e.slidesGrid.map((e) => e + s)));
          }
          (c !== d && e.emit("slidesLengthChange"),
            u.length !== b &&
              (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")),
            h.length !== w && e.emit("slidesGridLengthChange"),
            i.watchSlidesProgress && e.updateSlidesOffset());
        },
        updateAutoHeight: function (e) {
          const t = this,
            s = [],
            i = t.virtual && t.params.virtual.enabled;
          let a,
            n = 0;
          "number" == typeof e ? t.setTransition(e) : !0 === e && t.setTransition(t.params.speed);
          const r = (e) =>
            i
              ? t.slides.filter(
                  (t) => parseInt(t.getAttribute("data-swiper-slide-index"), 10) === e,
                )[0]
              : t.slides.eq(e)[0];
          if ("auto" !== t.params.slidesPerView && t.params.slidesPerView > 1)
            if (t.params.centeredSlides)
              t.visibleSlides.each((e) => {
                s.push(e);
              });
            else
              for (a = 0; a < Math.ceil(t.params.slidesPerView); a += 1) {
                const e = t.activeIndex + a;
                if (e > t.slides.length && !i) break;
                s.push(r(e));
              }
          else s.push(r(t.activeIndex));
          for (a = 0; a < s.length; a += 1)
            if (void 0 !== s[a]) {
              const e = s[a].offsetHeight;
              n = e > n ? e : n;
            }
          n && t.$wrapperEl.css("height", `${n}px`);
        },
        updateSlidesOffset: function () {
          const e = this,
            t = e.slides;
          for (let s = 0; s < t.length; s += 1)
            t[s].swiperSlideOffset = e.isHorizontal() ? t[s].offsetLeft : t[s].offsetTop;
        },
        updateSlidesProgress: function (e = (this && this.translate) || 0) {
          const t = this,
            s = t.params,
            { slides: i, rtlTranslate: a } = t;
          if (0 === i.length) return;
          void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
          let n = -e;
          (a && (n = e),
            i.removeClass(s.slideVisibleClass),
            (t.visibleSlidesIndexes = []),
            (t.visibleSlides = []));
          for (let e = 0; e < i.length; e += 1) {
            const r = i[e];
            let l = r.swiperSlideOffset;
            s.cssMode && s.centeredSlides && (l -= i[0].swiperSlideOffset);
            const o =
                (n + (s.centeredSlides ? t.minTranslate() : 0) - l) /
                (r.swiperSlideSize + s.spaceBetween),
              d = -(n - l),
              p = d + t.slidesSizesGrid[e];
            (((d >= 0 && d < t.size - 1) || (p > 1 && p <= t.size) || (d <= 0 && p >= t.size)) &&
              (t.visibleSlides.push(r),
              t.visibleSlidesIndexes.push(e),
              i.eq(e).addClass(s.slideVisibleClass)),
              (r.progress = a ? -o : o));
          }
          t.visibleSlides = d(t.visibleSlides);
        },
        updateProgress: function (e) {
          const t = this;
          if (void 0 === e) {
            const s = t.rtlTranslate ? -1 : 1;
            e = (t && t.translate && t.translate * s) || 0;
          }
          const s = t.params,
            i = t.maxTranslate() - t.minTranslate();
          let { progress: a, isBeginning: n, isEnd: r } = t;
          const l = n,
            o = r;
          (0 === i
            ? ((a = 0), (n = !0), (r = !0))
            : ((a = (e - t.minTranslate()) / i), (n = a <= 0), (r = a >= 1)),
            Object.assign(t, { progress: a, isBeginning: n, isEnd: r }),
            (s.watchSlidesProgress || (s.centeredSlides && s.autoHeight)) &&
              t.updateSlidesProgress(e),
            n && !l && t.emit("reachBeginning toEdge"),
            r && !o && t.emit("reachEnd toEdge"),
            ((l && !n) || (o && !r)) && t.emit("fromEdge"),
            t.emit("progress", a));
        },
        updateSlidesClasses: function () {
          const e = this,
            { slides: t, params: s, $wrapperEl: i, activeIndex: a, realIndex: n } = e,
            r = e.virtual && s.virtual.enabled;
          let l;
          (t.removeClass(
            `${s.slideActiveClass} ${s.slideNextClass} ${s.slidePrevClass} ${s.slideDuplicateActiveClass} ${s.slideDuplicateNextClass} ${s.slideDuplicatePrevClass}`,
          ),
            (l = r
              ? e.$wrapperEl.find(`.${s.slideClass}[data-swiper-slide-index="${a}"]`)
              : t.eq(a)),
            l.addClass(s.slideActiveClass),
            s.loop &&
              (l.hasClass(s.slideDuplicateClass)
                ? i
                    .children(
                      `.${s.slideClass}:not(.${s.slideDuplicateClass})[data-swiper-slide-index="${n}"]`,
                    )
                    .addClass(s.slideDuplicateActiveClass)
                : i
                    .children(
                      `.${s.slideClass}.${s.slideDuplicateClass}[data-swiper-slide-index="${n}"]`,
                    )
                    .addClass(s.slideDuplicateActiveClass)));
          let o = l.nextAll(`.${s.slideClass}`).eq(0).addClass(s.slideNextClass);
          s.loop && 0 === o.length && ((o = t.eq(0)), o.addClass(s.slideNextClass));
          let d = l.prevAll(`.${s.slideClass}`).eq(0).addClass(s.slidePrevClass);
          (s.loop && 0 === d.length && ((d = t.eq(-1)), d.addClass(s.slidePrevClass)),
            s.loop &&
              (o.hasClass(s.slideDuplicateClass)
                ? i
                    .children(
                      `.${s.slideClass}:not(.${s.slideDuplicateClass})[data-swiper-slide-index="${o.attr("data-swiper-slide-index")}"]`,
                    )
                    .addClass(s.slideDuplicateNextClass)
                : i
                    .children(
                      `.${s.slideClass}.${s.slideDuplicateClass}[data-swiper-slide-index="${o.attr("data-swiper-slide-index")}"]`,
                    )
                    .addClass(s.slideDuplicateNextClass),
              d.hasClass(s.slideDuplicateClass)
                ? i
                    .children(
                      `.${s.slideClass}:not(.${s.slideDuplicateClass})[data-swiper-slide-index="${d.attr("data-swiper-slide-index")}"]`,
                    )
                    .addClass(s.slideDuplicatePrevClass)
                : i
                    .children(
                      `.${s.slideClass}.${s.slideDuplicateClass}[data-swiper-slide-index="${d.attr("data-swiper-slide-index")}"]`,
                    )
                    .addClass(s.slideDuplicatePrevClass)),
            e.emitSlidesClasses());
        },
        updateActiveIndex: function (e) {
          const t = this,
            s = t.rtlTranslate ? t.translate : -t.translate,
            {
              slidesGrid: i,
              snapGrid: a,
              params: n,
              activeIndex: r,
              realIndex: l,
              snapIndex: o,
            } = t;
          let d,
            p = e;
          if (void 0 === p) {
            for (let e = 0; e < i.length; e += 1)
              void 0 !== i[e + 1]
                ? s >= i[e] && s < i[e + 1] - (i[e + 1] - i[e]) / 2
                  ? (p = e)
                  : s >= i[e] && s < i[e + 1] && (p = e + 1)
                : s >= i[e] && (p = e);
            n.normalizeSlideIndex && (p < 0 || void 0 === p) && (p = 0);
          }
          if (a.indexOf(s) >= 0) d = a.indexOf(s);
          else {
            const e = Math.min(n.slidesPerGroupSkip, p);
            d = e + Math.floor((p - e) / n.slidesPerGroup);
          }
          if ((d >= a.length && (d = a.length - 1), p === r))
            return void (d !== o && ((t.snapIndex = d), t.emit("snapIndexChange")));
          const c = parseInt(t.slides.eq(p).attr("data-swiper-slide-index") || p, 10);
          (Object.assign(t, { snapIndex: d, realIndex: c, previousIndex: r, activeIndex: p }),
            t.emit("activeIndexChange"),
            t.emit("snapIndexChange"),
            l !== c && t.emit("realIndexChange"),
            (t.initialized || t.params.runCallbacksOnInit) && t.emit("slideChange"));
        },
        updateClickedSlide: function (e) {
          const t = this,
            s = t.params,
            i = d(e.target).closest(`.${s.slideClass}`)[0];
          let a,
            n = !1;
          if (i)
            for (let e = 0; e < t.slides.length; e += 1)
              if (t.slides[e] === i) {
                ((n = !0), (a = e));
                break;
              }
          if (!i || !n) return ((t.clickedSlide = void 0), void (t.clickedIndex = void 0));
          ((t.clickedSlide = i),
            t.virtual && t.params.virtual.enabled
              ? (t.clickedIndex = parseInt(d(i).attr("data-swiper-slide-index"), 10))
              : (t.clickedIndex = a),
            s.slideToClickedSlide &&
              void 0 !== t.clickedIndex &&
              t.clickedIndex !== t.activeIndex &&
              t.slideToClickedSlide());
        },
      },
      translate: {
        getTranslate: function (e = this.isHorizontal() ? "x" : "y") {
          const { params: t, rtlTranslate: s, translate: i, $wrapperEl: a } = this;
          if (t.virtualTranslate) return s ? -i : i;
          if (t.cssMode) return i;
          let n = h(a[0], e);
          return (s && (n = -n), n || 0);
        },
        setTranslate: function (e, t) {
          const s = this,
            { rtlTranslate: i, params: a, $wrapperEl: n, wrapperEl: r, progress: l } = s;
          let o,
            d = 0,
            p = 0;
          (s.isHorizontal() ? (d = i ? -e : e) : (p = e),
            a.roundLengths && ((d = Math.floor(d)), (p = Math.floor(p))),
            a.cssMode
              ? (r[s.isHorizontal() ? "scrollLeft" : "scrollTop"] = s.isHorizontal() ? -d : -p)
              : a.virtualTranslate || n.transform(`translate3d(${d}px, ${p}px, 0px)`),
            (s.previousTranslate = s.translate),
            (s.translate = s.isHorizontal() ? d : p));
          const c = s.maxTranslate() - s.minTranslate();
          ((o = 0 === c ? 0 : (e - s.minTranslate()) / c),
            o !== l && s.updateProgress(e),
            s.emit("setTranslate", s.translate, t));
        },
        minTranslate: function () {
          return -this.snapGrid[0];
        },
        maxTranslate: function () {
          return -this.snapGrid[this.snapGrid.length - 1];
        },
        translateTo: function (e = 0, t = this.params.speed, s = !0, i = !0, a) {
          const n = this,
            { params: r, wrapperEl: l } = n;
          if (n.animating && r.preventInteractionOnTransition) return !1;
          const o = n.minTranslate(),
            d = n.maxTranslate();
          let p;
          if (((p = i && e > o ? o : i && e < d ? d : e), n.updateProgress(p), r.cssMode)) {
            const e = n.isHorizontal();
            if (0 === t) l[e ? "scrollLeft" : "scrollTop"] = -p;
            else {
              if (!n.support.smoothScroll)
                return (v({ swiper: n, targetPosition: -p, side: e ? "left" : "top" }), !0);
              l.scrollTo({ [e ? "left" : "top"]: -p, behavior: "smooth" });
            }
            return !0;
          }
          return (
            0 === t
              ? (n.setTransition(0),
                n.setTranslate(p),
                s && (n.emit("beforeTransitionStart", t, a), n.emit("transitionEnd")))
              : (n.setTransition(t),
                n.setTranslate(p),
                s && (n.emit("beforeTransitionStart", t, a), n.emit("transitionStart")),
                n.animating ||
                  ((n.animating = !0),
                  n.onTranslateToWrapperTransitionEnd ||
                    (n.onTranslateToWrapperTransitionEnd = function (e) {
                      n &&
                        !n.destroyed &&
                        e.target === this &&
                        (n.$wrapperEl[0].removeEventListener(
                          "transitionend",
                          n.onTranslateToWrapperTransitionEnd,
                        ),
                        n.$wrapperEl[0].removeEventListener(
                          "webkitTransitionEnd",
                          n.onTranslateToWrapperTransitionEnd,
                        ),
                        (n.onTranslateToWrapperTransitionEnd = null),
                        delete n.onTranslateToWrapperTransitionEnd,
                        s && n.emit("transitionEnd"));
                    }),
                  n.$wrapperEl[0].addEventListener(
                    "transitionend",
                    n.onTranslateToWrapperTransitionEnd,
                  ),
                  n.$wrapperEl[0].addEventListener(
                    "webkitTransitionEnd",
                    n.onTranslateToWrapperTransitionEnd,
                  ))),
            !0
          );
        },
      },
      transition: {
        setTransition: function (e, t) {
          const s = this;
          (s.params.cssMode || s.$wrapperEl.transition(e), s.emit("setTransition", e, t));
        },
        transitionStart: function (e = !0, t) {
          const s = this,
            { params: i } = s;
          i.cssMode ||
            (i.autoHeight && s.updateAutoHeight(),
            E({ swiper: s, runCallbacks: e, direction: t, step: "Start" }));
        },
        transitionEnd: function (e = !0, t) {
          const s = this,
            { params: i } = s;
          ((s.animating = !1),
            i.cssMode ||
              (s.setTransition(0), E({ swiper: s, runCallbacks: e, direction: t, step: "End" })));
        },
      },
      slide: {
        slideTo: function (e = 0, t = this.params.speed, s = !0, i, a) {
          if ("number" != typeof e && "string" != typeof e)
            throw new Error(
              `The 'index' argument cannot have type other than 'number' or 'string'. [${typeof e}] given.`,
            );
          if ("string" == typeof e) {
            const t = parseInt(e, 10);
            if (!isFinite(t))
              throw new Error(
                `The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`,
              );
            e = t;
          }
          const n = this;
          let r = e;
          r < 0 && (r = 0);
          const {
            params: l,
            snapGrid: o,
            slidesGrid: d,
            previousIndex: p,
            activeIndex: c,
            rtlTranslate: u,
            wrapperEl: h,
            enabled: f,
          } = n;
          if ((n.animating && l.preventInteractionOnTransition) || (!f && !i && !a)) return !1;
          const m = Math.min(n.params.slidesPerGroupSkip, r);
          let g = m + Math.floor((r - m) / n.params.slidesPerGroup);
          (g >= o.length && (g = o.length - 1),
            (c || l.initialSlide || 0) === (p || 0) && s && n.emit("beforeSlideChangeStart"));
          const b = -o[g];
          if ((n.updateProgress(b), l.normalizeSlideIndex))
            for (let e = 0; e < d.length; e += 1) {
              const t = -Math.floor(100 * b),
                s = Math.floor(100 * d[e]),
                i = Math.floor(100 * d[e + 1]);
              void 0 !== d[e + 1]
                ? t >= s && t < i - (i - s) / 2
                  ? (r = e)
                  : t >= s && t < i && (r = e + 1)
                : t >= s && (r = e);
            }
          if (n.initialized && r !== c) {
            if (!n.allowSlideNext && b < n.translate && b < n.minTranslate()) return !1;
            if (!n.allowSlidePrev && b > n.translate && b > n.maxTranslate() && (c || 0) !== r)
              return !1;
          }
          let w;
          if (
            ((w = r > c ? "next" : r < c ? "prev" : "reset"),
            (u && -b === n.translate) || (!u && b === n.translate))
          )
            return (
              n.updateActiveIndex(r),
              l.autoHeight && n.updateAutoHeight(),
              n.updateSlidesClasses(),
              "slide" !== l.effect && n.setTranslate(b),
              "reset" !== w && (n.transitionStart(s, w), n.transitionEnd(s, w)),
              !1
            );
          if (l.cssMode) {
            const e = n.isHorizontal(),
              s = u ? b : -b;
            if (0 === t) {
              const t = n.virtual && n.params.virtual.enabled;
              (t && ((n.wrapperEl.style.scrollSnapType = "none"), (n._immediateVirtual = !0)),
                (h[e ? "scrollLeft" : "scrollTop"] = s),
                t &&
                  requestAnimationFrame(() => {
                    ((n.wrapperEl.style.scrollSnapType = ""), (n._swiperImmediateVirtual = !1));
                  }));
            } else {
              if (!n.support.smoothScroll)
                return (v({ swiper: n, targetPosition: s, side: e ? "left" : "top" }), !0);
              h.scrollTo({ [e ? "left" : "top"]: s, behavior: "smooth" });
            }
            return !0;
          }
          return (
            0 === t
              ? (n.setTransition(0),
                n.setTranslate(b),
                n.updateActiveIndex(r),
                n.updateSlidesClasses(),
                n.emit("beforeTransitionStart", t, i),
                n.transitionStart(s, w),
                n.transitionEnd(s, w))
              : (n.setTransition(t),
                n.setTranslate(b),
                n.updateActiveIndex(r),
                n.updateSlidesClasses(),
                n.emit("beforeTransitionStart", t, i),
                n.transitionStart(s, w),
                n.animating ||
                  ((n.animating = !0),
                  n.onSlideToWrapperTransitionEnd ||
                    (n.onSlideToWrapperTransitionEnd = function (e) {
                      n &&
                        !n.destroyed &&
                        e.target === this &&
                        (n.$wrapperEl[0].removeEventListener(
                          "transitionend",
                          n.onSlideToWrapperTransitionEnd,
                        ),
                        n.$wrapperEl[0].removeEventListener(
                          "webkitTransitionEnd",
                          n.onSlideToWrapperTransitionEnd,
                        ),
                        (n.onSlideToWrapperTransitionEnd = null),
                        delete n.onSlideToWrapperTransitionEnd,
                        n.transitionEnd(s, w));
                    }),
                  n.$wrapperEl[0].addEventListener(
                    "transitionend",
                    n.onSlideToWrapperTransitionEnd,
                  ),
                  n.$wrapperEl[0].addEventListener(
                    "webkitTransitionEnd",
                    n.onSlideToWrapperTransitionEnd,
                  ))),
            !0
          );
        },
        slideToLoop: function (e = 0, t = this.params.speed, s = !0, i) {
          const a = this;
          let n = e;
          return (a.params.loop && (n += a.loopedSlides), a.slideTo(n, t, s, i));
        },
        slideNext: function (e = this.params.speed, t = !0, s) {
          const i = this,
            { animating: a, enabled: n, params: r } = i;
          if (!n) return i;
          let l = r.slidesPerGroup;
          "auto" === r.slidesPerView &&
            1 === r.slidesPerGroup &&
            r.slidesPerGroupAuto &&
            (l = Math.max(i.slidesPerViewDynamic("current", !0), 1));
          const o = i.activeIndex < r.slidesPerGroupSkip ? 1 : l;
          if (r.loop) {
            if (a && r.loopPreventsSlide) return !1;
            (i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft));
          }
          return i.slideTo(i.activeIndex + o, e, t, s);
        },
        slidePrev: function (e = this.params.speed, t = !0, s) {
          const i = this,
            {
              params: a,
              animating: n,
              snapGrid: r,
              slidesGrid: l,
              rtlTranslate: o,
              enabled: d,
            } = i;
          if (!d) return i;
          if (a.loop) {
            if (n && a.loopPreventsSlide) return !1;
            (i.loopFix(), (i._clientLeft = i.$wrapperEl[0].clientLeft));
          }
          function p(e) {
            return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
          }
          const c = p(o ? i.translate : -i.translate),
            u = r.map((e) => p(e));
          let h = r[u.indexOf(c) - 1];
          if (void 0 === h && a.cssMode) {
            let e;
            (r.forEach((t, s) => {
              c >= t && (e = s);
            }),
              void 0 !== e && (h = r[e > 0 ? e - 1 : e]));
          }
          let f = 0;
          return (
            void 0 !== h &&
              ((f = l.indexOf(h)),
              f < 0 && (f = i.activeIndex - 1),
              "auto" === a.slidesPerView &&
                1 === a.slidesPerGroup &&
                a.slidesPerGroupAuto &&
                ((f = f - i.slidesPerViewDynamic("previous", !0) + 1), (f = Math.max(f, 0)))),
            i.slideTo(f, e, t, s)
          );
        },
        slideReset: function (e = this.params.speed, t = !0, s) {
          return this.slideTo(this.activeIndex, e, t, s);
        },
        slideToClosest: function (e = this.params.speed, t = !0, s, i = 0.5) {
          const a = this;
          let n = a.activeIndex;
          const r = Math.min(a.params.slidesPerGroupSkip, n),
            l = r + Math.floor((n - r) / a.params.slidesPerGroup),
            o = a.rtlTranslate ? a.translate : -a.translate;
          if (o >= a.snapGrid[l]) {
            const e = a.snapGrid[l];
            o - e > (a.snapGrid[l + 1] - e) * i && (n += a.params.slidesPerGroup);
          } else {
            const e = a.snapGrid[l - 1];
            o - e <= (a.snapGrid[l] - e) * i && (n -= a.params.slidesPerGroup);
          }
          return (
            (n = Math.max(n, 0)), (n = Math.min(n, a.slidesGrid.length - 1)), a.slideTo(n, e, t, s)
          );
        },
        slideToClickedSlide: function () {
          const e = this,
            { params: t, $wrapperEl: s } = e,
            i = "auto" === t.slidesPerView ? e.slidesPerViewDynamic() : t.slidesPerView;
          let a,
            n = e.clickedIndex;
          if (t.loop) {
            if (e.animating) return;
            ((a = parseInt(d(e.clickedSlide).attr("data-swiper-slide-index"), 10)),
              t.centeredSlides
                ? n < e.loopedSlides - i / 2 || n > e.slides.length - e.loopedSlides + i / 2
                  ? (e.loopFix(),
                    (n = s
                      .children(
                        `.${t.slideClass}[data-swiper-slide-index="${a}"]:not(.${t.slideDuplicateClass})`,
                      )
                      .eq(0)
                      .index()),
                    c(() => {
                      e.slideTo(n);
                    }))
                  : e.slideTo(n)
                : n > e.slides.length - i
                  ? (e.loopFix(),
                    (n = s
                      .children(
                        `.${t.slideClass}[data-swiper-slide-index="${a}"]:not(.${t.slideDuplicateClass})`,
                      )
                      .eq(0)
                      .index()),
                    c(() => {
                      e.slideTo(n);
                    }))
                  : e.slideTo(n));
          } else e.slideTo(n);
        },
      },
      loop: {
        loopCreate: function () {
          const e = this,
            t = i(),
            { params: s, $wrapperEl: a } = e;
          a.children(`.${s.slideClass}.${s.slideDuplicateClass}`).remove();
          let n = a.children(`.${s.slideClass}`);
          if (s.loopFillGroupWithBlank) {
            const e = s.slidesPerGroup - (n.length % s.slidesPerGroup);
            if (e !== s.slidesPerGroup) {
              for (let i = 0; i < e; i += 1) {
                const e = d(t.createElement("div")).addClass(
                  `${s.slideClass} ${s.slideBlankClass}`,
                );
                a.append(e);
              }
              n = a.children(`.${s.slideClass}`);
            }
          }
          ("auto" !== s.slidesPerView || s.loopedSlides || (s.loopedSlides = n.length),
            (e.loopedSlides = Math.ceil(parseFloat(s.loopedSlides || s.slidesPerView, 10))),
            (e.loopedSlides += s.loopAdditionalSlides),
            e.loopedSlides > n.length && (e.loopedSlides = n.length));
          const r = [],
            l = [];
          n.each((t, s) => {
            const i = d(t);
            (s < e.loopedSlides && l.push(t),
              s < n.length && s >= n.length - e.loopedSlides && r.push(t),
              i.attr("data-swiper-slide-index", s));
          });
          for (let e = 0; e < l.length; e += 1)
            a.append(d(l[e].cloneNode(!0)).addClass(s.slideDuplicateClass));
          for (let e = r.length - 1; e >= 0; e -= 1)
            a.prepend(d(r[e].cloneNode(!0)).addClass(s.slideDuplicateClass));
        },
        loopFix: function () {
          const e = this;
          e.emit("beforeLoopFix");
          const {
            activeIndex: t,
            slides: s,
            loopedSlides: i,
            allowSlidePrev: a,
            allowSlideNext: n,
            snapGrid: r,
            rtlTranslate: l,
          } = e;
          let o;
          ((e.allowSlidePrev = !0), (e.allowSlideNext = !0));
          const d = -r[t] - e.getTranslate();
          if (t < i) {
            ((o = s.length - 3 * i + t), (o += i));
            e.slideTo(o, 0, !1, !0) &&
              0 !== d &&
              e.setTranslate((l ? -e.translate : e.translate) - d);
          } else if (t >= s.length - i) {
            ((o = -s.length + t + i), (o += i));
            e.slideTo(o, 0, !1, !0) &&
              0 !== d &&
              e.setTranslate((l ? -e.translate : e.translate) - d);
          }
          ((e.allowSlidePrev = a), (e.allowSlideNext = n), e.emit("loopFix"));
        },
        loopDestroy: function () {
          const { $wrapperEl: e, params: t, slides: s } = this;
          (e
            .children(
              `.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`,
            )
            .remove(),
            s.removeAttr("data-swiper-slide-index"));
        },
      },
      grabCursor: {
        setGrabCursor: function (e) {
          const t = this;
          if (
            t.support.touch ||
            !t.params.simulateTouch ||
            (t.params.watchOverflow && t.isLocked) ||
            t.params.cssMode
          )
            return;
          const s = "container" === t.params.touchEventsTarget ? t.el : t.wrapperEl;
          ((s.style.cursor = "move"),
            (s.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab"),
            (s.style.cursor = e ? "-moz-grabbin" : "-moz-grab"),
            (s.style.cursor = e ? "grabbing" : "grab"));
        },
        unsetGrabCursor: function () {
          const e = this;
          e.support.touch ||
            (e.params.watchOverflow && e.isLocked) ||
            e.params.cssMode ||
            (e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = "");
        },
      },
      events: {
        attachEvents: function () {
          const e = this,
            t = i(),
            { params: s, support: a } = e;
          ((e.onTouchStart = M.bind(e)),
            (e.onTouchMove = $.bind(e)),
            (e.onTouchEnd = k.bind(e)),
            s.cssMode && (e.onScroll = L.bind(e)),
            (e.onClick = O.bind(e)),
            a.touch && !I && (t.addEventListener("touchstart", z), (I = !0)),
            A(e, "on"));
        },
        detachEvents: function () {
          A(this, "off");
        },
      },
      breakpoints: {
        setBreakpoint: function () {
          const e = this,
            { activeIndex: t, initialized: s, loopedSlides: i = 0, params: a, $el: n } = e,
            r = a.breakpoints;
          if (!r || (r && 0 === Object.keys(r).length)) return;
          const l = e.getBreakpoint(r, e.params.breakpointsBase, e.el);
          if (!l || e.currentBreakpoint === l) return;
          const o = (l in r ? r[l] : void 0) || e.originalParams,
            d = D(e, a),
            p = D(e, o),
            c = a.enabled;
          d && !p
            ? (n.removeClass(
                `${a.containerModifierClass}grid ${a.containerModifierClass}grid-column`,
              ),
              e.emitContainerClasses())
            : !d &&
              p &&
              (n.addClass(`${a.containerModifierClass}grid`),
              ((o.grid.fill && "column" === o.grid.fill) ||
                (!o.grid.fill && "column" === a.grid.fill)) &&
                n.addClass(`${a.containerModifierClass}grid-column`),
              e.emitContainerClasses());
          const u = o.direction && o.direction !== a.direction,
            h = a.loop && (o.slidesPerView !== a.slidesPerView || u);
          (u && s && e.changeDirection(), m(e.params, o));
          const f = e.params.enabled;
          (Object.assign(e, {
            allowTouchMove: e.params.allowTouchMove,
            allowSlideNext: e.params.allowSlideNext,
            allowSlidePrev: e.params.allowSlidePrev,
          }),
            c && !f ? e.disable() : !c && f && e.enable(),
            (e.currentBreakpoint = l),
            e.emit("_beforeBreakpoint", o),
            h &&
              s &&
              (e.loopDestroy(),
              e.loopCreate(),
              e.updateSlides(),
              e.slideTo(t - i + e.loopedSlides, 0, !1)),
            e.emit("breakpoint", o));
        },
        getBreakpoint: function (e, t = "window", s) {
          if (!e || ("container" === t && !s)) return;
          let i = !1;
          const a = n(),
            r = "window" === t ? a.innerHeight : s.clientHeight,
            l = Object.keys(e).map((e) => {
              if ("string" == typeof e && 0 === e.indexOf("@")) {
                const t = parseFloat(e.substr(1));
                return { value: r * t, point: e };
              }
              return { value: e, point: e };
            });
          l.sort((e, t) => parseInt(e.value, 10) - parseInt(t.value, 10));
          for (let e = 0; e < l.length; e += 1) {
            const { point: n, value: r } = l[e];
            "window" === t
              ? a.matchMedia(`(min-width: ${r}px)`).matches && (i = n)
              : r <= s.clientWidth && (i = n);
          }
          return i || "max";
        },
      },
      checkOverflow: {
        checkOverflow: function () {
          const e = this,
            { isLocked: t, params: s } = e,
            { slidesOffsetBefore: i } = s;
          if (i) {
            const t = e.slides.length - 1,
              s = e.slidesGrid[t] + e.slidesSizesGrid[t] + 2 * i;
            e.isLocked = e.size > s;
          } else e.isLocked = 1 === e.snapGrid.length;
          (!0 === s.allowSlideNext && (e.allowSlideNext = !e.isLocked),
            !0 === s.allowSlidePrev && (e.allowSlidePrev = !e.isLocked),
            t && t !== e.isLocked && (e.isEnd = !1),
            t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock"));
        },
      },
      classes: {
        addClasses: function () {
          const e = this,
            { classNames: t, params: s, rtl: i, $el: a, device: n, support: r } = e,
            l = (function (e, t) {
              const s = [];
              return (
                e.forEach((e) => {
                  "object" == typeof e
                    ? Object.keys(e).forEach((i) => {
                        e[i] && s.push(t + i);
                      })
                    : "string" == typeof e && s.push(t + e);
                }),
                s
              );
            })(
              [
                "initialized",
                s.direction,
                { "pointer-events": !r.touch },
                { "free-mode": e.params.freeMode && s.freeMode.enabled },
                { autoheight: s.autoHeight },
                { rtl: i },
                { grid: s.grid && s.grid.rows > 1 },
                { "grid-column": s.grid && s.grid.rows > 1 && "column" === s.grid.fill },
                { android: n.android },
                { ios: n.ios },
                { "css-mode": s.cssMode },
                { centered: s.cssMode && s.centeredSlides },
              ],
              s.containerModifierClass,
            );
          (t.push(...l), a.addClass([...t].join(" ")), e.emitContainerClasses());
        },
        removeClasses: function () {
          const { $el: e, classNames: t } = this;
          (e.removeClass(t.join(" ")), this.emitContainerClasses());
        },
      },
      images: {
        loadImage: function (e, t, s, i, a, r) {
          const l = n();
          let o;
          function p() {
            r && r();
          }
          d(e).parent("picture")[0] || (e.complete && a)
            ? p()
            : t
              ? ((o = new l.Image()),
                (o.onload = p),
                (o.onerror = p),
                i && (o.sizes = i),
                s && (o.srcset = s),
                t && (o.src = t))
              : p();
        },
        preloadImages: function () {
          const e = this;
          function t() {
            null != e &&
              e &&
              !e.destroyed &&
              (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
              e.imagesLoaded === e.imagesToLoad.length &&
                (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")));
          }
          e.imagesToLoad = e.$el.find("img");
          for (let s = 0; s < e.imagesToLoad.length; s += 1) {
            const i = e.imagesToLoad[s];
            e.loadImage(
              i,
              i.currentSrc || i.getAttribute("src"),
              i.srcset || i.getAttribute("srcset"),
              i.sizes || i.getAttribute("sizes"),
              !0,
              t,
            );
          }
        },
      },
    },
    _ = {};
  class H {
    constructor(...e) {
      let t, s;
      if (
        (1 === e.length &&
        e[0].constructor &&
        "Object" === Object.prototype.toString.call(e[0]).slice(8, -1)
          ? (s = e[0])
          : ([t, s] = e),
        s || (s = {}),
        (s = m({}, s)),
        t && !s.el && (s.el = t),
        s.el && d(s.el).length > 1)
      ) {
        const e = [];
        return (
          d(s.el).each((t) => {
            const i = m({}, s, { el: t });
            e.push(new H(i));
          }),
          e
        );
      }
      const i = this;
      ((i.__swiper__ = !0),
        (i.support = T()),
        (i.device = C({ userAgent: s.userAgent })),
        (i.browser = x()),
        (i.eventsListeners = {}),
        (i.eventsAnyListeners = []),
        (i.modules = [...i.__modules__]),
        s.modules && Array.isArray(s.modules) && i.modules.push(...s.modules));
      const a = {};
      i.modules.forEach((e) => {
        e({
          swiper: i,
          extendParams: N(s, a),
          on: i.on.bind(i),
          once: i.once.bind(i),
          off: i.off.bind(i),
          emit: i.emit.bind(i),
        });
      });
      const n = m({}, G, a);
      return (
        (i.params = m({}, n, _, s)),
        (i.originalParams = m({}, i.params)),
        (i.passedParams = m({}, s)),
        i.params &&
          i.params.on &&
          Object.keys(i.params.on).forEach((e) => {
            i.on(e, i.params.on[e]);
          }),
        i.params && i.params.onAny && i.onAny(i.params.onAny),
        (i.$ = d),
        Object.assign(i, {
          enabled: i.params.enabled,
          el: t,
          classNames: [],
          slides: d(),
          slidesGrid: [],
          snapGrid: [],
          slidesSizesGrid: [],
          isHorizontal: () => "horizontal" === i.params.direction,
          isVertical: () => "vertical" === i.params.direction,
          activeIndex: 0,
          realIndex: 0,
          isBeginning: !0,
          isEnd: !1,
          translate: 0,
          previousTranslate: 0,
          progress: 0,
          velocity: 0,
          animating: !1,
          allowSlideNext: i.params.allowSlideNext,
          allowSlidePrev: i.params.allowSlidePrev,
          touchEvents: (function () {
            const e = ["touchstart", "touchmove", "touchend", "touchcancel"],
              t = ["pointerdown", "pointermove", "pointerup"];
            return (
              (i.touchEventsTouch = { start: e[0], move: e[1], end: e[2], cancel: e[3] }),
              (i.touchEventsDesktop = { start: t[0], move: t[1], end: t[2] }),
              i.support.touch || !i.params.simulateTouch ? i.touchEventsTouch : i.touchEventsDesktop
            );
          })(),
          touchEventsData: {
            isTouched: void 0,
            isMoved: void 0,
            allowTouchCallbacks: void 0,
            touchStartTime: void 0,
            isScrolling: void 0,
            currentTranslate: void 0,
            startTranslate: void 0,
            allowThresholdMove: void 0,
            focusableElements: i.params.focusableElements,
            lastClickTime: u(),
            clickTimeout: void 0,
            velocities: [],
            allowMomentumBounce: void 0,
            isTouchEvent: void 0,
            startMoving: void 0,
          },
          allowClick: !0,
          allowTouchMove: i.params.allowTouchMove,
          touches: { startX: 0, startY: 0, currentX: 0, currentY: 0, diff: 0 },
          imagesToLoad: [],
          imagesLoaded: 0,
        }),
        i.emit("_swiper"),
        i.params.init && i.init(),
        i
      );
    }
    enable() {
      const e = this;
      e.enabled || ((e.enabled = !0), e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
    }
    disable() {
      const e = this;
      e.enabled &&
        ((e.enabled = !1), e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
    }
    setProgress(e, t) {
      const s = this;
      e = Math.min(Math.max(e, 0), 1);
      const i = s.minTranslate(),
        a = (s.maxTranslate() - i) * e + i;
      (s.translateTo(a, void 0 === t ? 0 : t), s.updateActiveIndex(), s.updateSlidesClasses());
    }
    emitContainerClasses() {
      const e = this;
      if (!e.params._emitClasses || !e.el) return;
      const t = e.el.className
        .split(" ")
        .filter(
          (t) => 0 === t.indexOf("swiper") || 0 === t.indexOf(e.params.containerModifierClass),
        );
      e.emit("_containerClasses", t.join(" "));
    }
    getSlideClasses(e) {
      const t = this;
      return e.className
        .split(" ")
        .filter((e) => 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(t.params.slideClass))
        .join(" ");
    }
    emitSlidesClasses() {
      const e = this;
      if (!e.params._emitClasses || !e.el) return;
      const t = [];
      (e.slides.each((s) => {
        const i = e.getSlideClasses(s);
        (t.push({ slideEl: s, classNames: i }), e.emit("_slideClass", s, i));
      }),
        e.emit("_slideClasses", t));
    }
    slidesPerViewDynamic(e = "current", t = !1) {
      const {
        params: s,
        slides: i,
        slidesGrid: a,
        slidesSizesGrid: n,
        size: r,
        activeIndex: l,
      } = this;
      let o = 1;
      if (s.centeredSlides) {
        let e,
          t = i[l].swiperSlideSize;
        for (let s = l + 1; s < i.length; s += 1)
          i[s] && !e && ((t += i[s].swiperSlideSize), (o += 1), t > r && (e = !0));
        for (let s = l - 1; s >= 0; s -= 1)
          i[s] && !e && ((t += i[s].swiperSlideSize), (o += 1), t > r && (e = !0));
      } else if ("current" === e)
        for (let e = l + 1; e < i.length; e += 1) {
          (t ? a[e] + n[e] - a[l] < r : a[e] - a[l] < r) && (o += 1);
        }
      else
        for (let e = l - 1; e >= 0; e -= 1) {
          a[l] - a[e] < r && (o += 1);
        }
      return o;
    }
    update() {
      const e = this;
      if (!e || e.destroyed) return;
      const { snapGrid: t, params: s } = e;
      function i() {
        const t = e.rtlTranslate ? -1 * e.translate : e.translate,
          s = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
        (e.setTranslate(s), e.updateActiveIndex(), e.updateSlidesClasses());
      }
      let a;
      (s.breakpoints && e.setBreakpoint(),
        e.updateSize(),
        e.updateSlides(),
        e.updateProgress(),
        e.updateSlidesClasses(),
        e.params.freeMode && e.params.freeMode.enabled
          ? (i(), e.params.autoHeight && e.updateAutoHeight())
          : ((a =
              ("auto" === e.params.slidesPerView || e.params.slidesPerView > 1) &&
              e.isEnd &&
              !e.params.centeredSlides
                ? e.slideTo(e.slides.length - 1, 0, !1, !0)
                : e.slideTo(e.activeIndex, 0, !1, !0)),
            a || i()),
        s.watchOverflow && t !== e.snapGrid && e.checkOverflow(),
        e.emit("update"));
    }
    changeDirection(e, t = !0) {
      const s = this,
        i = s.params.direction;
      return (
        e || (e = "horizontal" === i ? "vertical" : "horizontal"),
        e === i ||
          ("horizontal" !== e && "vertical" !== e) ||
          (s.$el
            .removeClass(`${s.params.containerModifierClass}${i}`)
            .addClass(`${s.params.containerModifierClass}${e}`),
          s.emitContainerClasses(),
          (s.params.direction = e),
          s.slides.each((t) => {
            "vertical" === e ? (t.style.width = "") : (t.style.height = "");
          }),
          s.emit("changeDirection"),
          t && s.update()),
        s
      );
    }
    mount(e) {
      const t = this;
      if (t.mounted) return !0;
      const s = d(e || t.params.el);
      if (!(e = s[0])) return !1;
      e.swiper = t;
      const a = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
      let n = (() => {
        if (e && e.shadowRoot && e.shadowRoot.querySelector) {
          const t = d(e.shadowRoot.querySelector(a()));
          return ((t.children = (e) => s.children(e)), t);
        }
        return s.children(a());
      })();
      if (0 === n.length && t.params.createElements) {
        const e = i().createElement("div");
        ((n = d(e)),
          (e.className = t.params.wrapperClass),
          s.append(e),
          s.children(`.${t.params.slideClass}`).each((e) => {
            n.append(e);
          }));
      }
      return (
        Object.assign(t, {
          $el: s,
          el: e,
          $wrapperEl: n,
          wrapperEl: n[0],
          mounted: !0,
          rtl: "rtl" === e.dir.toLowerCase() || "rtl" === s.css("direction"),
          rtlTranslate:
            "horizontal" === t.params.direction &&
            ("rtl" === e.dir.toLowerCase() || "rtl" === s.css("direction")),
          wrongRTL: "-webkit-box" === n.css("display"),
        }),
        !0
      );
    }
    init(e) {
      const t = this;
      if (t.initialized) return t;
      return (
        !1 === t.mount(e) ||
          (t.emit("beforeInit"),
          t.params.breakpoints && t.setBreakpoint(),
          t.addClasses(),
          t.params.loop && t.loopCreate(),
          t.updateSize(),
          t.updateSlides(),
          t.params.watchOverflow && t.checkOverflow(),
          t.params.grabCursor && t.enabled && t.setGrabCursor(),
          t.params.preloadImages && t.preloadImages(),
          t.params.loop
            ? t.slideTo(
                t.params.initialSlide + t.loopedSlides,
                0,
                t.params.runCallbacksOnInit,
                !1,
                !0,
              )
            : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0),
          t.attachEvents(),
          (t.initialized = !0),
          t.emit("init"),
          t.emit("afterInit")),
        t
      );
    }
    destroy(e = !0, t = !0) {
      const s = this,
        { params: i, $el: a, $wrapperEl: n, slides: r } = s;
      return (
        void 0 === s.params ||
          s.destroyed ||
          (s.emit("beforeDestroy"),
          (s.initialized = !1),
          s.detachEvents(),
          i.loop && s.loopDestroy(),
          t &&
            (s.removeClasses(),
            a.removeAttr("style"),
            n.removeAttr("style"),
            r &&
              r.length &&
              r
                .removeClass(
                  [
                    i.slideVisibleClass,
                    i.slideActiveClass,
                    i.slideNextClass,
                    i.slidePrevClass,
                  ].join(" "),
                )
                .removeAttr("style")
                .removeAttr("data-swiper-slide-index")),
          s.emit("destroy"),
          Object.keys(s.eventsListeners).forEach((e) => {
            s.off(e);
          }),
          !1 !== e &&
            ((s.$el[0].swiper = null),
            (function (e) {
              const t = e;
              Object.keys(t).forEach((e) => {
                try {
                  t[e] = null;
                } catch (e) {}
                try {
                  delete t[e];
                } catch (e) {}
              });
            })(s)),
          (s.destroyed = !0)),
        null
      );
    }
    static extendDefaults(e) {
      m(_, e);
    }
    static get extendedDefaults() {
      return _;
    }
    static get defaults() {
      return G;
    }
    static installModule(e) {
      H.prototype.__modules__ || (H.prototype.__modules__ = []);
      const t = H.prototype.__modules__;
      "function" == typeof e && t.indexOf(e) < 0 && t.push(e);
    }
    static use(e) {
      return Array.isArray(e) ? (e.forEach((e) => H.installModule(e)), H) : (H.installModule(e), H);
    }
  }
  function j(e, t, s, a) {
    const n = i();
    return (
      e.params.createElements &&
        Object.keys(a).forEach((i) => {
          if (!s[i] && !0 === s.auto) {
            let r = e.$el.children(`.${a[i]}`)[0];
            (r || ((r = n.createElement("div")), (r.className = a[i]), e.$el.append(r)),
              (s[i] = r),
              (t[i] = r));
          }
        }),
      s
    );
  }
  function V(e = "") {
    return `.${e
      .trim()
      .replace(/([\.:!\/])/g, "\\$1")
      .replace(/ /g, ".")}`;
  }
  function F(e) {
    const t = this,
      { $wrapperEl: s, params: i } = t;
    if ((i.loop && t.loopDestroy(), "object" == typeof e && "length" in e))
      for (let t = 0; t < e.length; t += 1) e[t] && s.append(e[t]);
    else s.append(e);
    (i.loop && t.loopCreate(), i.observer || t.update());
  }
  function R(e) {
    const t = this,
      { params: s, $wrapperEl: i, activeIndex: a } = t;
    s.loop && t.loopDestroy();
    let n = a + 1;
    if ("object" == typeof e && "length" in e) {
      for (let t = 0; t < e.length; t += 1) e[t] && i.prepend(e[t]);
      n = a + e.length;
    } else i.prepend(e);
    (s.loop && t.loopCreate(), s.observer || t.update(), t.slideTo(n, 0, !1));
  }
  function W(e, t) {
    const s = this,
      { $wrapperEl: i, params: a, activeIndex: n } = s;
    let r = n;
    a.loop && ((r -= s.loopedSlides), s.loopDestroy(), (s.slides = i.children(`.${a.slideClass}`)));
    const l = s.slides.length;
    if (e <= 0) return void s.prependSlide(t);
    if (e >= l) return void s.appendSlide(t);
    let o = r > e ? r + 1 : r;
    const d = [];
    for (let t = l - 1; t >= e; t -= 1) {
      const e = s.slides.eq(t);
      (e.remove(), d.unshift(e));
    }
    if ("object" == typeof t && "length" in t) {
      for (let e = 0; e < t.length; e += 1) t[e] && i.append(t[e]);
      o = r > e ? r + t.length : r;
    } else i.append(t);
    for (let e = 0; e < d.length; e += 1) i.append(d[e]);
    (a.loop && s.loopCreate(),
      a.observer || s.update(),
      a.loop ? s.slideTo(o + s.loopedSlides, 0, !1) : s.slideTo(o, 0, !1));
  }
  function q(e) {
    const t = this,
      { params: s, $wrapperEl: i, activeIndex: a } = t;
    let n = a;
    s.loop && ((n -= t.loopedSlides), t.loopDestroy(), (t.slides = i.children(`.${s.slideClass}`)));
    let r,
      l = n;
    if ("object" == typeof e && "length" in e) {
      for (let s = 0; s < e.length; s += 1)
        ((r = e[s]), t.slides[r] && t.slides.eq(r).remove(), r < l && (l -= 1));
      l = Math.max(l, 0);
    } else
      ((r = e), t.slides[r] && t.slides.eq(r).remove(), r < l && (l -= 1), (l = Math.max(l, 0)));
    (s.loop && t.loopCreate(),
      s.observer || t.update(),
      s.loop ? t.slideTo(l + t.loopedSlides, 0, !1) : t.slideTo(l, 0, !1));
  }
  function X() {
    const e = this,
      t = [];
    for (let s = 0; s < e.slides.length; s += 1) t.push(s);
    e.removeSlide(t);
  }
  function Y(e, t) {
    return e.transformEl
      ? t
          .find(e.transformEl)
          .css({ "backface-visibility": "hidden", "-webkit-backface-visibility": "hidden" })
      : t;
  }
  (Object.keys(B).forEach((e) => {
    Object.keys(B[e]).forEach((t) => {
      H.prototype[t] = B[e][t];
    });
  }),
    H.use([
      function ({ swiper: e, on: t, emit: s }) {
        const i = n();
        let a = null;
        const r = () => {
            e && !e.destroyed && e.initialized && (s("beforeResize"), s("resize"));
          },
          l = () => {
            e && !e.destroyed && e.initialized && s("orientationchange");
          };
        (t("init", () => {
          e.params.resizeObserver && void 0 !== i.ResizeObserver
            ? e &&
              !e.destroyed &&
              e.initialized &&
              ((a = new ResizeObserver((t) => {
                const { width: s, height: i } = e;
                let a = s,
                  n = i;
                (t.forEach(({ contentBoxSize: t, contentRect: s, target: i }) => {
                  (i && i !== e.el) ||
                    ((a = s ? s.width : (t[0] || t).inlineSize),
                    (n = s ? s.height : (t[0] || t).blockSize));
                }),
                  (a === s && n === i) || r());
              })),
              a.observe(e.el))
            : (i.addEventListener("resize", r), i.addEventListener("orientationchange", l));
        }),
          t("destroy", () => {
            (a && a.unobserve && e.el && (a.unobserve(e.el), (a = null)),
              i.removeEventListener("resize", r),
              i.removeEventListener("orientationchange", l));
          }));
      },
      function ({ swiper: e, extendParams: t, on: s, emit: i }) {
        const a = [],
          r = n(),
          l = (e, t = {}) => {
            const s = new (r.MutationObserver || r.WebkitMutationObserver)((e) => {
              if (1 === e.length) return void i("observerUpdate", e[0]);
              const t = function () {
                i("observerUpdate", e[0]);
              };
              r.requestAnimationFrame ? r.requestAnimationFrame(t) : r.setTimeout(t, 0);
            });
            (s.observe(e, {
              attributes: void 0 === t.attributes || t.attributes,
              childList: void 0 === t.childList || t.childList,
              characterData: void 0 === t.characterData || t.characterData,
            }),
              a.push(s));
          };
        (t({ observer: !1, observeParents: !1, observeSlideChildren: !1 }),
          s("init", () => {
            if (e.params.observer) {
              if (e.params.observeParents) {
                const t = e.$el.parents();
                for (let e = 0; e < t.length; e += 1) l(t[e]);
              }
              (l(e.$el[0], { childList: e.params.observeSlideChildren }),
                l(e.$wrapperEl[0], { attributes: !1 }));
            }
          }),
          s("destroy", () => {
            (a.forEach((e) => {
              e.disconnect();
            }),
              a.splice(0, a.length));
          }));
      },
    ]));
  const U = [
    function ({ swiper: e, extendParams: t, on: s }) {
      let i;
      function a(t, s) {
        const i = e.params.virtual;
        if (i.cache && e.virtual.cache[s]) return e.virtual.cache[s];
        const a = i.renderSlide
          ? d(i.renderSlide.call(e, t, s))
          : d(`<div class="${e.params.slideClass}" data-swiper-slide-index="${s}">${t}</div>`);
        return (
          a.attr("data-swiper-slide-index") || a.attr("data-swiper-slide-index", s),
          i.cache && (e.virtual.cache[s] = a),
          a
        );
      }
      function n(t) {
        const { slidesPerView: s, slidesPerGroup: i, centeredSlides: n } = e.params,
          { addSlidesBefore: r, addSlidesAfter: l } = e.params.virtual,
          { from: o, to: d, slides: p, slidesGrid: c, offset: u } = e.virtual;
        e.params.cssMode || e.updateActiveIndex();
        const h = e.activeIndex || 0;
        let f, m, g;
        ((f = e.rtlTranslate ? "right" : e.isHorizontal() ? "left" : "top"),
          n
            ? ((m = Math.floor(s / 2) + i + l), (g = Math.floor(s / 2) + i + r))
            : ((m = s + (i - 1) + l), (g = i + r)));
        const v = Math.max((h || 0) - g, 0),
          b = Math.min((h || 0) + m, p.length - 1),
          w = (e.slidesGrid[v] || 0) - (e.slidesGrid[0] || 0);
        function y() {
          (e.updateSlides(),
            e.updateProgress(),
            e.updateSlidesClasses(),
            e.lazy && e.params.lazy.enabled && e.lazy.load());
        }
        if (
          (Object.assign(e.virtual, { from: v, to: b, offset: w, slidesGrid: e.slidesGrid }),
          o === v && d === b && !t)
        )
          return (
            e.slidesGrid !== c && w !== u && e.slides.css(f, `${w}px`), void e.updateProgress()
          );
        if (e.params.virtual.renderExternal)
          return (
            e.params.virtual.renderExternal.call(e, {
              offset: w,
              from: v,
              to: b,
              slides: (function () {
                const e = [];
                for (let t = v; t <= b; t += 1) e.push(p[t]);
                return e;
              })(),
            }),
            void (e.params.virtual.renderExternalUpdate && y())
          );
        const T = [],
          C = [];
        if (t) e.$wrapperEl.find(`.${e.params.slideClass}`).remove();
        else
          for (let t = o; t <= d; t += 1)
            (t < v || t > b) &&
              e.$wrapperEl.find(`.${e.params.slideClass}[data-swiper-slide-index="${t}"]`).remove();
        for (let e = 0; e < p.length; e += 1)
          e >= v &&
            e <= b &&
            (void 0 === d || t ? C.push(e) : (e > d && C.push(e), e < o && T.push(e)));
        (C.forEach((t) => {
          e.$wrapperEl.append(a(p[t], t));
        }),
          T.sort((e, t) => t - e).forEach((t) => {
            e.$wrapperEl.prepend(a(p[t], t));
          }),
          e.$wrapperEl.children(".swiper-slide").css(f, `${w}px`),
          y());
      }
      (t({
        virtual: {
          enabled: !1,
          slides: [],
          cache: !0,
          renderSlide: null,
          renderExternal: null,
          renderExternalUpdate: !0,
          addSlidesBefore: 0,
          addSlidesAfter: 0,
        },
      }),
        (e.virtual = {
          cache: {},
          from: void 0,
          to: void 0,
          slides: [],
          offset: 0,
          slidesGrid: [],
        }),
        s("beforeInit", () => {
          e.params.virtual.enabled &&
            ((e.virtual.slides = e.params.virtual.slides),
            e.classNames.push(`${e.params.containerModifierClass}virtual`),
            (e.params.watchSlidesProgress = !0),
            (e.originalParams.watchSlidesProgress = !0),
            e.params.initialSlide || n());
        }),
        s("setTranslate", () => {
          e.params.virtual.enabled &&
            (e.params.cssMode && !e._immediateVirtual
              ? (clearTimeout(i),
                (i = setTimeout(() => {
                  n();
                }, 100)))
              : n());
        }),
        s("init update resize", () => {
          e.params.virtual.enabled &&
            e.params.cssMode &&
            g(e.wrapperEl, "--swiper-virtual-size", `${e.virtualSize}px`);
        }),
        Object.assign(e.virtual, {
          appendSlide: function (t) {
            if ("object" == typeof t && "length" in t)
              for (let s = 0; s < t.length; s += 1) t[s] && e.virtual.slides.push(t[s]);
            else e.virtual.slides.push(t);
            n(!0);
          },
          prependSlide: function (t) {
            const s = e.activeIndex;
            let i = s + 1,
              a = 1;
            if (Array.isArray(t)) {
              for (let s = 0; s < t.length; s += 1) t[s] && e.virtual.slides.unshift(t[s]);
              ((i = s + t.length), (a = t.length));
            } else e.virtual.slides.unshift(t);
            if (e.params.virtual.cache) {
              const t = e.virtual.cache,
                s = {};
              (Object.keys(t).forEach((e) => {
                const i = t[e],
                  n = i.attr("data-swiper-slide-index");
                (n && i.attr("data-swiper-slide-index", parseInt(n, 10) + a),
                  (s[parseInt(e, 10) + a] = i));
              }),
                (e.virtual.cache = s));
            }
            (n(!0), e.slideTo(i, 0));
          },
          removeSlide: function (t) {
            if (null == t) return;
            let s = e.activeIndex;
            if (Array.isArray(t))
              for (let i = t.length - 1; i >= 0; i -= 1)
                (e.virtual.slides.splice(t[i], 1),
                  e.params.virtual.cache && delete e.virtual.cache[t[i]],
                  t[i] < s && (s -= 1),
                  (s = Math.max(s, 0)));
            else
              (e.virtual.slides.splice(t, 1),
                e.params.virtual.cache && delete e.virtual.cache[t],
                t < s && (s -= 1),
                (s = Math.max(s, 0)));
            (n(!0), e.slideTo(s, 0));
          },
          removeAllSlides: function () {
            ((e.virtual.slides = []),
              e.params.virtual.cache && (e.virtual.cache = {}),
              n(!0),
              e.slideTo(0, 0));
          },
          update: n,
        }));
    },
    function ({ swiper: e, extendParams: t, on: s, emit: a }) {
      const r = i(),
        l = n();
      function o(t) {
        if (!e.enabled) return;
        const { rtlTranslate: s } = e;
        let i = t;
        i.originalEvent && (i = i.originalEvent);
        const n = i.keyCode || i.charCode,
          o = e.params.keyboard.pageUpDown,
          d = o && 33 === n,
          p = o && 34 === n,
          c = 37 === n,
          u = 39 === n,
          h = 38 === n,
          f = 40 === n;
        if (!e.allowSlideNext && ((e.isHorizontal() && u) || (e.isVertical() && f) || p)) return !1;
        if (!e.allowSlidePrev && ((e.isHorizontal() && c) || (e.isVertical() && h) || d)) return !1;
        if (
          !(
            i.shiftKey ||
            i.altKey ||
            i.ctrlKey ||
            i.metaKey ||
            (r.activeElement &&
              r.activeElement.nodeName &&
              ("input" === r.activeElement.nodeName.toLowerCase() ||
                "textarea" === r.activeElement.nodeName.toLowerCase()))
          )
        ) {
          if (e.params.keyboard.onlyInViewport && (d || p || c || u || h || f)) {
            let t = !1;
            if (
              e.$el.parents(`.${e.params.slideClass}`).length > 0 &&
              0 === e.$el.parents(`.${e.params.slideActiveClass}`).length
            )
              return;
            const i = e.$el,
              a = i[0].clientWidth,
              n = i[0].clientHeight,
              r = l.innerWidth,
              o = l.innerHeight,
              d = e.$el.offset();
            s && (d.left -= e.$el[0].scrollLeft);
            const p = [
              [d.left, d.top],
              [d.left + a, d.top],
              [d.left, d.top + n],
              [d.left + a, d.top + n],
            ];
            for (let e = 0; e < p.length; e += 1) {
              const s = p[e];
              if (s[0] >= 0 && s[0] <= r && s[1] >= 0 && s[1] <= o) {
                if (0 === s[0] && 0 === s[1]) continue;
                t = !0;
              }
            }
            if (!t) return;
          }
          (e.isHorizontal()
            ? ((d || p || c || u) && (i.preventDefault ? i.preventDefault() : (i.returnValue = !1)),
              (((p || u) && !s) || ((d || c) && s)) && e.slideNext(),
              (((d || c) && !s) || ((p || u) && s)) && e.slidePrev())
            : ((d || p || h || f) && (i.preventDefault ? i.preventDefault() : (i.returnValue = !1)),
              (p || f) && e.slideNext(),
              (d || h) && e.slidePrev()),
            a("keyPress", n));
        }
      }
      function p() {
        e.keyboard.enabled || (d(r).on("keydown", o), (e.keyboard.enabled = !0));
      }
      function c() {
        e.keyboard.enabled && (d(r).off("keydown", o), (e.keyboard.enabled = !1));
      }
      ((e.keyboard = { enabled: !1 }),
        t({ keyboard: { enabled: !1, onlyInViewport: !0, pageUpDown: !0 } }),
        s("init", () => {
          e.params.keyboard.enabled && p();
        }),
        s("destroy", () => {
          e.keyboard.enabled && c();
        }),
        Object.assign(e.keyboard, { enable: p, disable: c }));
    },
    function ({ swiper: e, extendParams: t, on: s, emit: i }) {
      const a = n();
      let r;
      (t({
        mousewheel: {
          enabled: !1,
          releaseOnEdges: !1,
          invert: !1,
          forceToAxis: !1,
          sensitivity: 1,
          eventsTarget: "container",
          thresholdDelta: null,
          thresholdTime: null,
        },
      }),
        (e.mousewheel = { enabled: !1 }));
      let l,
        o = u();
      const p = [];
      function h() {
        e.enabled && (e.mouseEntered = !0);
      }
      function f() {
        e.enabled && (e.mouseEntered = !1);
      }
      function m(t) {
        return (
          !(e.params.mousewheel.thresholdDelta && t.delta < e.params.mousewheel.thresholdDelta) &&
          !(e.params.mousewheel.thresholdTime && u() - o < e.params.mousewheel.thresholdTime) &&
          ((t.delta >= 6 && u() - o < 60) ||
            (t.direction < 0
              ? (e.isEnd && !e.params.loop) || e.animating || (e.slideNext(), i("scroll", t.raw))
              : (e.isBeginning && !e.params.loop) ||
                e.animating ||
                (e.slidePrev(), i("scroll", t.raw)),
            (o = new a.Date().getTime()),
            !1))
        );
      }
      function g(t) {
        let s = t,
          a = !0;
        if (!e.enabled) return;
        const n = e.params.mousewheel;
        e.params.cssMode && s.preventDefault();
        let o = e.$el;
        if (
          ("container" !== e.params.mousewheel.eventsTarget &&
            (o = d(e.params.mousewheel.eventsTarget)),
          !e.mouseEntered && !o[0].contains(s.target) && !n.releaseOnEdges)
        )
          return !0;
        s.originalEvent && (s = s.originalEvent);
        let h = 0;
        const f = e.rtlTranslate ? -1 : 1,
          g = (function (e) {
            let t = 0,
              s = 0,
              i = 0,
              a = 0;
            return (
              "detail" in e && (s = e.detail),
              "wheelDelta" in e && (s = -e.wheelDelta / 120),
              "wheelDeltaY" in e && (s = -e.wheelDeltaY / 120),
              "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120),
              "axis" in e && e.axis === e.HORIZONTAL_AXIS && ((t = s), (s = 0)),
              (i = 10 * t),
              (a = 10 * s),
              "deltaY" in e && (a = e.deltaY),
              "deltaX" in e && (i = e.deltaX),
              e.shiftKey && !i && ((i = a), (a = 0)),
              (i || a) &&
                e.deltaMode &&
                (1 === e.deltaMode ? ((i *= 40), (a *= 40)) : ((i *= 800), (a *= 800))),
              i && !t && (t = i < 1 ? -1 : 1),
              a && !s && (s = a < 1 ? -1 : 1),
              { spinX: t, spinY: s, pixelX: i, pixelY: a }
            );
          })(s);
        if (n.forceToAxis)
          if (e.isHorizontal()) {
            if (!(Math.abs(g.pixelX) > Math.abs(g.pixelY))) return !0;
            h = -g.pixelX * f;
          } else {
            if (!(Math.abs(g.pixelY) > Math.abs(g.pixelX))) return !0;
            h = -g.pixelY;
          }
        else h = Math.abs(g.pixelX) > Math.abs(g.pixelY) ? -g.pixelX * f : -g.pixelY;
        if (0 === h) return !0;
        n.invert && (h = -h);
        let v = e.getTranslate() + h * n.sensitivity;
        if (
          (v >= e.minTranslate() && (v = e.minTranslate()),
          v <= e.maxTranslate() && (v = e.maxTranslate()),
          (a = !!e.params.loop || !(v === e.minTranslate() || v === e.maxTranslate())),
          a && e.params.nested && s.stopPropagation(),
          e.params.freeMode && e.params.freeMode.enabled)
        ) {
          const t = { time: u(), delta: Math.abs(h), direction: Math.sign(h) },
            a = l && t.time < l.time + 500 && t.delta <= l.delta && t.direction === l.direction;
          if (!a) {
            ((l = void 0), e.params.loop && e.loopFix());
            let o = e.getTranslate() + h * n.sensitivity;
            const d = e.isBeginning,
              u = e.isEnd;
            if (
              (o >= e.minTranslate() && (o = e.minTranslate()),
              o <= e.maxTranslate() && (o = e.maxTranslate()),
              e.setTransition(0),
              e.setTranslate(o),
              e.updateProgress(),
              e.updateActiveIndex(),
              e.updateSlidesClasses(),
              ((!d && e.isBeginning) || (!u && e.isEnd)) && e.updateSlidesClasses(),
              e.params.freeMode.sticky)
            ) {
              (clearTimeout(r), (r = void 0), p.length >= 15 && p.shift());
              const s = p.length ? p[p.length - 1] : void 0,
                i = p[0];
              if ((p.push(t), s && (t.delta > s.delta || t.direction !== s.direction))) p.splice(0);
              else if (
                p.length >= 15 &&
                t.time - i.time < 500 &&
                i.delta - t.delta >= 1 &&
                t.delta <= 6
              ) {
                const s = h > 0 ? 0.8 : 0.2;
                ((l = t),
                  p.splice(0),
                  (r = c(() => {
                    e.slideToClosest(e.params.speed, !0, void 0, s);
                  }, 0)));
              }
              r ||
                (r = c(() => {
                  ((l = t), p.splice(0), e.slideToClosest(e.params.speed, !0, void 0, 0.5));
                }, 500));
            }
            if (
              (a || i("scroll", s),
              e.params.autoplay && e.params.autoplayDisableOnInteraction && e.autoplay.stop(),
              o === e.minTranslate() || o === e.maxTranslate())
            )
              return !0;
          }
        } else {
          const s = { time: u(), delta: Math.abs(h), direction: Math.sign(h), raw: t };
          p.length >= 2 && p.shift();
          const i = p.length ? p[p.length - 1] : void 0;
          if (
            (p.push(s),
            i
              ? (s.direction !== i.direction || s.delta > i.delta || s.time > i.time + 150) && m(s)
              : m(s),
            (function (t) {
              const s = e.params.mousewheel;
              if (t.direction < 0) {
                if (e.isEnd && !e.params.loop && s.releaseOnEdges) return !0;
              } else if (e.isBeginning && !e.params.loop && s.releaseOnEdges) return !0;
              return !1;
            })(s))
          )
            return !0;
        }
        return (s.preventDefault ? s.preventDefault() : (s.returnValue = !1), !1);
      }
      function v(t) {
        let s = e.$el;
        ("container" !== e.params.mousewheel.eventsTarget &&
          (s = d(e.params.mousewheel.eventsTarget)),
          s[t]("mouseenter", h),
          s[t]("mouseleave", f),
          s[t]("wheel", g));
      }
      function b() {
        return e.params.cssMode
          ? (e.wrapperEl.removeEventListener("wheel", g), !0)
          : !e.mousewheel.enabled && (v("on"), (e.mousewheel.enabled = !0), !0);
      }
      function w() {
        return e.params.cssMode
          ? (e.wrapperEl.addEventListener(event, g), !0)
          : !!e.mousewheel.enabled && (v("off"), (e.mousewheel.enabled = !1), !0);
      }
      (s("init", () => {
        (!e.params.mousewheel.enabled && e.params.cssMode && w(),
          e.params.mousewheel.enabled && b());
      }),
        s("destroy", () => {
          (e.params.cssMode && b(), e.mousewheel.enabled && w());
        }),
        Object.assign(e.mousewheel, { enable: b, disable: w }));
    },
    function ({ swiper: e, extendParams: t, on: s, emit: i }) {
      function a(t) {
        let s;
        return (
          t &&
            ((s = d(t)),
            e.params.uniqueNavElements &&
              "string" == typeof t &&
              s.length > 1 &&
              1 === e.$el.find(t).length &&
              (s = e.$el.find(t))),
          s
        );
      }
      function n(t, s) {
        const i = e.params.navigation;
        t &&
          t.length > 0 &&
          (t[s ? "addClass" : "removeClass"](i.disabledClass),
          t[0] && "BUTTON" === t[0].tagName && (t[0].disabled = s),
          e.params.watchOverflow &&
            e.enabled &&
            t[e.isLocked ? "addClass" : "removeClass"](i.lockClass));
      }
      function r() {
        if (e.params.loop) return;
        const { $nextEl: t, $prevEl: s } = e.navigation;
        (n(s, e.isBeginning), n(t, e.isEnd));
      }
      function l(t) {
        (t.preventDefault(), (e.isBeginning && !e.params.loop) || e.slidePrev());
      }
      function o(t) {
        (t.preventDefault(), (e.isEnd && !e.params.loop) || e.slideNext());
      }
      function p() {
        const t = e.params.navigation;
        if (
          ((e.params.navigation = j(e, e.originalParams.navigation, e.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev",
          })),
          !t.nextEl && !t.prevEl)
        )
          return;
        const s = a(t.nextEl),
          i = a(t.prevEl);
        (s && s.length > 0 && s.on("click", o),
          i && i.length > 0 && i.on("click", l),
          Object.assign(e.navigation, {
            $nextEl: s,
            nextEl: s && s[0],
            $prevEl: i,
            prevEl: i && i[0],
          }),
          e.enabled || (s && s.addClass(t.lockClass), i && i.addClass(t.lockClass)));
      }
      function c() {
        const { $nextEl: t, $prevEl: s } = e.navigation;
        (t && t.length && (t.off("click", o), t.removeClass(e.params.navigation.disabledClass)),
          s && s.length && (s.off("click", l), s.removeClass(e.params.navigation.disabledClass)));
      }
      (t({
        navigation: {
          nextEl: null,
          prevEl: null,
          hideOnClick: !1,
          disabledClass: "swiper-button-disabled",
          hiddenClass: "swiper-button-hidden",
          lockClass: "swiper-button-lock",
        },
      }),
        (e.navigation = { nextEl: null, $nextEl: null, prevEl: null, $prevEl: null }),
        s("init", () => {
          (p(), r());
        }),
        s("toEdge fromEdge lock unlock", () => {
          r();
        }),
        s("destroy", () => {
          c();
        }),
        s("enable disable", () => {
          const { $nextEl: t, $prevEl: s } = e.navigation;
          (t && t[e.enabled ? "removeClass" : "addClass"](e.params.navigation.lockClass),
            s && s[e.enabled ? "removeClass" : "addClass"](e.params.navigation.lockClass));
        }),
        s("click", (t, s) => {
          const { $nextEl: a, $prevEl: n } = e.navigation,
            r = s.target;
          if (e.params.navigation.hideOnClick && !d(r).is(n) && !d(r).is(a)) {
            if (
              e.pagination &&
              e.params.pagination &&
              e.params.pagination.clickable &&
              (e.pagination.el === r || e.pagination.el.contains(r))
            )
              return;
            let t;
            (a
              ? (t = a.hasClass(e.params.navigation.hiddenClass))
              : n && (t = n.hasClass(e.params.navigation.hiddenClass)),
              i(!0 === t ? "navigationShow" : "navigationHide"),
              a && a.toggleClass(e.params.navigation.hiddenClass),
              n && n.toggleClass(e.params.navigation.hiddenClass));
          }
        }),
        Object.assign(e.navigation, { update: r, init: p, destroy: c }));
    },
    function ({ swiper: e, extendParams: t, on: s, emit: i }) {
      const a = "swiper-pagination";
      let n;
      (t({
        pagination: {
          el: null,
          bulletElement: "span",
          clickable: !1,
          hideOnClick: !1,
          renderBullet: null,
          renderProgressbar: null,
          renderFraction: null,
          renderCustom: null,
          progressbarOpposite: !1,
          type: "bullets",
          dynamicBullets: !1,
          dynamicMainBullets: 1,
          formatFractionCurrent: (e) => e,
          formatFractionTotal: (e) => e,
          bulletClass: `${a}-bullet`,
          bulletActiveClass: `${a}-bullet-active`,
          modifierClass: `${a}-`,
          currentClass: `${a}-current`,
          totalClass: `${a}-total`,
          hiddenClass: `${a}-hidden`,
          progressbarFillClass: `${a}-progressbar-fill`,
          progressbarOppositeClass: `${a}-progressbar-opposite`,
          clickableClass: `${a}-clickable`,
          lockClass: `${a}-lock`,
          horizontalClass: `${a}-horizontal`,
          verticalClass: `${a}-vertical`,
        },
      }),
        (e.pagination = { el: null, $el: null, bullets: [] }));
      let r = 0;
      function l() {
        return (
          !e.params.pagination.el ||
          !e.pagination.el ||
          !e.pagination.$el ||
          0 === e.pagination.$el.length
        );
      }
      function o(t, s) {
        const { bulletActiveClass: i } = e.params.pagination;
        t[s]().addClass(`${i}-${s}`)[s]().addClass(`${i}-${s}-${s}`);
      }
      function p() {
        const t = e.rtl,
          s = e.params.pagination;
        if (l()) return;
        const a = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
          p = e.pagination.$el;
        let c;
        const u = e.params.loop
          ? Math.ceil((a - 2 * e.loopedSlides) / e.params.slidesPerGroup)
          : e.snapGrid.length;
        if (
          (e.params.loop
            ? ((c = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)),
              c > a - 1 - 2 * e.loopedSlides && (c -= a - 2 * e.loopedSlides),
              c > u - 1 && (c -= u),
              c < 0 && "bullets" !== e.params.paginationType && (c = u + c))
            : (c = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0),
          "bullets" === s.type && e.pagination.bullets && e.pagination.bullets.length > 0)
        ) {
          const i = e.pagination.bullets;
          let a, l, u;
          if (
            (s.dynamicBullets &&
              ((n = i.eq(0)[e.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
              p.css(e.isHorizontal() ? "width" : "height", n * (s.dynamicMainBullets + 4) + "px"),
              s.dynamicMainBullets > 1 &&
                void 0 !== e.previousIndex &&
                ((r += c - e.previousIndex),
                r > s.dynamicMainBullets - 1 ? (r = s.dynamicMainBullets - 1) : r < 0 && (r = 0)),
              (a = c - r),
              (l = a + (Math.min(i.length, s.dynamicMainBullets) - 1)),
              (u = (l + a) / 2)),
            i.removeClass(
              ["", "-next", "-next-next", "-prev", "-prev-prev", "-main"]
                .map((e) => `${s.bulletActiveClass}${e}`)
                .join(" "),
            ),
            p.length > 1)
          )
            i.each((e) => {
              const t = d(e),
                i = t.index();
              (i === c && t.addClass(s.bulletActiveClass),
                s.dynamicBullets &&
                  (i >= a && i <= l && t.addClass(`${s.bulletActiveClass}-main`),
                  i === a && o(t, "prev"),
                  i === l && o(t, "next")));
            });
          else {
            const t = i.eq(c),
              n = t.index();
            if ((t.addClass(s.bulletActiveClass), s.dynamicBullets)) {
              const t = i.eq(a),
                r = i.eq(l);
              for (let e = a; e <= l; e += 1) i.eq(e).addClass(`${s.bulletActiveClass}-main`);
              if (e.params.loop)
                if (n >= i.length - s.dynamicMainBullets) {
                  for (let e = s.dynamicMainBullets; e >= 0; e -= 1)
                    i.eq(i.length - e).addClass(`${s.bulletActiveClass}-main`);
                  i.eq(i.length - s.dynamicMainBullets - 1).addClass(`${s.bulletActiveClass}-prev`);
                } else (o(t, "prev"), o(r, "next"));
              else (o(t, "prev"), o(r, "next"));
            }
          }
          if (s.dynamicBullets) {
            const a = Math.min(i.length, s.dynamicMainBullets + 4),
              r = (n * a - n) / 2 - u * n,
              l = t ? "right" : "left";
            i.css(e.isHorizontal() ? l : "top", `${r}px`);
          }
        }
        if (
          ("fraction" === s.type &&
            (p.find(V(s.currentClass)).text(s.formatFractionCurrent(c + 1)),
            p.find(V(s.totalClass)).text(s.formatFractionTotal(u))),
          "progressbar" === s.type)
        ) {
          let t;
          t = s.progressbarOpposite
            ? e.isHorizontal()
              ? "vertical"
              : "horizontal"
            : e.isHorizontal()
              ? "horizontal"
              : "vertical";
          const i = (c + 1) / u;
          let a = 1,
            n = 1;
          ("horizontal" === t ? (a = i) : (n = i),
            p
              .find(V(s.progressbarFillClass))
              .transform(`translate3d(0,0,0) scaleX(${a}) scaleY(${n})`)
              .transition(e.params.speed));
        }
        ("custom" === s.type && s.renderCustom
          ? (p.html(s.renderCustom(e, c + 1, u)), i("paginationRender", p[0]))
          : i("paginationUpdate", p[0]),
          e.params.watchOverflow &&
            e.enabled &&
            p[e.isLocked ? "addClass" : "removeClass"](s.lockClass));
      }
      function c() {
        const t = e.params.pagination;
        if (l()) return;
        const s = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
          a = e.pagination.$el;
        let n = "";
        if ("bullets" === t.type) {
          let i = e.params.loop
            ? Math.ceil((s - 2 * e.loopedSlides) / e.params.slidesPerGroup)
            : e.snapGrid.length;
          e.params.freeMode && e.params.freeMode.enabled && !e.params.loop && i > s && (i = s);
          for (let s = 0; s < i; s += 1)
            t.renderBullet
              ? (n += t.renderBullet.call(e, s, t.bulletClass))
              : (n += `<${t.bulletElement} class="${t.bulletClass}"></${t.bulletElement}>`);
          (a.html(n), (e.pagination.bullets = a.find(V(t.bulletClass))));
        }
        ("fraction" === t.type &&
          ((n = t.renderFraction
            ? t.renderFraction.call(e, t.currentClass, t.totalClass)
            : `<span class="${t.currentClass}"></span> / <span class="${t.totalClass}"></span>`),
          a.html(n)),
          "progressbar" === t.type &&
            ((n = t.renderProgressbar
              ? t.renderProgressbar.call(e, t.progressbarFillClass)
              : `<span class="${t.progressbarFillClass}"></span>`),
            a.html(n)),
          "custom" !== t.type && i("paginationRender", e.pagination.$el[0]));
      }
      function u() {
        e.params.pagination = j(e, e.originalParams.pagination, e.params.pagination, {
          el: "swiper-pagination",
        });
        const t = e.params.pagination;
        if (!t.el) return;
        let s = d(t.el);
        0 !== s.length &&
          (e.params.uniqueNavElements &&
            "string" == typeof t.el &&
            s.length > 1 &&
            ((s = e.$el.find(t.el)),
            s.length > 1 && (s = s.filter((t) => d(t).parents(".swiper")[0] === e.el))),
          "bullets" === t.type && t.clickable && s.addClass(t.clickableClass),
          s.addClass(t.modifierClass + t.type),
          s.addClass(t.modifierClass + e.params.direction),
          "bullets" === t.type &&
            t.dynamicBullets &&
            (s.addClass(`${t.modifierClass}${t.type}-dynamic`),
            (r = 0),
            t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)),
          "progressbar" === t.type &&
            t.progressbarOpposite &&
            s.addClass(t.progressbarOppositeClass),
          t.clickable &&
            s.on("click", V(t.bulletClass), function (t) {
              t.preventDefault();
              let s = d(this).index() * e.params.slidesPerGroup;
              (e.params.loop && (s += e.loopedSlides), e.slideTo(s));
            }),
          Object.assign(e.pagination, { $el: s, el: s[0] }),
          e.enabled || s.addClass(t.lockClass));
      }
      function h() {
        const t = e.params.pagination;
        if (l()) return;
        const s = e.pagination.$el;
        (s.removeClass(t.hiddenClass),
          s.removeClass(t.modifierClass + t.type),
          s.removeClass(t.modifierClass + e.params.direction),
          e.pagination.bullets &&
            e.pagination.bullets.removeClass &&
            e.pagination.bullets.removeClass(t.bulletActiveClass),
          t.clickable && s.off("click", V(t.bulletClass)));
      }
      (s("init", () => {
        (u(), c(), p());
      }),
        s("activeIndexChange", () => {
          (e.params.loop || void 0 === e.snapIndex) && p();
        }),
        s("snapIndexChange", () => {
          e.params.loop || p();
        }),
        s("slidesLengthChange", () => {
          e.params.loop && (c(), p());
        }),
        s("snapGridLengthChange", () => {
          e.params.loop || (c(), p());
        }),
        s("destroy", () => {
          h();
        }),
        s("enable disable", () => {
          const { $el: t } = e.pagination;
          t && t[e.enabled ? "removeClass" : "addClass"](e.params.pagination.lockClass);
        }),
        s("lock unlock", () => {
          p();
        }),
        s("click", (t, s) => {
          const a = s.target,
            { $el: n } = e.pagination;
          if (
            e.params.pagination.el &&
            e.params.pagination.hideOnClick &&
            n.length > 0 &&
            !d(a).hasClass(e.params.pagination.bulletClass)
          ) {
            if (
              e.navigation &&
              ((e.navigation.nextEl && a === e.navigation.nextEl) ||
                (e.navigation.prevEl && a === e.navigation.prevEl))
            )
              return;
            const t = n.hasClass(e.params.pagination.hiddenClass);
            (i(!0 === t ? "paginationShow" : "paginationHide"),
              n.toggleClass(e.params.pagination.hiddenClass));
          }
        }),
        Object.assign(e.pagination, { render: c, update: p, init: u, destroy: h }));
    },
    function ({ swiper: e, extendParams: t, on: s, emit: i }) {
      (t({
        lazy: {
          checkInView: !1,
          enabled: !1,
          loadPrevNext: !1,
          loadPrevNextAmount: 1,
          loadOnTransitionStart: !1,
          scrollingElement: "",
          elementClass: "swiper-lazy",
          loadingClass: "swiper-lazy-loading",
          loadedClass: "swiper-lazy-loaded",
          preloaderClass: "swiper-lazy-preloader",
        },
      }),
        (e.lazy = {}));
      let a = !1,
        r = !1;
      function l(t, s = !0) {
        const a = e.params.lazy;
        if (void 0 === t) return;
        if (0 === e.slides.length) return;
        const n =
            e.virtual && e.params.virtual.enabled
              ? e.$wrapperEl.children(`.${e.params.slideClass}[data-swiper-slide-index="${t}"]`)
              : e.slides.eq(t),
          r = n.find(`.${a.elementClass}:not(.${a.loadedClass}):not(.${a.loadingClass})`);
        (!n.hasClass(a.elementClass) ||
          n.hasClass(a.loadedClass) ||
          n.hasClass(a.loadingClass) ||
          r.push(n[0]),
          0 !== r.length &&
            r.each((t) => {
              const r = d(t);
              r.addClass(a.loadingClass);
              const o = r.attr("data-background"),
                p = r.attr("data-src"),
                c = r.attr("data-srcset"),
                u = r.attr("data-sizes"),
                h = r.parent("picture");
              (e.loadImage(r[0], p || o, c, u, !1, () => {
                if (null != e && e && (!e || e.params) && !e.destroyed) {
                  if (
                    (o
                      ? (r.css("background-image", `url("${o}")`), r.removeAttr("data-background"))
                      : (c && (r.attr("srcset", c), r.removeAttr("data-srcset")),
                        u && (r.attr("sizes", u), r.removeAttr("data-sizes")),
                        h.length &&
                          h.children("source").each((e) => {
                            const t = d(e);
                            t.attr("data-srcset") &&
                              (t.attr("srcset", t.attr("data-srcset")),
                              t.removeAttr("data-srcset"));
                          }),
                        p && (r.attr("src", p), r.removeAttr("data-src"))),
                    r.addClass(a.loadedClass).removeClass(a.loadingClass),
                    n.find(`.${a.preloaderClass}`).remove(),
                    e.params.loop && s)
                  ) {
                    const t = n.attr("data-swiper-slide-index");
                    if (n.hasClass(e.params.slideDuplicateClass)) {
                      l(
                        e.$wrapperEl
                          .children(
                            `[data-swiper-slide-index="${t}"]:not(.${e.params.slideDuplicateClass})`,
                          )
                          .index(),
                        !1,
                      );
                    } else {
                      l(
                        e.$wrapperEl
                          .children(
                            `.${e.params.slideDuplicateClass}[data-swiper-slide-index="${t}"]`,
                          )
                          .index(),
                        !1,
                      );
                    }
                  }
                  (i("lazyImageReady", n[0], r[0]), e.params.autoHeight && e.updateAutoHeight());
                }
              }),
                i("lazyImageLoad", n[0], r[0]));
            }));
      }
      function o() {
        const { $wrapperEl: t, params: s, slides: i, activeIndex: a } = e,
          n = e.virtual && s.virtual.enabled,
          o = s.lazy;
        let p = s.slidesPerView;
        function c(e) {
          if (n) {
            if (t.children(`.${s.slideClass}[data-swiper-slide-index="${e}"]`).length) return !0;
          } else if (i[e]) return !0;
          return !1;
        }
        function u(e) {
          return n ? d(e).attr("data-swiper-slide-index") : d(e).index();
        }
        if (("auto" === p && (p = 0), r || (r = !0), e.params.watchSlidesProgress))
          t.children(`.${s.slideVisibleClass}`).each((e) => {
            l(n ? d(e).attr("data-swiper-slide-index") : d(e).index());
          });
        else if (p > 1) for (let e = a; e < a + p; e += 1) c(e) && l(e);
        else l(a);
        if (o.loadPrevNext)
          if (p > 1 || (o.loadPrevNextAmount && o.loadPrevNextAmount > 1)) {
            const e = o.loadPrevNextAmount,
              t = p,
              s = Math.min(a + t + Math.max(e, t), i.length),
              n = Math.max(a - Math.max(t, e), 0);
            for (let e = a + p; e < s; e += 1) c(e) && l(e);
            for (let e = n; e < a; e += 1) c(e) && l(e);
          } else {
            const e = t.children(`.${s.slideNextClass}`);
            e.length > 0 && l(u(e));
            const i = t.children(`.${s.slidePrevClass}`);
            i.length > 0 && l(u(i));
          }
      }
      function p() {
        const t = n();
        if (!e || e.destroyed) return;
        const s = e.params.lazy.scrollingElement ? d(e.params.lazy.scrollingElement) : d(t),
          i = s[0] === t,
          r = i ? t.innerWidth : s[0].offsetWidth,
          l = i ? t.innerHeight : s[0].offsetHeight,
          c = e.$el.offset(),
          { rtlTranslate: u } = e;
        let h = !1;
        u && (c.left -= e.$el[0].scrollLeft);
        const f = [
          [c.left, c.top],
          [c.left + e.width, c.top],
          [c.left, c.top + e.height],
          [c.left + e.width, c.top + e.height],
        ];
        for (let e = 0; e < f.length; e += 1) {
          const t = f[e];
          if (t[0] >= 0 && t[0] <= r && t[1] >= 0 && t[1] <= l) {
            if (0 === t[0] && 0 === t[1]) continue;
            h = !0;
          }
        }
        const m = !(
          "touchstart" !== e.touchEvents.start ||
          !e.support.passiveListener ||
          !e.params.passiveListeners
        ) && { passive: !0, capture: !1 };
        h ? (o(), s.off("scroll", p, m)) : a || ((a = !0), s.on("scroll", p, m));
      }
      (s("beforeInit", () => {
        e.params.lazy.enabled && e.params.preloadImages && (e.params.preloadImages = !1);
      }),
        s("init", () => {
          e.params.lazy.enabled && (e.params.lazy.checkInView ? p() : o());
        }),
        s("scroll", () => {
          e.params.freeMode && e.params.freeMode.enabled && !e.params.freeMode.sticky && o();
        }),
        s("scrollbarDragMove resize _freeModeNoMomentumRelease", () => {
          e.params.lazy.enabled && (e.params.lazy.checkInView ? p() : o());
        }),
        s("transitionStart", () => {
          e.params.lazy.enabled &&
            (e.params.lazy.loadOnTransitionStart || (!e.params.lazy.loadOnTransitionStart && !r)) &&
            (e.params.lazy.checkInView ? p() : o());
        }),
        s("transitionEnd", () => {
          e.params.lazy.enabled &&
            !e.params.lazy.loadOnTransitionStart &&
            (e.params.lazy.checkInView ? p() : o());
        }),
        s("slideChange", () => {
          const {
            lazy: t,
            cssMode: s,
            watchSlidesProgress: i,
            touchReleaseOnEdges: a,
            resistanceRatio: n,
          } = e.params;
          t.enabled && (s || (i && (a || 0 === n))) && o();
        }),
        Object.assign(e.lazy, { load: o, loadInSlide: l }));
    },
    function ({ swiper: e, extendParams: t, on: s }) {
      function i(e, t) {
        const s = (function () {
          let e, t, s;
          return (i, a) => {
            for (t = -1, e = i.length; e - t > 1; )
              ((s = (e + t) >> 1), i[s] <= a ? (t = s) : (e = s));
            return e;
          };
        })();
        let i, a;
        return (
          (this.x = e),
          (this.y = t),
          (this.lastIndex = e.length - 1),
          (this.interpolate = function (e) {
            return e
              ? ((a = s(this.x, e)),
                (i = a - 1),
                ((e - this.x[i]) * (this.y[a] - this.y[i])) / (this.x[a] - this.x[i]) + this.y[i])
              : 0;
          }),
          this
        );
      }
      function a() {
        e.controller.control &&
          e.controller.spline &&
          ((e.controller.spline = void 0), delete e.controller.spline);
      }
      (t({ controller: { control: void 0, inverse: !1, by: "slide" } }),
        (e.controller = { control: void 0 }),
        s("beforeInit", () => {
          e.controller.control = e.params.controller.control;
        }),
        s("update", () => {
          a();
        }),
        s("resize", () => {
          a();
        }),
        s("observerUpdate", () => {
          a();
        }),
        s("setTranslate", (t, s, i) => {
          e.controller.control && e.controller.setTranslate(s, i);
        }),
        s("setTransition", (t, s, i) => {
          e.controller.control && e.controller.setTransition(s, i);
        }),
        Object.assign(e.controller, {
          setTranslate: function (t, s) {
            const a = e.controller.control;
            let n, r;
            const l = e.constructor;
            function o(t) {
              const s = e.rtlTranslate ? -e.translate : e.translate;
              ("slide" === e.params.controller.by &&
                (!(function (t) {
                  e.controller.spline ||
                    (e.controller.spline = e.params.loop
                      ? new i(e.slidesGrid, t.slidesGrid)
                      : new i(e.snapGrid, t.snapGrid));
                })(t),
                (r = -e.controller.spline.interpolate(-s))),
                (r && "container" !== e.params.controller.by) ||
                  ((n =
                    (t.maxTranslate() - t.minTranslate()) / (e.maxTranslate() - e.minTranslate())),
                  (r = (s - e.minTranslate()) * n + t.minTranslate())),
                e.params.controller.inverse && (r = t.maxTranslate() - r),
                t.updateProgress(r),
                t.setTranslate(r, e),
                t.updateActiveIndex(),
                t.updateSlidesClasses());
            }
            if (Array.isArray(a))
              for (let e = 0; e < a.length; e += 1) a[e] !== s && a[e] instanceof l && o(a[e]);
            else a instanceof l && s !== a && o(a);
          },
          setTransition: function (t, s) {
            const i = e.constructor,
              a = e.controller.control;
            let n;
            function r(s) {
              (s.setTransition(t, e),
                0 !== t &&
                  (s.transitionStart(),
                  s.params.autoHeight &&
                    c(() => {
                      s.updateAutoHeight();
                    }),
                  s.$wrapperEl.transitionEnd(() => {
                    a &&
                      (s.params.loop && "slide" === e.params.controller.by && s.loopFix(),
                      s.transitionEnd());
                  })));
            }
            if (Array.isArray(a))
              for (n = 0; n < a.length; n += 1) a[n] !== s && a[n] instanceof i && r(a[n]);
            else a instanceof i && s !== a && r(a);
          },
        }));
    },
    function ({ swiper: e, extendParams: t, on: s }) {
      t({
        a11y: {
          enabled: !0,
          notificationClass: "swiper-notification",
          prevSlideMessage: "Previous slide",
          nextSlideMessage: "Next slide",
          firstSlideMessage: "This is the first slide",
          lastSlideMessage: "This is the last slide",
          paginationBulletMessage: "Go to slide {{index}}",
          slideLabelMessage: "{{index}} / {{slidesLength}}",
          containerMessage: null,
          containerRoleDescriptionMessage: null,
          itemRoleDescriptionMessage: null,
          slideRole: "group",
        },
      });
      let i = null;
      function a(e) {
        const t = i;
        0 !== t.length && (t.html(""), t.html(e));
      }
      function n(e) {
        e.attr("tabIndex", "0");
      }
      function r(e) {
        e.attr("tabIndex", "-1");
      }
      function l(e, t) {
        e.attr("role", t);
      }
      function o(e, t) {
        e.attr("aria-roledescription", t);
      }
      function p(e, t) {
        e.attr("aria-label", t);
      }
      function c(e) {
        e.attr("aria-disabled", !0);
      }
      function u(e) {
        e.attr("aria-disabled", !1);
      }
      function h(t) {
        if (13 !== t.keyCode && 32 !== t.keyCode) return;
        const s = e.params.a11y,
          i = d(t.target);
        (e.navigation &&
          e.navigation.$nextEl &&
          i.is(e.navigation.$nextEl) &&
          ((e.isEnd && !e.params.loop) || e.slideNext(),
          e.isEnd ? a(s.lastSlideMessage) : a(s.nextSlideMessage)),
          e.navigation &&
            e.navigation.$prevEl &&
            i.is(e.navigation.$prevEl) &&
            ((e.isBeginning && !e.params.loop) || e.slidePrev(),
            e.isBeginning ? a(s.firstSlideMessage) : a(s.prevSlideMessage)),
          e.pagination && i.is(V(e.params.pagination.bulletClass)) && i[0].click());
      }
      function f() {
        if (e.params.loop || !e.navigation) return;
        const { $nextEl: t, $prevEl: s } = e.navigation;
        (s && s.length > 0 && (e.isBeginning ? (c(s), r(s)) : (u(s), n(s))),
          t && t.length > 0 && (e.isEnd ? (c(t), r(t)) : (u(t), n(t))));
      }
      function m() {
        return (
          e.pagination &&
          e.params.pagination.clickable &&
          e.pagination.bullets &&
          e.pagination.bullets.length
        );
      }
      const g = (e, t, s) => {
        (n(e),
          "BUTTON" !== e[0].tagName && (l(e, "button"), e.on("keydown", h)),
          p(e, s),
          (function (e, t) {
            e.attr("aria-controls", t);
          })(e, t));
      };
      function v() {
        const t = e.params.a11y;
        e.$el.append(i);
        const s = e.$el;
        (t.containerRoleDescriptionMessage && o(s, t.containerRoleDescriptionMessage),
          t.containerMessage && p(s, t.containerMessage));
        const a = e.$wrapperEl,
          n =
            a.attr("id") ||
            `swiper-wrapper-${(function (e = 16) {
              return "x".repeat(e).replace(/x/g, () => Math.round(16 * Math.random()).toString(16));
            })(16)}`,
          r = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
        var c;
        ((c = n),
          a.attr("id", c),
          (function (e, t) {
            e.attr("aria-live", t);
          })(a, r),
          t.itemRoleDescriptionMessage && o(d(e.slides), t.itemRoleDescriptionMessage),
          l(d(e.slides), t.slideRole));
        const u = e.params.loop
          ? e.slides.filter((t) => !t.classList.contains(e.params.slideDuplicateClass)).length
          : e.slides.length;
        let f, v;
        (e.slides.each((s, i) => {
          const a = d(s),
            n = e.params.loop ? parseInt(a.attr("data-swiper-slide-index"), 10) : i;
          p(
            a,
            t.slideLabelMessage.replace(/\{\{index\}\}/, n + 1).replace(/\{\{slidesLength\}\}/, u),
          );
        }),
          e.navigation && e.navigation.$nextEl && (f = e.navigation.$nextEl),
          e.navigation && e.navigation.$prevEl && (v = e.navigation.$prevEl),
          f && f.length && g(f, n, t.nextSlideMessage),
          v && v.length && g(v, n, t.prevSlideMessage),
          m() && e.pagination.$el.on("keydown", V(e.params.pagination.bulletClass), h));
      }
      (s("beforeInit", () => {
        i = d(
          `<span class="${e.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`,
        );
      }),
        s("afterInit", () => {
          e.params.a11y.enabled && (v(), f());
        }),
        s("toEdge", () => {
          e.params.a11y.enabled && f();
        }),
        s("fromEdge", () => {
          e.params.a11y.enabled && f();
        }),
        s("paginationUpdate", () => {
          e.params.a11y.enabled &&
            (function () {
              const t = e.params.a11y;
              m() &&
                e.pagination.bullets.each((s) => {
                  const i = d(s);
                  (n(i),
                    e.params.pagination.renderBullet ||
                      (l(i, "button"),
                      p(i, t.paginationBulletMessage.replace(/\{\{index\}\}/, i.index() + 1))));
                });
            })();
        }),
        s("destroy", () => {
          e.params.a11y.enabled &&
            (function () {
              let t, s;
              (i && i.length > 0 && i.remove(),
                e.navigation && e.navigation.$nextEl && (t = e.navigation.$nextEl),
                e.navigation && e.navigation.$prevEl && (s = e.navigation.$prevEl),
                t && t.off("keydown", h),
                s && s.off("keydown", h),
                m() && e.pagination.$el.off("keydown", V(e.params.pagination.bulletClass), h));
            })();
        }));
    },
    function ({ swiper: e, extendParams: t, on: s, emit: a }) {
      let n;
      function r() {
        const t = e.slides.eq(e.activeIndex);
        let s = e.params.autoplay.delay;
        (t.attr("data-swiper-autoplay") &&
          (s = t.attr("data-swiper-autoplay") || e.params.autoplay.delay),
          clearTimeout(n),
          (n = c(() => {
            let t;
            (e.params.autoplay.reverseDirection
              ? e.params.loop
                ? (e.loopFix(), (t = e.slidePrev(e.params.speed, !0, !0)), a("autoplay"))
                : e.isBeginning
                  ? e.params.autoplay.stopOnLastSlide
                    ? o()
                    : ((t = e.slideTo(e.slides.length - 1, e.params.speed, !0, !0)), a("autoplay"))
                  : ((t = e.slidePrev(e.params.speed, !0, !0)), a("autoplay"))
              : e.params.loop
                ? (e.loopFix(), (t = e.slideNext(e.params.speed, !0, !0)), a("autoplay"))
                : e.isEnd
                  ? e.params.autoplay.stopOnLastSlide
                    ? o()
                    : ((t = e.slideTo(0, e.params.speed, !0, !0)), a("autoplay"))
                  : ((t = e.slideNext(e.params.speed, !0, !0)), a("autoplay")),
              ((e.params.cssMode && e.autoplay.running) || !1 === t) && r());
          }, s)));
      }
      function l() {
        return (
          void 0 === n &&
          !e.autoplay.running &&
          ((e.autoplay.running = !0), a("autoplayStart"), r(), !0)
        );
      }
      function o() {
        return (
          !!e.autoplay.running &&
          void 0 !== n &&
          (n && (clearTimeout(n), (n = void 0)), (e.autoplay.running = !1), a("autoplayStop"), !0)
        );
      }
      function d(t) {
        e.autoplay.running &&
          (e.autoplay.paused ||
            (n && clearTimeout(n),
            (e.autoplay.paused = !0),
            0 !== t && e.params.autoplay.waitForTransition
              ? ["transitionend", "webkitTransitionEnd"].forEach((t) => {
                  e.$wrapperEl[0].addEventListener(t, u);
                })
              : ((e.autoplay.paused = !1), r())));
      }
      function p() {
        const t = i();
        ("hidden" === t.visibilityState && e.autoplay.running && d(),
          "visible" === t.visibilityState && e.autoplay.paused && (r(), (e.autoplay.paused = !1)));
      }
      function u(t) {
        e &&
          !e.destroyed &&
          e.$wrapperEl &&
          t.target === e.$wrapperEl[0] &&
          (["transitionend", "webkitTransitionEnd"].forEach((t) => {
            e.$wrapperEl[0].removeEventListener(t, u);
          }),
          (e.autoplay.paused = !1),
          e.autoplay.running ? r() : o());
      }
      function h() {
        (e.params.autoplay.disableOnInteraction ? o() : d(),
          ["transitionend", "webkitTransitionEnd"].forEach((t) => {
            e.$wrapperEl[0].removeEventListener(t, u);
          }));
      }
      function f() {
        e.params.autoplay.disableOnInteraction || ((e.autoplay.paused = !1), r());
      }
      ((e.autoplay = { running: !1, paused: !1 }),
        t({
          autoplay: {
            enabled: !1,
            delay: 3e3,
            waitForTransition: !0,
            disableOnInteraction: !0,
            stopOnLastSlide: !1,
            reverseDirection: !1,
            pauseOnMouseEnter: !1,
          },
        }),
        s("init", () => {
          if (e.params.autoplay.enabled) {
            l();
            (i().addEventListener("visibilitychange", p),
              e.params.autoplay.pauseOnMouseEnter &&
                (e.$el.on("mouseenter", h), e.$el.on("mouseleave", f)));
          }
        }),
        s("beforeTransitionStart", (t, s, i) => {
          e.autoplay.running &&
            (i || !e.params.autoplay.disableOnInteraction ? e.autoplay.pause(s) : o());
        }),
        s("sliderFirstMove", () => {
          e.autoplay.running && (e.params.autoplay.disableOnInteraction ? o() : d());
        }),
        s("touchEnd", () => {
          e.params.cssMode && e.autoplay.paused && !e.params.autoplay.disableOnInteraction && r();
        }),
        s("destroy", () => {
          (e.$el.off("mouseenter", h), e.$el.off("mouseleave", f), e.autoplay.running && o());
          i().removeEventListener("visibilitychange", p);
        }),
        Object.assign(e.autoplay, { pause: d, run: r, start: l, stop: o }));
    },
    function ({ swiper: e }) {
      Object.assign(e, {
        appendSlide: F.bind(e),
        prependSlide: R.bind(e),
        addSlide: W.bind(e),
        removeSlide: q.bind(e),
        removeAllSlides: X.bind(e),
      });
    },
    function ({ swiper: e, extendParams: t, on: s }) {
      (t({ fadeEffect: { crossFade: !1, transformEl: null } }),
        (function (e) {
          const {
            effect: t,
            swiper: s,
            on: i,
            setTranslate: a,
            setTransition: n,
            overwriteParams: r,
            perspective: l,
          } = e;
          (i("beforeInit", () => {
            if (s.params.effect !== t) return;
            (s.classNames.push(`${s.params.containerModifierClass}${t}`),
              l && l() && s.classNames.push(`${s.params.containerModifierClass}3d`));
            const e = r ? r() : {};
            (Object.assign(s.params, e), Object.assign(s.originalParams, e));
          }),
            i("setTranslate", () => {
              s.params.effect === t && a();
            }),
            i("setTransition", (e, i) => {
              s.params.effect === t && n(i);
            }));
        })({
          effect: "fade",
          swiper: e,
          on: s,
          setTranslate: () => {
            const { slides: t } = e,
              s = e.params.fadeEffect;
            for (let i = 0; i < t.length; i += 1) {
              const t = e.slides.eq(i);
              let a = -t[0].swiperSlideOffset;
              e.params.virtualTranslate || (a -= e.translate);
              let n = 0;
              e.isHorizontal() || ((n = a), (a = 0));
              const r = e.params.fadeEffect.crossFade
                ? Math.max(1 - Math.abs(t[0].progress), 0)
                : 1 + Math.min(Math.max(t[0].progress, -1), 0);
              Y(s, t).css({ opacity: r }).transform(`translate3d(${a}px, ${n}px, 0px)`);
            }
          },
          setTransition: (t) => {
            const { transformEl: s } = e.params.fadeEffect;
            ((s ? e.slides.find(s) : e.slides).transition(t),
              (function ({ swiper: e, duration: t, transformEl: s, allSlides: i }) {
                const { slides: a, activeIndex: n, $wrapperEl: r } = e;
                if (e.params.virtualTranslate && 0 !== t) {
                  let t,
                    l = !1;
                  ((t = i ? (s ? a.find(s) : a) : s ? a.eq(n).find(s) : a.eq(n)),
                    t.transitionEnd(() => {
                      if (l) return;
                      if (!e || e.destroyed) return;
                      ((l = !0), (e.animating = !1));
                      const t = ["webkitTransitionEnd", "transitionend"];
                      for (let e = 0; e < t.length; e += 1) r.trigger(t[e]);
                    }));
                }
              })({ swiper: e, duration: t, transformEl: s, allSlides: !0 }));
          },
          overwriteParams: () => ({
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: !0,
            spaceBetween: 0,
            virtualTranslate: !e.params.cssMode,
          }),
        }));
    },
  ];
  return (H.use(U), H);
});

/*!
	Swiper
	Copyright	Vladimir Kharlampidi
	License		MIT
	Version		8.3.0

	https://github.com/nolimits4web/swiper
*/
// !function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).Swiper=t()}(this,(function(){"use strict";function e(e){return null!==e&&"object"==typeof e&&"constructor"in e&&e.constructor===Object}function t(s,i){void 0===s&&(s={}),void 0===i&&(i={}),Object.keys(i).forEach((a=>{void 0===s[a]?s[a]=i[a]:e(i[a])&&e(s[a])&&Object.keys(i[a]).length>0&&t(s[a],i[a])}))}const s={body:{},addEventListener(){},removeEventListener(){},activeElement:{blur(){},nodeName:""},querySelector:()=>null,querySelectorAll:()=>[],getElementById:()=>null,createEvent:()=>({initEvent(){}}),createElement:()=>({children:[],childNodes:[],style:{},setAttribute(){},getElementsByTagName:()=>[]}),createElementNS:()=>({}),importNode:()=>null,location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""}};function i(){const e="undefined"!=typeof document?document:{};return t(e,s),e}const a={document:s,navigator:{userAgent:""},location:{hash:"",host:"",hostname:"",href:"",origin:"",pathname:"",protocol:"",search:""},history:{replaceState(){},pushState(){},go(){},back(){}},CustomEvent:function(){return this},addEventListener(){},removeEventListener(){},getComputedStyle:()=>({getPropertyValue:()=>""}),Image(){},Date(){},screen:{},setTimeout(){},clearTimeout(){},matchMedia:()=>({}),requestAnimationFrame:e=>"undefined"==typeof setTimeout?(e(),null):setTimeout(e,0),cancelAnimationFrame(e){"undefined"!=typeof setTimeout&&clearTimeout(e)}};function n(){const e="undefined"!=typeof window?window:{};return t(e,a),e}class r extends Array{constructor(e){"number"==typeof e?super(e):(super(...e||[]),function(e){const t=e.__proto__;Object.defineProperty(e,"__proto__",{get:()=>t,set(e){t.__proto__=e}})}(this))}}function l(e){void 0===e&&(e=[]);const t=[];return e.forEach((e=>{Array.isArray(e)?t.push(...l(e)):t.push(e)})),t}function o(e,t){return Array.prototype.filter.call(e,t)}function d(e,t){const s=n(),a=i();let l=[];if(!t&&e instanceof r)return e;if(!e)return new r(l);if("string"==typeof e){const s=e.trim();if(s.indexOf("<")>=0&&s.indexOf(">")>=0){let e="div";0===s.indexOf("<li")&&(e="ul"),0===s.indexOf("<tr")&&(e="tbody"),0!==s.indexOf("<td")&&0!==s.indexOf("<th")||(e="tr"),0===s.indexOf("<tbody")&&(e="table"),0===s.indexOf("<option")&&(e="select");const t=a.createElement(e);t.innerHTML=s;for(let e=0;e<t.childNodes.length;e+=1)l.push(t.childNodes[e])}else l=function(e,t){if("string"!=typeof e)return[e];const s=[],i=t.querySelectorAll(e);for(let e=0;e<i.length;e+=1)s.push(i[e]);return s}(e.trim(),t||a)}else if(e.nodeType||e===s||e===a)l.push(e);else if(Array.isArray(e)){if(e instanceof r)return e;l=e}return new r(function(e){const t=[];for(let s=0;s<e.length;s+=1)-1===t.indexOf(e[s])&&t.push(e[s]);return t}(l))}d.fn=r.prototype;const p={addClass:function(){for(var e=arguments.length,t=new Array(e),s=0;s<e;s++)t[s]=arguments[s];const i=l(t.map((e=>e.split(" "))));return this.forEach((e=>{e.classList.add(...i)})),this},removeClass:function(){for(var e=arguments.length,t=new Array(e),s=0;s<e;s++)t[s]=arguments[s];const i=l(t.map((e=>e.split(" "))));return this.forEach((e=>{e.classList.remove(...i)})),this},hasClass:function(){for(var e=arguments.length,t=new Array(e),s=0;s<e;s++)t[s]=arguments[s];const i=l(t.map((e=>e.split(" "))));return o(this,(e=>i.filter((t=>e.classList.contains(t))).length>0)).length>0},toggleClass:function(){for(var e=arguments.length,t=new Array(e),s=0;s<e;s++)t[s]=arguments[s];const i=l(t.map((e=>e.split(" "))));this.forEach((e=>{i.forEach((t=>{e.classList.toggle(t)}))}))},attr:function(e,t){if(1===arguments.length&&"string"==typeof e)return this[0]?this[0].getAttribute(e):void 0;for(let s=0;s<this.length;s+=1)if(2===arguments.length)this[s].setAttribute(e,t);else for(const t in e)this[s][t]=e[t],this[s].setAttribute(t,e[t]);return this},removeAttr:function(e){for(let t=0;t<this.length;t+=1)this[t].removeAttribute(e);return this},transform:function(e){for(let t=0;t<this.length;t+=1)this[t].style.transform=e;return this},transition:function(e){for(let t=0;t<this.length;t+=1)this[t].style.transitionDuration="string"!=typeof e?`${e}ms`:e;return this},on:function(){for(var e=arguments.length,t=new Array(e),s=0;s<e;s++)t[s]=arguments[s];let[i,a,n,r]=t;function l(e){const t=e.target;if(!t)return;const s=e.target.dom7EventData||[];if(s.indexOf(e)<0&&s.unshift(e),d(t).is(a))n.apply(t,s);else{const e=d(t).parents();for(let t=0;t<e.length;t+=1)d(e[t]).is(a)&&n.apply(e[t],s)}}function o(e){const t=e&&e.target&&e.target.dom7EventData||[];t.indexOf(e)<0&&t.unshift(e),n.apply(this,t)}"function"==typeof t[1]&&([i,n,r]=t,a=void 0),r||(r=!1);const p=i.split(" ");let c;for(let e=0;e<this.length;e+=1){const t=this[e];if(a)for(c=0;c<p.length;c+=1){const e=p[c];t.dom7LiveListeners||(t.dom7LiveListeners={}),t.dom7LiveListeners[e]||(t.dom7LiveListeners[e]=[]),t.dom7LiveListeners[e].push({listener:n,proxyListener:l}),t.addEventListener(e,l,r)}else for(c=0;c<p.length;c+=1){const e=p[c];t.dom7Listeners||(t.dom7Listeners={}),t.dom7Listeners[e]||(t.dom7Listeners[e]=[]),t.dom7Listeners[e].push({listener:n,proxyListener:o}),t.addEventListener(e,o,r)}}return this},off:function(){for(var e=arguments.length,t=new Array(e),s=0;s<e;s++)t[s]=arguments[s];let[i,a,n,r]=t;"function"==typeof t[1]&&([i,n,r]=t,a=void 0),r||(r=!1);const l=i.split(" ");for(let e=0;e<l.length;e+=1){const t=l[e];for(let e=0;e<this.length;e+=1){const s=this[e];let i;if(!a&&s.dom7Listeners?i=s.dom7Listeners[t]:a&&s.dom7LiveListeners&&(i=s.dom7LiveListeners[t]),i&&i.length)for(let e=i.length-1;e>=0;e-=1){const a=i[e];n&&a.listener===n||n&&a.listener&&a.listener.dom7proxy&&a.listener.dom7proxy===n?(s.removeEventListener(t,a.proxyListener,r),i.splice(e,1)):n||(s.removeEventListener(t,a.proxyListener,r),i.splice(e,1))}}}return this},trigger:function(){const e=n();for(var t=arguments.length,s=new Array(t),i=0;i<t;i++)s[i]=arguments[i];const a=s[0].split(" "),r=s[1];for(let t=0;t<a.length;t+=1){const i=a[t];for(let t=0;t<this.length;t+=1){const a=this[t];if(e.CustomEvent){const t=new e.CustomEvent(i,{detail:r,bubbles:!0,cancelable:!0});a.dom7EventData=s.filter(((e,t)=>t>0)),a.dispatchEvent(t),a.dom7EventData=[],delete a.dom7EventData}}}return this},transitionEnd:function(e){const t=this;return e&&t.on("transitionend",(function s(i){i.target===this&&(e.call(this,i),t.off("transitionend",s))})),this},outerWidth:function(e){if(this.length>0){if(e){const e=this.styles();return this[0].offsetWidth+parseFloat(e.getPropertyValue("margin-right"))+parseFloat(e.getPropertyValue("margin-left"))}return this[0].offsetWidth}return null},outerHeight:function(e){if(this.length>0){if(e){const e=this.styles();return this[0].offsetHeight+parseFloat(e.getPropertyValue("margin-top"))+parseFloat(e.getPropertyValue("margin-bottom"))}return this[0].offsetHeight}return null},styles:function(){const e=n();return this[0]?e.getComputedStyle(this[0],null):{}},offset:function(){if(this.length>0){const e=n(),t=i(),s=this[0],a=s.getBoundingClientRect(),r=t.body,l=s.clientTop||r.clientTop||0,o=s.clientLeft||r.clientLeft||0,d=s===e?e.scrollY:s.scrollTop,p=s===e?e.scrollX:s.scrollLeft;return{top:a.top+d-l,left:a.left+p-o}}return null},css:function(e,t){const s=n();let i;if(1===arguments.length){if("string"!=typeof e){for(i=0;i<this.length;i+=1)for(const t in e)this[i].style[t]=e[t];return this}if(this[0])return s.getComputedStyle(this[0],null).getPropertyValue(e)}if(2===arguments.length&&"string"==typeof e){for(i=0;i<this.length;i+=1)this[i].style[e]=t;return this}return this},each:function(e){return e?(this.forEach(((t,s)=>{e.apply(t,[t,s])})),this):this},html:function(e){if(void 0===e)return this[0]?this[0].innerHTML:null;for(let t=0;t<this.length;t+=1)this[t].innerHTML=e;return this},text:function(e){if(void 0===e)return this[0]?this[0].textContent.trim():null;for(let t=0;t<this.length;t+=1)this[t].textContent=e;return this},is:function(e){const t=n(),s=i(),a=this[0];let l,o;if(!a||void 0===e)return!1;if("string"==typeof e){if(a.matches)return a.matches(e);if(a.webkitMatchesSelector)return a.webkitMatchesSelector(e);if(a.msMatchesSelector)return a.msMatchesSelector(e);for(l=d(e),o=0;o<l.length;o+=1)if(l[o]===a)return!0;return!1}if(e===s)return a===s;if(e===t)return a===t;if(e.nodeType||e instanceof r){for(l=e.nodeType?[e]:e,o=0;o<l.length;o+=1)if(l[o]===a)return!0;return!1}return!1},index:function(){let e,t=this[0];if(t){for(e=0;null!==(t=t.previousSibling);)1===t.nodeType&&(e+=1);return e}},eq:function(e){if(void 0===e)return this;const t=this.length;if(e>t-1)return d([]);if(e<0){const s=t+e;return d(s<0?[]:[this[s]])}return d([this[e]])},append:function(){let e;const t=i();for(let s=0;s<arguments.length;s+=1){e=s<0||arguments.length<=s?void 0:arguments[s];for(let s=0;s<this.length;s+=1)if("string"==typeof e){const i=t.createElement("div");for(i.innerHTML=e;i.firstChild;)this[s].appendChild(i.firstChild)}else if(e instanceof r)for(let t=0;t<e.length;t+=1)this[s].appendChild(e[t]);else this[s].appendChild(e)}return this},prepend:function(e){const t=i();let s,a;for(s=0;s<this.length;s+=1)if("string"==typeof e){const i=t.createElement("div");for(i.innerHTML=e,a=i.childNodes.length-1;a>=0;a-=1)this[s].insertBefore(i.childNodes[a],this[s].childNodes[0])}else if(e instanceof r)for(a=0;a<e.length;a+=1)this[s].insertBefore(e[a],this[s].childNodes[0]);else this[s].insertBefore(e,this[s].childNodes[0]);return this},next:function(e){return this.length>0?e?this[0].nextElementSibling&&d(this[0].nextElementSibling).is(e)?d([this[0].nextElementSibling]):d([]):this[0].nextElementSibling?d([this[0].nextElementSibling]):d([]):d([])},nextAll:function(e){const t=[];let s=this[0];if(!s)return d([]);for(;s.nextElementSibling;){const i=s.nextElementSibling;e?d(i).is(e)&&t.push(i):t.push(i),s=i}return d(t)},prev:function(e){if(this.length>0){const t=this[0];return e?t.previousElementSibling&&d(t.previousElementSibling).is(e)?d([t.previousElementSibling]):d([]):t.previousElementSibling?d([t.previousElementSibling]):d([])}return d([])},prevAll:function(e){const t=[];let s=this[0];if(!s)return d([]);for(;s.previousElementSibling;){const i=s.previousElementSibling;e?d(i).is(e)&&t.push(i):t.push(i),s=i}return d(t)},parent:function(e){const t=[];for(let s=0;s<this.length;s+=1)null!==this[s].parentNode&&(e?d(this[s].parentNode).is(e)&&t.push(this[s].parentNode):t.push(this[s].parentNode));return d(t)},parents:function(e){const t=[];for(let s=0;s<this.length;s+=1){let i=this[s].parentNode;for(;i;)e?d(i).is(e)&&t.push(i):t.push(i),i=i.parentNode}return d(t)},closest:function(e){let t=this;return void 0===e?d([]):(t.is(e)||(t=t.parents(e).eq(0)),t)},find:function(e){const t=[];for(let s=0;s<this.length;s+=1){const i=this[s].querySelectorAll(e);for(let e=0;e<i.length;e+=1)t.push(i[e])}return d(t)},children:function(e){const t=[];for(let s=0;s<this.length;s+=1){const i=this[s].children;for(let s=0;s<i.length;s+=1)e&&!d(i[s]).is(e)||t.push(i[s])}return d(t)},filter:function(e){return d(o(this,e))},remove:function(){for(let e=0;e<this.length;e+=1)this[e].parentNode&&this[e].parentNode.removeChild(this[e]);return this}};function c(e,t){return void 0===t&&(t=0),setTimeout(e,t)}function u(){return Date.now()}function h(e,t){void 0===t&&(t="x");const s=n();let i,a,r;const l=function(e){const t=n();let s;return t.getComputedStyle&&(s=t.getComputedStyle(e,null)),!s&&e.currentStyle&&(s=e.currentStyle),s||(s=e.style),s}(e);return s.WebKitCSSMatrix?(a=l.transform||l.webkitTransform,a.split(",").length>6&&(a=a.split(", ").map((e=>e.replace(",","."))).join(", ")),r=new s.WebKitCSSMatrix("none"===a?"":a)):(r=l.MozTransform||l.OTransform||l.MsTransform||l.msTransform||l.transform||l.getPropertyValue("transform").replace("translate(","matrix(1, 0, 0, 1,"),i=r.toString().split(",")),"x"===t&&(a=s.WebKitCSSMatrix?r.m41:16===i.length?parseFloat(i[12]):parseFloat(i[4])),"y"===t&&(a=s.WebKitCSSMatrix?r.m42:16===i.length?parseFloat(i[13]):parseFloat(i[5])),a||0}function f(e){return"object"==typeof e&&null!==e&&e.constructor&&"Object"===Object.prototype.toString.call(e).slice(8,-1)}function m(e){return"undefined"!=typeof window&&void 0!==window.HTMLElement?e instanceof HTMLElement:e&&(1===e.nodeType||11===e.nodeType)}function g(){const e=Object(arguments.length<=0?void 0:arguments[0]),t=["__proto__","constructor","prototype"];for(let s=1;s<arguments.length;s+=1){const i=s<0||arguments.length<=s?void 0:arguments[s];if(null!=i&&!m(i)){const s=Object.keys(Object(i)).filter((e=>t.indexOf(e)<0));for(let t=0,a=s.length;t<a;t+=1){const a=s[t],n=Object.getOwnPropertyDescriptor(i,a);void 0!==n&&n.enumerable&&(f(e[a])&&f(i[a])?i[a].__swiper__?e[a]=i[a]:g(e[a],i[a]):!f(e[a])&&f(i[a])?(e[a]={},i[a].__swiper__?e[a]=i[a]:g(e[a],i[a])):e[a]=i[a])}}}return e}function v(e,t,s){e.style.setProperty(t,s)}function w(e){let{swiper:t,targetPosition:s,side:i}=e;const a=n(),r=-t.translate;let l,o=null;const d=t.params.speed;t.wrapperEl.style.scrollSnapType="none",a.cancelAnimationFrame(t.cssModeFrameID);const p=s>r?"next":"prev",c=(e,t)=>"next"===p&&e>=t||"prev"===p&&e<=t,u=()=>{l=(new Date).getTime(),null===o&&(o=l);const e=Math.max(Math.min((l-o)/d,1),0),n=.5-Math.cos(e*Math.PI)/2;let p=r+n*(s-r);if(c(p,s)&&(p=s),t.wrapperEl.scrollTo({[i]:p}),c(p,s))return t.wrapperEl.style.overflow="hidden",t.wrapperEl.style.scrollSnapType="",setTimeout((()=>{t.wrapperEl.style.overflow="",t.wrapperEl.scrollTo({[i]:p})})),void a.cancelAnimationFrame(t.cssModeFrameID);t.cssModeFrameID=a.requestAnimationFrame(u)};u()}let b,y,C;function T(){return b||(b=function(){const e=n(),t=i();return{smoothScroll:t.documentElement&&"scrollBehavior"in t.documentElement.style,touch:!!("ontouchstart"in e||e.DocumentTouch&&t instanceof e.DocumentTouch),passiveListener:function(){let t=!1;try{const s=Object.defineProperty({},"passive",{get(){t=!0}});e.addEventListener("testPassiveListener",null,s)}catch(e){}return t}(),gestures:"ongesturestart"in e}}()),b}function x(e){return void 0===e&&(e={}),y||(y=function(e){let{userAgent:t}=void 0===e?{}:e;const s=T(),i=n(),a=i.navigator.platform,r=t||i.navigator.userAgent,l={ios:!1,android:!1},o=i.screen.width,d=i.screen.height,p=r.match(/(Android);?[\s\/]+([\d.]+)?/);let c=r.match(/(iPad).*OS\s([\d_]+)/);const u=r.match(/(iPod)(.*OS\s([\d_]+))?/),h=!c&&r.match(/(iPhone\sOS|iOS)\s([\d_]+)/),f="Win32"===a;let m="MacIntel"===a;return!c&&m&&s.touch&&["1024x1366","1366x1024","834x1194","1194x834","834x1112","1112x834","768x1024","1024x768","820x1180","1180x820","810x1080","1080x810"].indexOf(`${o}x${d}`)>=0&&(c=r.match(/(Version)\/([\d.]+)/),c||(c=[0,1,"13_0_0"]),m=!1),p&&!f&&(l.os="android",l.android=!0),(c||h||u)&&(l.os="ios",l.ios=!0),l}(e)),y}function S(){return C||(C=function(){const e=n();return{isSafari:function(){const t=e.navigator.userAgent.toLowerCase();return t.indexOf("safari")>=0&&t.indexOf("chrome")<0&&t.indexOf("android")<0}(),isWebView:/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)}}()),C}Object.keys(p).forEach((e=>{Object.defineProperty(d.fn,e,{value:p[e],writable:!0})}));var E={on(e,t,s){const i=this;if(!i.eventsListeners||i.destroyed)return i;if("function"!=typeof t)return i;const a=s?"unshift":"push";return e.split(" ").forEach((e=>{i.eventsListeners[e]||(i.eventsListeners[e]=[]),i.eventsListeners[e][a](t)})),i},once(e,t,s){const i=this;if(!i.eventsListeners||i.destroyed)return i;if("function"!=typeof t)return i;function a(){i.off(e,a),a.__emitterProxy&&delete a.__emitterProxy;for(var s=arguments.length,n=new Array(s),r=0;r<s;r++)n[r]=arguments[r];t.apply(i,n)}return a.__emitterProxy=t,i.on(e,a,s)},onAny(e,t){const s=this;if(!s.eventsListeners||s.destroyed)return s;if("function"!=typeof e)return s;const i=t?"unshift":"push";return s.eventsAnyListeners.indexOf(e)<0&&s.eventsAnyListeners[i](e),s},offAny(e){const t=this;if(!t.eventsListeners||t.destroyed)return t;if(!t.eventsAnyListeners)return t;const s=t.eventsAnyListeners.indexOf(e);return s>=0&&t.eventsAnyListeners.splice(s,1),t},off(e,t){const s=this;return!s.eventsListeners||s.destroyed?s:s.eventsListeners?(e.split(" ").forEach((e=>{void 0===t?s.eventsListeners[e]=[]:s.eventsListeners[e]&&s.eventsListeners[e].forEach(((i,a)=>{(i===t||i.__emitterProxy&&i.__emitterProxy===t)&&s.eventsListeners[e].splice(a,1)}))})),s):s},emit(){const e=this;if(!e.eventsListeners||e.destroyed)return e;if(!e.eventsListeners)return e;let t,s,i;for(var a=arguments.length,n=new Array(a),r=0;r<a;r++)n[r]=arguments[r];"string"==typeof n[0]||Array.isArray(n[0])?(t=n[0],s=n.slice(1,n.length),i=e):(t=n[0].events,s=n[0].data,i=n[0].context||e),s.unshift(i);return(Array.isArray(t)?t:t.split(" ")).forEach((t=>{e.eventsAnyListeners&&e.eventsAnyListeners.length&&e.eventsAnyListeners.forEach((e=>{e.apply(i,[t,...s])})),e.eventsListeners&&e.eventsListeners[t]&&e.eventsListeners[t].forEach((e=>{e.apply(i,s)}))})),e}};var $={updateSize:function(){const e=this;let t,s;const i=e.$el;t=void 0!==e.params.width&&null!==e.params.width?e.params.width:i[0].clientWidth,s=void 0!==e.params.height&&null!==e.params.height?e.params.height:i[0].clientHeight,0===t&&e.isHorizontal()||0===s&&e.isVertical()||(t=t-parseInt(i.css("padding-left")||0,10)-parseInt(i.css("padding-right")||0,10),s=s-parseInt(i.css("padding-top")||0,10)-parseInt(i.css("padding-bottom")||0,10),Number.isNaN(t)&&(t=0),Number.isNaN(s)&&(s=0),Object.assign(e,{width:t,height:s,size:e.isHorizontal()?t:s}))},updateSlides:function(){const e=this;function t(t){return e.isHorizontal()?t:{width:"height","margin-top":"margin-left","margin-bottom ":"margin-right","margin-left":"margin-top","margin-right":"margin-bottom","padding-left":"padding-top","padding-right":"padding-bottom",marginRight:"marginBottom"}[t]}function s(e,s){return parseFloat(e.getPropertyValue(t(s))||0)}const i=e.params,{$wrapperEl:a,size:n,rtlTranslate:r,wrongRTL:l}=e,o=e.virtual&&i.virtual.enabled,d=o?e.virtual.slides.length:e.slides.length,p=a.children(`.${e.params.slideClass}`),c=o?e.virtual.slides.length:p.length;let u=[];const h=[],f=[];let m=i.slidesOffsetBefore;"function"==typeof m&&(m=i.slidesOffsetBefore.call(e));let g=i.slidesOffsetAfter;"function"==typeof g&&(g=i.slidesOffsetAfter.call(e));const w=e.snapGrid.length,b=e.slidesGrid.length;let y=i.spaceBetween,C=-m,T=0,x=0;if(void 0===n)return;"string"==typeof y&&y.indexOf("%")>=0&&(y=parseFloat(y.replace("%",""))/100*n),e.virtualSize=-y,r?p.css({marginLeft:"",marginBottom:"",marginTop:""}):p.css({marginRight:"",marginBottom:"",marginTop:""}),i.centeredSlides&&i.cssMode&&(v(e.wrapperEl,"--swiper-centered-offset-before",""),v(e.wrapperEl,"--swiper-centered-offset-after",""));const S=i.grid&&i.grid.rows>1&&e.grid;let E;S&&e.grid.initSlides(c);const $="auto"===i.slidesPerView&&i.breakpoints&&Object.keys(i.breakpoints).filter((e=>void 0!==i.breakpoints[e].slidesPerView)).length>0;for(let a=0;a<c;a+=1){E=0;const r=p.eq(a);if(S&&e.grid.updateSlide(a,r,c,t),"none"!==r.css("display")){if("auto"===i.slidesPerView){$&&(p[a].style[t("width")]="");const n=getComputedStyle(r[0]),l=r[0].style.transform,o=r[0].style.webkitTransform;if(l&&(r[0].style.transform="none"),o&&(r[0].style.webkitTransform="none"),i.roundLengths)E=e.isHorizontal()?r.outerWidth(!0):r.outerHeight(!0);else{const e=s(n,"width"),t=s(n,"padding-left"),i=s(n,"padding-right"),a=s(n,"margin-left"),l=s(n,"margin-right"),o=n.getPropertyValue("box-sizing");if(o&&"border-box"===o)E=e+a+l;else{const{clientWidth:s,offsetWidth:n}=r[0];E=e+t+i+a+l+(n-s)}}l&&(r[0].style.transform=l),o&&(r[0].style.webkitTransform=o),i.roundLengths&&(E=Math.floor(E))}else E=(n-(i.slidesPerView-1)*y)/i.slidesPerView,i.roundLengths&&(E=Math.floor(E)),p[a]&&(p[a].style[t("width")]=`${E}px`);p[a]&&(p[a].swiperSlideSize=E),f.push(E),i.centeredSlides?(C=C+E/2+T/2+y,0===T&&0!==a&&(C=C-n/2-y),0===a&&(C=C-n/2-y),Math.abs(C)<.001&&(C=0),i.roundLengths&&(C=Math.floor(C)),x%i.slidesPerGroup==0&&u.push(C),h.push(C)):(i.roundLengths&&(C=Math.floor(C)),(x-Math.min(e.params.slidesPerGroupSkip,x))%e.params.slidesPerGroup==0&&u.push(C),h.push(C),C=C+E+y),e.virtualSize+=E+y,T=E,x+=1}}if(e.virtualSize=Math.max(e.virtualSize,n)+g,r&&l&&("slide"===i.effect||"coverflow"===i.effect)&&a.css({width:`${e.virtualSize+i.spaceBetween}px`}),i.setWrapperSize&&a.css({[t("width")]:`${e.virtualSize+i.spaceBetween}px`}),S&&e.grid.updateWrapperSize(E,u,t),!i.centeredSlides){const t=[];for(let s=0;s<u.length;s+=1){let a=u[s];i.roundLengths&&(a=Math.floor(a)),u[s]<=e.virtualSize-n&&t.push(a)}u=t,Math.floor(e.virtualSize-n)-Math.floor(u[u.length-1])>1&&u.push(e.virtualSize-n)}if(0===u.length&&(u=[0]),0!==i.spaceBetween){const s=e.isHorizontal()&&r?"marginLeft":t("marginRight");p.filter(((e,t)=>!i.cssMode||t!==p.length-1)).css({[s]:`${y}px`})}if(i.centeredSlides&&i.centeredSlidesBounds){let e=0;f.forEach((t=>{e+=t+(i.spaceBetween?i.spaceBetween:0)})),e-=i.spaceBetween;const t=e-n;u=u.map((e=>e<0?-m:e>t?t+g:e))}if(i.centerInsufficientSlides){let e=0;if(f.forEach((t=>{e+=t+(i.spaceBetween?i.spaceBetween:0)})),e-=i.spaceBetween,e<n){const t=(n-e)/2;u.forEach(((e,s)=>{u[s]=e-t})),h.forEach(((e,s)=>{h[s]=e+t}))}}if(Object.assign(e,{slides:p,snapGrid:u,slidesGrid:h,slidesSizesGrid:f}),i.centeredSlides&&i.cssMode&&!i.centeredSlidesBounds){v(e.wrapperEl,"--swiper-centered-offset-before",-u[0]+"px"),v(e.wrapperEl,"--swiper-centered-offset-after",e.size/2-f[f.length-1]/2+"px");const t=-e.snapGrid[0],s=-e.slidesGrid[0];e.snapGrid=e.snapGrid.map((e=>e+t)),e.slidesGrid=e.slidesGrid.map((e=>e+s))}if(c!==d&&e.emit("slidesLengthChange"),u.length!==w&&(e.params.watchOverflow&&e.checkOverflow(),e.emit("snapGridLengthChange")),h.length!==b&&e.emit("slidesGridLengthChange"),i.watchSlidesProgress&&e.updateSlidesOffset(),!(o||i.cssMode||"slide"!==i.effect&&"fade"!==i.effect)){const t=`${i.containerModifierClass}backface-hidden`,s=e.$el.hasClass(t);c<=i.maxBackfaceHiddenSlides?s||e.$el.addClass(t):s&&e.$el.removeClass(t)}},updateAutoHeight:function(e){const t=this,s=[],i=t.virtual&&t.params.virtual.enabled;let a,n=0;"number"==typeof e?t.setTransition(e):!0===e&&t.setTransition(t.params.speed);const r=e=>i?t.slides.filter((t=>parseInt(t.getAttribute("data-swiper-slide-index"),10)===e))[0]:t.slides.eq(e)[0];if("auto"!==t.params.slidesPerView&&t.params.slidesPerView>1)if(t.params.centeredSlides)(t.visibleSlides||d([])).each((e=>{s.push(e)}));else for(a=0;a<Math.ceil(t.params.slidesPerView);a+=1){const e=t.activeIndex+a;if(e>t.slides.length&&!i)break;s.push(r(e))}else s.push(r(t.activeIndex));for(a=0;a<s.length;a+=1)if(void 0!==s[a]){const e=s[a].offsetHeight;n=e>n?e:n}(n||0===n)&&t.$wrapperEl.css("height",`${n}px`)},updateSlidesOffset:function(){const e=this,t=e.slides;for(let s=0;s<t.length;s+=1)t[s].swiperSlideOffset=e.isHorizontal()?t[s].offsetLeft:t[s].offsetTop},updateSlidesProgress:function(e){void 0===e&&(e=this&&this.translate||0);const t=this,s=t.params,{slides:i,rtlTranslate:a,snapGrid:n}=t;if(0===i.length)return;void 0===i[0].swiperSlideOffset&&t.updateSlidesOffset();let r=-e;a&&(r=e),i.removeClass(s.slideVisibleClass),t.visibleSlidesIndexes=[],t.visibleSlides=[];for(let e=0;e<i.length;e+=1){const l=i[e];let o=l.swiperSlideOffset;s.cssMode&&s.centeredSlides&&(o-=i[0].swiperSlideOffset);const d=(r+(s.centeredSlides?t.minTranslate():0)-o)/(l.swiperSlideSize+s.spaceBetween),p=(r-n[0]+(s.centeredSlides?t.minTranslate():0)-o)/(l.swiperSlideSize+s.spaceBetween),c=-(r-o),u=c+t.slidesSizesGrid[e];(c>=0&&c<t.size-1||u>1&&u<=t.size||c<=0&&u>=t.size)&&(t.visibleSlides.push(l),t.visibleSlidesIndexes.push(e),i.eq(e).addClass(s.slideVisibleClass)),l.progress=a?-d:d,l.originalProgress=a?-p:p}t.visibleSlides=d(t.visibleSlides)},updateProgress:function(e){const t=this;if(void 0===e){const s=t.rtlTranslate?-1:1;e=t&&t.translate&&t.translate*s||0}const s=t.params,i=t.maxTranslate()-t.minTranslate();let{progress:a,isBeginning:n,isEnd:r}=t;const l=n,o=r;0===i?(a=0,n=!0,r=!0):(a=(e-t.minTranslate())/i,n=a<=0,r=a>=1),Object.assign(t,{progress:a,isBeginning:n,isEnd:r}),(s.watchSlidesProgress||s.centeredSlides&&s.autoHeight)&&t.updateSlidesProgress(e),n&&!l&&t.emit("reachBeginning toEdge"),r&&!o&&t.emit("reachEnd toEdge"),(l&&!n||o&&!r)&&t.emit("fromEdge"),t.emit("progress",a)},updateSlidesClasses:function(){const e=this,{slides:t,params:s,$wrapperEl:i,activeIndex:a,realIndex:n}=e,r=e.virtual&&s.virtual.enabled;let l;t.removeClass(`${s.slideActiveClass} ${s.slideNextClass} ${s.slidePrevClass} ${s.slideDuplicateActiveClass} ${s.slideDuplicateNextClass} ${s.slideDuplicatePrevClass}`),l=r?e.$wrapperEl.find(`.${s.slideClass}[data-swiper-slide-index="${a}"]`):t.eq(a),l.addClass(s.slideActiveClass),s.loop&&(l.hasClass(s.slideDuplicateClass)?i.children(`.${s.slideClass}:not(.${s.slideDuplicateClass})[data-swiper-slide-index="${n}"]`).addClass(s.slideDuplicateActiveClass):i.children(`.${s.slideClass}.${s.slideDuplicateClass}[data-swiper-slide-index="${n}"]`).addClass(s.slideDuplicateActiveClass));let o=l.nextAll(`.${s.slideClass}`).eq(0).addClass(s.slideNextClass);s.loop&&0===o.length&&(o=t.eq(0),o.addClass(s.slideNextClass));let d=l.prevAll(`.${s.slideClass}`).eq(0).addClass(s.slidePrevClass);s.loop&&0===d.length&&(d=t.eq(-1),d.addClass(s.slidePrevClass)),s.loop&&(o.hasClass(s.slideDuplicateClass)?i.children(`.${s.slideClass}:not(.${s.slideDuplicateClass})[data-swiper-slide-index="${o.attr("data-swiper-slide-index")}"]`).addClass(s.slideDuplicateNextClass):i.children(`.${s.slideClass}.${s.slideDuplicateClass}[data-swiper-slide-index="${o.attr("data-swiper-slide-index")}"]`).addClass(s.slideDuplicateNextClass),d.hasClass(s.slideDuplicateClass)?i.children(`.${s.slideClass}:not(.${s.slideDuplicateClass})[data-swiper-slide-index="${d.attr("data-swiper-slide-index")}"]`).addClass(s.slideDuplicatePrevClass):i.children(`.${s.slideClass}.${s.slideDuplicateClass}[data-swiper-slide-index="${d.attr("data-swiper-slide-index")}"]`).addClass(s.slideDuplicatePrevClass)),e.emitSlidesClasses()},updateActiveIndex:function(e){const t=this,s=t.rtlTranslate?t.translate:-t.translate,{slidesGrid:i,snapGrid:a,params:n,activeIndex:r,realIndex:l,snapIndex:o}=t;let d,p=e;if(void 0===p){for(let e=0;e<i.length;e+=1)void 0!==i[e+1]?s>=i[e]&&s<i[e+1]-(i[e+1]-i[e])/2?p=e:s>=i[e]&&s<i[e+1]&&(p=e+1):s>=i[e]&&(p=e);n.normalizeSlideIndex&&(p<0||void 0===p)&&(p=0)}if(a.indexOf(s)>=0)d=a.indexOf(s);else{const e=Math.min(n.slidesPerGroupSkip,p);d=e+Math.floor((p-e)/n.slidesPerGroup)}if(d>=a.length&&(d=a.length-1),p===r)return void(d!==o&&(t.snapIndex=d,t.emit("snapIndexChange")));const c=parseInt(t.slides.eq(p).attr("data-swiper-slide-index")||p,10);Object.assign(t,{snapIndex:d,realIndex:c,previousIndex:r,activeIndex:p}),t.emit("activeIndexChange"),t.emit("snapIndexChange"),l!==c&&t.emit("realIndexChange"),(t.initialized||t.params.runCallbacksOnInit)&&t.emit("slideChange")},updateClickedSlide:function(e){const t=this,s=t.params,i=d(e).closest(`.${s.slideClass}`)[0];let a,n=!1;if(i)for(let e=0;e<t.slides.length;e+=1)if(t.slides[e]===i){n=!0,a=e;break}if(!i||!n)return t.clickedSlide=void 0,void(t.clickedIndex=void 0);t.clickedSlide=i,t.virtual&&t.params.virtual.enabled?t.clickedIndex=parseInt(d(i).attr("data-swiper-slide-index"),10):t.clickedIndex=a,s.slideToClickedSlide&&void 0!==t.clickedIndex&&t.clickedIndex!==t.activeIndex&&t.slideToClickedSlide()}};var M={getTranslate:function(e){void 0===e&&(e=this.isHorizontal()?"x":"y");const{params:t,rtlTranslate:s,translate:i,$wrapperEl:a}=this;if(t.virtualTranslate)return s?-i:i;if(t.cssMode)return i;let n=h(a[0],e);return s&&(n=-n),n||0},setTranslate:function(e,t){const s=this,{rtlTranslate:i,params:a,$wrapperEl:n,wrapperEl:r,progress:l}=s;let o,d=0,p=0;s.isHorizontal()?d=i?-e:e:p=e,a.roundLengths&&(d=Math.floor(d),p=Math.floor(p)),a.cssMode?r[s.isHorizontal()?"scrollLeft":"scrollTop"]=s.isHorizontal()?-d:-p:a.virtualTranslate||n.transform(`translate3d(${d}px, ${p}px, 0px)`),s.previousTranslate=s.translate,s.translate=s.isHorizontal()?d:p;const c=s.maxTranslate()-s.minTranslate();o=0===c?0:(e-s.minTranslate())/c,o!==l&&s.updateProgress(e),s.emit("setTranslate",s.translate,t)},minTranslate:function(){return-this.snapGrid[0]},maxTranslate:function(){return-this.snapGrid[this.snapGrid.length-1]},translateTo:function(e,t,s,i,a){void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===s&&(s=!0),void 0===i&&(i=!0);const n=this,{params:r,wrapperEl:l}=n;if(n.animating&&r.preventInteractionOnTransition)return!1;const o=n.minTranslate(),d=n.maxTranslate();let p;if(p=i&&e>o?o:i&&e<d?d:e,n.updateProgress(p),r.cssMode){const e=n.isHorizontal();if(0===t)l[e?"scrollLeft":"scrollTop"]=-p;else{if(!n.support.smoothScroll)return w({swiper:n,targetPosition:-p,side:e?"left":"top"}),!0;l.scrollTo({[e?"left":"top"]:-p,behavior:"smooth"})}return!0}return 0===t?(n.setTransition(0),n.setTranslate(p),s&&(n.emit("beforeTransitionStart",t,a),n.emit("transitionEnd"))):(n.setTransition(t),n.setTranslate(p),s&&(n.emit("beforeTransitionStart",t,a),n.emit("transitionStart")),n.animating||(n.animating=!0,n.onTranslateToWrapperTransitionEnd||(n.onTranslateToWrapperTransitionEnd=function(e){n&&!n.destroyed&&e.target===this&&(n.$wrapperEl[0].removeEventListener("transitionend",n.onTranslateToWrapperTransitionEnd),n.$wrapperEl[0].removeEventListener("webkitTransitionEnd",n.onTranslateToWrapperTransitionEnd),n.onTranslateToWrapperTransitionEnd=null,delete n.onTranslateToWrapperTransitionEnd,s&&n.emit("transitionEnd"))}),n.$wrapperEl[0].addEventListener("transitionend",n.onTranslateToWrapperTransitionEnd),n.$wrapperEl[0].addEventListener("webkitTransitionEnd",n.onTranslateToWrapperTransitionEnd))),!0}};function k(e){let{swiper:t,runCallbacks:s,direction:i,step:a}=e;const{activeIndex:n,previousIndex:r}=t;let l=i;if(l||(l=n>r?"next":n<r?"prev":"reset"),t.emit(`transition${a}`),s&&n!==r){if("reset"===l)return void t.emit(`slideResetTransition${a}`);t.emit(`slideChangeTransition${a}`),"next"===l?t.emit(`slideNextTransition${a}`):t.emit(`slidePrevTransition${a}`)}}var P={slideTo:function(e,t,s,i,a){if(void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===s&&(s=!0),"number"!=typeof e&&"string"!=typeof e)throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof e}] given.`);if("string"==typeof e){const t=parseInt(e,10);if(!isFinite(t))throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`);e=t}const n=this;let r=e;r<0&&(r=0);const{params:l,snapGrid:o,slidesGrid:d,previousIndex:p,activeIndex:c,rtlTranslate:u,wrapperEl:h,enabled:f}=n;if(n.animating&&l.preventInteractionOnTransition||!f&&!i&&!a)return!1;const m=Math.min(n.params.slidesPerGroupSkip,r);let g=m+Math.floor((r-m)/n.params.slidesPerGroup);g>=o.length&&(g=o.length-1),(c||l.initialSlide||0)===(p||0)&&s&&n.emit("beforeSlideChangeStart");const v=-o[g];if(n.updateProgress(v),l.normalizeSlideIndex)for(let e=0;e<d.length;e+=1){const t=-Math.floor(100*v),s=Math.floor(100*d[e]),i=Math.floor(100*d[e+1]);void 0!==d[e+1]?t>=s&&t<i-(i-s)/2?r=e:t>=s&&t<i&&(r=e+1):t>=s&&(r=e)}if(n.initialized&&r!==c){if(!n.allowSlideNext&&v<n.translate&&v<n.minTranslate())return!1;if(!n.allowSlidePrev&&v>n.translate&&v>n.maxTranslate()&&(c||0)!==r)return!1}let b;if(b=r>c?"next":r<c?"prev":"reset",u&&-v===n.translate||!u&&v===n.translate)return n.updateActiveIndex(r),l.autoHeight&&n.updateAutoHeight(),n.updateSlidesClasses(),"slide"!==l.effect&&n.setTranslate(v),"reset"!==b&&(n.transitionStart(s,b),n.transitionEnd(s,b)),!1;if(l.cssMode){const e=n.isHorizontal(),s=u?v:-v;if(0===t){const t=n.virtual&&n.params.virtual.enabled;t&&(n.wrapperEl.style.scrollSnapType="none",n._immediateVirtual=!0),h[e?"scrollLeft":"scrollTop"]=s,t&&requestAnimationFrame((()=>{n.wrapperEl.style.scrollSnapType="",n._swiperImmediateVirtual=!1}))}else{if(!n.support.smoothScroll)return w({swiper:n,targetPosition:s,side:e?"left":"top"}),!0;h.scrollTo({[e?"left":"top"]:s,behavior:"smooth"})}return!0}return n.setTransition(t),n.setTranslate(v),n.updateActiveIndex(r),n.updateSlidesClasses(),n.emit("beforeTransitionStart",t,i),n.transitionStart(s,b),0===t?n.transitionEnd(s,b):n.animating||(n.animating=!0,n.onSlideToWrapperTransitionEnd||(n.onSlideToWrapperTransitionEnd=function(e){n&&!n.destroyed&&e.target===this&&(n.$wrapperEl[0].removeEventListener("transitionend",n.onSlideToWrapperTransitionEnd),n.$wrapperEl[0].removeEventListener("webkitTransitionEnd",n.onSlideToWrapperTransitionEnd),n.onSlideToWrapperTransitionEnd=null,delete n.onSlideToWrapperTransitionEnd,n.transitionEnd(s,b))}),n.$wrapperEl[0].addEventListener("transitionend",n.onSlideToWrapperTransitionEnd),n.$wrapperEl[0].addEventListener("webkitTransitionEnd",n.onSlideToWrapperTransitionEnd)),!0},slideToLoop:function(e,t,s,i){if(void 0===e&&(e=0),void 0===t&&(t=this.params.speed),void 0===s&&(s=!0),"string"==typeof e){const t=parseInt(e,10);if(!isFinite(t))throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${e}] given.`);e=t}const a=this;let n=e;return a.params.loop&&(n+=a.loopedSlides),a.slideTo(n,t,s,i)},slideNext:function(e,t,s){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);const i=this,{animating:a,enabled:n,params:r}=i;if(!n)return i;let l=r.slidesPerGroup;"auto"===r.slidesPerView&&1===r.slidesPerGroup&&r.slidesPerGroupAuto&&(l=Math.max(i.slidesPerViewDynamic("current",!0),1));const o=i.activeIndex<r.slidesPerGroupSkip?1:l;if(r.loop){if(a&&r.loopPreventsSlide)return!1;i.loopFix(),i._clientLeft=i.$wrapperEl[0].clientLeft}return r.rewind&&i.isEnd?i.slideTo(0,e,t,s):i.slideTo(i.activeIndex+o,e,t,s)},slidePrev:function(e,t,s){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0);const i=this,{params:a,animating:n,snapGrid:r,slidesGrid:l,rtlTranslate:o,enabled:d}=i;if(!d)return i;if(a.loop){if(n&&a.loopPreventsSlide)return!1;i.loopFix(),i._clientLeft=i.$wrapperEl[0].clientLeft}function p(e){return e<0?-Math.floor(Math.abs(e)):Math.floor(e)}const c=p(o?i.translate:-i.translate),u=r.map((e=>p(e)));let h=r[u.indexOf(c)-1];if(void 0===h&&a.cssMode){let e;r.forEach(((t,s)=>{c>=t&&(e=s)})),void 0!==e&&(h=r[e>0?e-1:e])}let f=0;if(void 0!==h&&(f=l.indexOf(h),f<0&&(f=i.activeIndex-1),"auto"===a.slidesPerView&&1===a.slidesPerGroup&&a.slidesPerGroupAuto&&(f=f-i.slidesPerViewDynamic("previous",!0)+1,f=Math.max(f,0))),a.rewind&&i.isBeginning){const a=i.params.virtual&&i.params.virtual.enabled&&i.virtual?i.virtual.slides.length-1:i.slides.length-1;return i.slideTo(a,e,t,s)}return i.slideTo(f,e,t,s)},slideReset:function(e,t,s){return void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),this.slideTo(this.activeIndex,e,t,s)},slideToClosest:function(e,t,s,i){void 0===e&&(e=this.params.speed),void 0===t&&(t=!0),void 0===i&&(i=.5);const a=this;let n=a.activeIndex;const r=Math.min(a.params.slidesPerGroupSkip,n),l=r+Math.floor((n-r)/a.params.slidesPerGroup),o=a.rtlTranslate?a.translate:-a.translate;if(o>=a.snapGrid[l]){const e=a.snapGrid[l];o-e>(a.snapGrid[l+1]-e)*i&&(n+=a.params.slidesPerGroup)}else{const e=a.snapGrid[l-1];o-e<=(a.snapGrid[l]-e)*i&&(n-=a.params.slidesPerGroup)}return n=Math.max(n,0),n=Math.min(n,a.slidesGrid.length-1),a.slideTo(n,e,t,s)},slideToClickedSlide:function(){const e=this,{params:t,$wrapperEl:s}=e,i="auto"===t.slidesPerView?e.slidesPerViewDynamic():t.slidesPerView;let a,n=e.clickedIndex;if(t.loop){if(e.animating)return;a=parseInt(d(e.clickedSlide).attr("data-swiper-slide-index"),10),t.centeredSlides?n<e.loopedSlides-i/2||n>e.slides.length-e.loopedSlides+i/2?(e.loopFix(),n=s.children(`.${t.slideClass}[data-swiper-slide-index="${a}"]:not(.${t.slideDuplicateClass})`).eq(0).index(),c((()=>{e.slideTo(n)}))):e.slideTo(n):n>e.slides.length-i?(e.loopFix(),n=s.children(`.${t.slideClass}[data-swiper-slide-index="${a}"]:not(.${t.slideDuplicateClass})`).eq(0).index(),c((()=>{e.slideTo(n)}))):e.slideTo(n)}else e.slideTo(n)}};var L={loopCreate:function(){const e=this,t=i(),{params:s,$wrapperEl:a}=e,n=a.children().length>0?d(a.children()[0].parentNode):a;n.children(`.${s.slideClass}.${s.slideDuplicateClass}`).remove();let r=n.children(`.${s.slideClass}`);if(s.loopFillGroupWithBlank){const e=s.slidesPerGroup-r.length%s.slidesPerGroup;if(e!==s.slidesPerGroup){for(let i=0;i<e;i+=1){const e=d(t.createElement("div")).addClass(`${s.slideClass} ${s.slideBlankClass}`);n.append(e)}r=n.children(`.${s.slideClass}`)}}"auto"!==s.slidesPerView||s.loopedSlides||(s.loopedSlides=r.length),e.loopedSlides=Math.ceil(parseFloat(s.loopedSlides||s.slidesPerView,10)),e.loopedSlides+=s.loopAdditionalSlides,e.loopedSlides>r.length&&(e.loopedSlides=r.length);const l=[],o=[];r.each(((t,s)=>{const i=d(t);s<e.loopedSlides&&o.push(t),s<r.length&&s>=r.length-e.loopedSlides&&l.push(t),i.attr("data-swiper-slide-index",s)}));for(let e=0;e<o.length;e+=1)n.append(d(o[e].cloneNode(!0)).addClass(s.slideDuplicateClass));for(let e=l.length-1;e>=0;e-=1)n.prepend(d(l[e].cloneNode(!0)).addClass(s.slideDuplicateClass))},loopFix:function(){const e=this;e.emit("beforeLoopFix");const{activeIndex:t,slides:s,loopedSlides:i,allowSlidePrev:a,allowSlideNext:n,snapGrid:r,rtlTranslate:l}=e;let o;e.allowSlidePrev=!0,e.allowSlideNext=!0;const d=-r[t]-e.getTranslate();if(t<i){o=s.length-3*i+t,o+=i;e.slideTo(o,0,!1,!0)&&0!==d&&e.setTranslate((l?-e.translate:e.translate)-d)}else if(t>=s.length-i){o=-s.length+t+i,o+=i;e.slideTo(o,0,!1,!0)&&0!==d&&e.setTranslate((l?-e.translate:e.translate)-d)}e.allowSlidePrev=a,e.allowSlideNext=n,e.emit("loopFix")},loopDestroy:function(){const{$wrapperEl:e,params:t,slides:s}=this;e.children(`.${t.slideClass}.${t.slideDuplicateClass},.${t.slideClass}.${t.slideBlankClass}`).remove(),s.removeAttr("data-swiper-slide-index")}};function O(e){const t=this,s=i(),a=n(),r=t.touchEventsData,{params:l,touches:o,enabled:p}=t;if(!p)return;if(t.animating&&l.preventInteractionOnTransition)return;!t.animating&&l.cssMode&&l.loop&&t.loopFix();let c=e;c.originalEvent&&(c=c.originalEvent);let h=d(c.target);if("wrapper"===l.touchEventsTarget&&!h.closest(t.wrapperEl).length)return;if(r.isTouchEvent="touchstart"===c.type,!r.isTouchEvent&&"which"in c&&3===c.which)return;if(!r.isTouchEvent&&"button"in c&&c.button>0)return;if(r.isTouched&&r.isMoved)return;!!l.noSwipingClass&&""!==l.noSwipingClass&&c.target&&c.target.shadowRoot&&e.path&&e.path[0]&&(h=d(e.path[0]));const f=l.noSwipingSelector?l.noSwipingSelector:`.${l.noSwipingClass}`,m=!(!c.target||!c.target.shadowRoot);if(l.noSwiping&&(m?function(e,t){return void 0===t&&(t=this),function t(s){if(!s||s===i()||s===n())return null;s.assignedSlot&&(s=s.assignedSlot);const a=s.closest(e);return a||s.getRootNode?a||t(s.getRootNode().host):null}(t)}(f,h[0]):h.closest(f)[0]))return void(t.allowClick=!0);if(l.swipeHandler&&!h.closest(l.swipeHandler)[0])return;o.currentX="touchstart"===c.type?c.targetTouches[0].pageX:c.pageX,o.currentY="touchstart"===c.type?c.targetTouches[0].pageY:c.pageY;const g=o.currentX,v=o.currentY,w=l.edgeSwipeDetection||l.iOSEdgeSwipeDetection,b=l.edgeSwipeThreshold||l.iOSEdgeSwipeThreshold;if(w&&(g<=b||g>=a.innerWidth-b)){if("prevent"!==w)return;e.preventDefault()}if(Object.assign(r,{isTouched:!0,isMoved:!1,allowTouchCallbacks:!0,isScrolling:void 0,startMoving:void 0}),o.startX=g,o.startY=v,r.touchStartTime=u(),t.allowClick=!0,t.updateSize(),t.swipeDirection=void 0,l.threshold>0&&(r.allowThresholdMove=!1),"touchstart"!==c.type){let e=!0;h.is(r.focusableElements)&&(e=!1,"SELECT"===h[0].nodeName&&(r.isTouched=!1)),s.activeElement&&d(s.activeElement).is(r.focusableElements)&&s.activeElement!==h[0]&&s.activeElement.blur();const i=e&&t.allowTouchMove&&l.touchStartPreventDefault;!l.touchStartForcePreventDefault&&!i||h[0].isContentEditable||c.preventDefault()}t.params.freeMode&&t.params.freeMode.enabled&&t.freeMode&&t.animating&&!l.cssMode&&t.freeMode.onTouchStart(),t.emit("touchStart",c)}function z(e){const t=i(),s=this,a=s.touchEventsData,{params:n,touches:r,rtlTranslate:l,enabled:o}=s;if(!o)return;let p=e;if(p.originalEvent&&(p=p.originalEvent),!a.isTouched)return void(a.startMoving&&a.isScrolling&&s.emit("touchMoveOpposite",p));if(a.isTouchEvent&&"touchmove"!==p.type)return;const c="touchmove"===p.type&&p.targetTouches&&(p.targetTouches[0]||p.changedTouches[0]),h="touchmove"===p.type?c.pageX:p.pageX,f="touchmove"===p.type?c.pageY:p.pageY;if(p.preventedByNestedSwiper)return r.startX=h,void(r.startY=f);if(!s.allowTouchMove)return d(p.target).is(a.focusableElements)||(s.allowClick=!1),void(a.isTouched&&(Object.assign(r,{startX:h,startY:f,currentX:h,currentY:f}),a.touchStartTime=u()));if(a.isTouchEvent&&n.touchReleaseOnEdges&&!n.loop)if(s.isVertical()){if(f<r.startY&&s.translate<=s.maxTranslate()||f>r.startY&&s.translate>=s.minTranslate())return a.isTouched=!1,void(a.isMoved=!1)}else if(h<r.startX&&s.translate<=s.maxTranslate()||h>r.startX&&s.translate>=s.minTranslate())return;if(a.isTouchEvent&&t.activeElement&&p.target===t.activeElement&&d(p.target).is(a.focusableElements))return a.isMoved=!0,void(s.allowClick=!1);if(a.allowTouchCallbacks&&s.emit("touchMove",p),p.targetTouches&&p.targetTouches.length>1)return;r.currentX=h,r.currentY=f;const m=r.currentX-r.startX,g=r.currentY-r.startY;if(s.params.threshold&&Math.sqrt(m**2+g**2)<s.params.threshold)return;if(void 0===a.isScrolling){let e;s.isHorizontal()&&r.currentY===r.startY||s.isVertical()&&r.currentX===r.startX?a.isScrolling=!1:m*m+g*g>=25&&(e=180*Math.atan2(Math.abs(g),Math.abs(m))/Math.PI,a.isScrolling=s.isHorizontal()?e>n.touchAngle:90-e>n.touchAngle)}if(a.isScrolling&&s.emit("touchMoveOpposite",p),void 0===a.startMoving&&(r.currentX===r.startX&&r.currentY===r.startY||(a.startMoving=!0)),a.isScrolling)return void(a.isTouched=!1);if(!a.startMoving)return;s.allowClick=!1,!n.cssMode&&p.cancelable&&p.preventDefault(),n.touchMoveStopPropagation&&!n.nested&&p.stopPropagation(),a.isMoved||(n.loop&&!n.cssMode&&s.loopFix(),a.startTranslate=s.getTranslate(),s.setTransition(0),s.animating&&s.$wrapperEl.trigger("webkitTransitionEnd transitionend"),a.allowMomentumBounce=!1,!n.grabCursor||!0!==s.allowSlideNext&&!0!==s.allowSlidePrev||s.setGrabCursor(!0),s.emit("sliderFirstMove",p)),s.emit("sliderMove",p),a.isMoved=!0;let v=s.isHorizontal()?m:g;r.diff=v,v*=n.touchRatio,l&&(v=-v),s.swipeDirection=v>0?"prev":"next",a.currentTranslate=v+a.startTranslate;let w=!0,b=n.resistanceRatio;if(n.touchReleaseOnEdges&&(b=0),v>0&&a.currentTranslate>s.minTranslate()?(w=!1,n.resistance&&(a.currentTranslate=s.minTranslate()-1+(-s.minTranslate()+a.startTranslate+v)**b)):v<0&&a.currentTranslate<s.maxTranslate()&&(w=!1,n.resistance&&(a.currentTranslate=s.maxTranslate()+1-(s.maxTranslate()-a.startTranslate-v)**b)),w&&(p.preventedByNestedSwiper=!0),!s.allowSlideNext&&"next"===s.swipeDirection&&a.currentTranslate<a.startTranslate&&(a.currentTranslate=a.startTranslate),!s.allowSlidePrev&&"prev"===s.swipeDirection&&a.currentTranslate>a.startTranslate&&(a.currentTranslate=a.startTranslate),s.allowSlidePrev||s.allowSlideNext||(a.currentTranslate=a.startTranslate),n.threshold>0){if(!(Math.abs(v)>n.threshold||a.allowThresholdMove))return void(a.currentTranslate=a.startTranslate);if(!a.allowThresholdMove)return a.allowThresholdMove=!0,r.startX=r.currentX,r.startY=r.currentY,a.currentTranslate=a.startTranslate,void(r.diff=s.isHorizontal()?r.currentX-r.startX:r.currentY-r.startY)}n.followFinger&&!n.cssMode&&((n.freeMode&&n.freeMode.enabled&&s.freeMode||n.watchSlidesProgress)&&(s.updateActiveIndex(),s.updateSlidesClasses()),s.params.freeMode&&n.freeMode.enabled&&s.freeMode&&s.freeMode.onTouchMove(),s.updateProgress(a.currentTranslate),s.setTranslate(a.currentTranslate))}function A(e){const t=this,s=t.touchEventsData,{params:i,touches:a,rtlTranslate:n,slidesGrid:r,enabled:l}=t;if(!l)return;let o=e;if(o.originalEvent&&(o=o.originalEvent),s.allowTouchCallbacks&&t.emit("touchEnd",o),s.allowTouchCallbacks=!1,!s.isTouched)return s.isMoved&&i.grabCursor&&t.setGrabCursor(!1),s.isMoved=!1,void(s.startMoving=!1);i.grabCursor&&s.isMoved&&s.isTouched&&(!0===t.allowSlideNext||!0===t.allowSlidePrev)&&t.setGrabCursor(!1);const d=u(),p=d-s.touchStartTime;if(t.allowClick){const e=o.path||o.composedPath&&o.composedPath();t.updateClickedSlide(e&&e[0]||o.target),t.emit("tap click",o),p<300&&d-s.lastClickTime<300&&t.emit("doubleTap doubleClick",o)}if(s.lastClickTime=u(),c((()=>{t.destroyed||(t.allowClick=!0)})),!s.isTouched||!s.isMoved||!t.swipeDirection||0===a.diff||s.currentTranslate===s.startTranslate)return s.isTouched=!1,s.isMoved=!1,void(s.startMoving=!1);let h;if(s.isTouched=!1,s.isMoved=!1,s.startMoving=!1,h=i.followFinger?n?t.translate:-t.translate:-s.currentTranslate,i.cssMode)return;if(t.params.freeMode&&i.freeMode.enabled)return void t.freeMode.onTouchEnd({currentPos:h});let f=0,m=t.slidesSizesGrid[0];for(let e=0;e<r.length;e+=e<i.slidesPerGroupSkip?1:i.slidesPerGroup){const t=e<i.slidesPerGroupSkip-1?1:i.slidesPerGroup;void 0!==r[e+t]?h>=r[e]&&h<r[e+t]&&(f=e,m=r[e+t]-r[e]):h>=r[e]&&(f=e,m=r[r.length-1]-r[r.length-2])}let g=null,v=null;i.rewind&&(t.isBeginning?v=t.params.virtual&&t.params.virtual.enabled&&t.virtual?t.virtual.slides.length-1:t.slides.length-1:t.isEnd&&(g=0));const w=(h-r[f])/m,b=f<i.slidesPerGroupSkip-1?1:i.slidesPerGroup;if(p>i.longSwipesMs){if(!i.longSwipes)return void t.slideTo(t.activeIndex);"next"===t.swipeDirection&&(w>=i.longSwipesRatio?t.slideTo(i.rewind&&t.isEnd?g:f+b):t.slideTo(f)),"prev"===t.swipeDirection&&(w>1-i.longSwipesRatio?t.slideTo(f+b):null!==v&&w<0&&Math.abs(w)>i.longSwipesRatio?t.slideTo(v):t.slideTo(f))}else{if(!i.shortSwipes)return void t.slideTo(t.activeIndex);t.navigation&&(o.target===t.navigation.nextEl||o.target===t.navigation.prevEl)?o.target===t.navigation.nextEl?t.slideTo(f+b):t.slideTo(f):("next"===t.swipeDirection&&t.slideTo(null!==g?g:f+b),"prev"===t.swipeDirection&&t.slideTo(null!==v?v:f))}}function I(){const e=this,{params:t,el:s}=e;if(s&&0===s.offsetWidth)return;t.breakpoints&&e.setBreakpoint();const{allowSlideNext:i,allowSlidePrev:a,snapGrid:n}=e;e.allowSlideNext=!0,e.allowSlidePrev=!0,e.updateSize(),e.updateSlides(),e.updateSlidesClasses(),("auto"===t.slidesPerView||t.slidesPerView>1)&&e.isEnd&&!e.isBeginning&&!e.params.centeredSlides?e.slideTo(e.slides.length-1,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0),e.autoplay&&e.autoplay.running&&e.autoplay.paused&&e.autoplay.run(),e.allowSlidePrev=a,e.allowSlideNext=i,e.params.watchOverflow&&n!==e.snapGrid&&e.checkOverflow()}function D(e){const t=this;t.enabled&&(t.allowClick||(t.params.preventClicks&&e.preventDefault(),t.params.preventClicksPropagation&&t.animating&&(e.stopPropagation(),e.stopImmediatePropagation())))}function G(){const e=this,{wrapperEl:t,rtlTranslate:s,enabled:i}=e;if(!i)return;let a;e.previousTranslate=e.translate,e.isHorizontal()?e.translate=-t.scrollLeft:e.translate=-t.scrollTop,0===e.translate&&(e.translate=0),e.updateActiveIndex(),e.updateSlidesClasses();const n=e.maxTranslate()-e.minTranslate();a=0===n?0:(e.translate-e.minTranslate())/n,a!==e.progress&&e.updateProgress(s?-e.translate:e.translate),e.emit("setTranslate",e.translate,!1)}let N=!1;function B(){}const H=(e,t)=>{const s=i(),{params:a,touchEvents:n,el:r,wrapperEl:l,device:o,support:d}=e,p=!!a.nested,c="on"===t?"addEventListener":"removeEventListener",u=t;if(d.touch){const t=!("touchstart"!==n.start||!d.passiveListener||!a.passiveListeners)&&{passive:!0,capture:!1};r[c](n.start,e.onTouchStart,t),r[c](n.move,e.onTouchMove,d.passiveListener?{passive:!1,capture:p}:p),r[c](n.end,e.onTouchEnd,t),n.cancel&&r[c](n.cancel,e.onTouchEnd,t)}else r[c](n.start,e.onTouchStart,!1),s[c](n.move,e.onTouchMove,p),s[c](n.end,e.onTouchEnd,!1);(a.preventClicks||a.preventClicksPropagation)&&r[c]("click",e.onClick,!0),a.cssMode&&l[c]("scroll",e.onScroll),a.updateOnWindowResize?e[u](o.ios||o.android?"resize orientationchange observerUpdate":"resize observerUpdate",I,!0):e[u]("observerUpdate",I,!0)};var _={attachEvents:function(){const e=this,t=i(),{params:s,support:a}=e;e.onTouchStart=O.bind(e),e.onTouchMove=z.bind(e),e.onTouchEnd=A.bind(e),s.cssMode&&(e.onScroll=G.bind(e)),e.onClick=D.bind(e),a.touch&&!N&&(t.addEventListener("touchstart",B),N=!0),H(e,"on")},detachEvents:function(){H(this,"off")}};const j=(e,t)=>e.grid&&t.grid&&t.grid.rows>1;var F={addClasses:function(){const e=this,{classNames:t,params:s,rtl:i,$el:a,device:n,support:r}=e,l=function(e,t){const s=[];return e.forEach((e=>{"object"==typeof e?Object.keys(e).forEach((i=>{e[i]&&s.push(t+i)})):"string"==typeof e&&s.push(t+e)})),s}(["initialized",s.direction,{"pointer-events":!r.touch},{"free-mode":e.params.freeMode&&s.freeMode.enabled},{autoheight:s.autoHeight},{rtl:i},{grid:s.grid&&s.grid.rows>1},{"grid-column":s.grid&&s.grid.rows>1&&"column"===s.grid.fill},{android:n.android},{ios:n.ios},{"css-mode":s.cssMode},{centered:s.cssMode&&s.centeredSlides},{"watch-progress":s.watchSlidesProgress}],s.containerModifierClass);t.push(...l),a.addClass([...t].join(" ")),e.emitContainerClasses()},removeClasses:function(){const{$el:e,classNames:t}=this;e.removeClass(t.join(" ")),this.emitContainerClasses()}};var V={init:!0,direction:"horizontal",touchEventsTarget:"wrapper",initialSlide:0,speed:300,cssMode:!1,updateOnWindowResize:!0,resizeObserver:!0,nested:!1,createElements:!1,enabled:!0,focusableElements:"input, select, option, textarea, button, video, label",width:null,height:null,preventInteractionOnTransition:!1,userAgent:null,url:null,edgeSwipeDetection:!1,edgeSwipeThreshold:20,autoHeight:!1,setWrapperSize:!1,virtualTranslate:!1,effect:"slide",breakpoints:void 0,breakpointsBase:"window",spaceBetween:0,slidesPerView:1,slidesPerGroup:1,slidesPerGroupSkip:0,slidesPerGroupAuto:!1,centeredSlides:!1,centeredSlidesBounds:!1,slidesOffsetBefore:0,slidesOffsetAfter:0,normalizeSlideIndex:!0,centerInsufficientSlides:!1,watchOverflow:!0,roundLengths:!1,touchRatio:1,touchAngle:45,simulateTouch:!0,shortSwipes:!0,longSwipes:!0,longSwipesRatio:.5,longSwipesMs:300,followFinger:!0,allowTouchMove:!0,threshold:0,touchMoveStopPropagation:!1,touchStartPreventDefault:!0,touchStartForcePreventDefault:!1,touchReleaseOnEdges:!1,uniqueNavElements:!0,resistance:!0,resistanceRatio:.85,watchSlidesProgress:!1,grabCursor:!1,preventClicks:!0,preventClicksPropagation:!0,slideToClickedSlide:!1,preloadImages:!0,updateOnImagesReady:!0,loop:!1,loopAdditionalSlides:0,loopedSlides:null,loopFillGroupWithBlank:!1,loopPreventsSlide:!0,rewind:!1,allowSlidePrev:!0,allowSlideNext:!0,swipeHandler:null,noSwiping:!0,noSwipingClass:"swiper-no-swiping",noSwipingSelector:null,passiveListeners:!0,maxBackfaceHiddenSlides:10,containerModifierClass:"swiper-",slideClass:"swiper-slide",slideBlankClass:"swiper-slide-invisible-blank",slideActiveClass:"swiper-slide-active",slideDuplicateActiveClass:"swiper-slide-duplicate-active",slideVisibleClass:"swiper-slide-visible",slideDuplicateClass:"swiper-slide-duplicate",slideNextClass:"swiper-slide-next",slideDuplicateNextClass:"swiper-slide-duplicate-next",slidePrevClass:"swiper-slide-prev",slideDuplicatePrevClass:"swiper-slide-duplicate-prev",wrapperClass:"swiper-wrapper",runCallbacksOnInit:!0,_emitClasses:!1};function R(e,t){return function(s){void 0===s&&(s={});const i=Object.keys(s)[0],a=s[i];"object"==typeof a&&null!==a?(["navigation","pagination","scrollbar"].indexOf(i)>=0&&!0===e[i]&&(e[i]={auto:!0}),i in e&&"enabled"in a?(!0===e[i]&&(e[i]={enabled:!0}),"object"!=typeof e[i]||"enabled"in e[i]||(e[i].enabled=!0),e[i]||(e[i]={enabled:!1}),g(t,s)):g(t,s)):g(t,s)}}const W={eventsEmitter:E,update:$,translate:M,transition:{setTransition:function(e,t){const s=this;s.params.cssMode||s.$wrapperEl.transition(e),s.emit("setTransition",e,t)},transitionStart:function(e,t){void 0===e&&(e=!0);const s=this,{params:i}=s;i.cssMode||(i.autoHeight&&s.updateAutoHeight(),k({swiper:s,runCallbacks:e,direction:t,step:"Start"}))},transitionEnd:function(e,t){void 0===e&&(e=!0);const s=this,{params:i}=s;s.animating=!1,i.cssMode||(s.setTransition(0),k({swiper:s,runCallbacks:e,direction:t,step:"End"}))}},slide:P,loop:L,grabCursor:{setGrabCursor:function(e){const t=this;if(t.support.touch||!t.params.simulateTouch||t.params.watchOverflow&&t.isLocked||t.params.cssMode)return;const s="container"===t.params.touchEventsTarget?t.el:t.wrapperEl;s.style.cursor="move",s.style.cursor=e?"grabbing":"grab"},unsetGrabCursor:function(){const e=this;e.support.touch||e.params.watchOverflow&&e.isLocked||e.params.cssMode||(e["container"===e.params.touchEventsTarget?"el":"wrapperEl"].style.cursor="")}},events:_,breakpoints:{setBreakpoint:function(){const e=this,{activeIndex:t,initialized:s,loopedSlides:i=0,params:a,$el:n}=e,r=a.breakpoints;if(!r||r&&0===Object.keys(r).length)return;const l=e.getBreakpoint(r,e.params.breakpointsBase,e.el);if(!l||e.currentBreakpoint===l)return;const o=(l in r?r[l]:void 0)||e.originalParams,d=j(e,a),p=j(e,o),c=a.enabled;d&&!p?(n.removeClass(`${a.containerModifierClass}grid ${a.containerModifierClass}grid-column`),e.emitContainerClasses()):!d&&p&&(n.addClass(`${a.containerModifierClass}grid`),(o.grid.fill&&"column"===o.grid.fill||!o.grid.fill&&"column"===a.grid.fill)&&n.addClass(`${a.containerModifierClass}grid-column`),e.emitContainerClasses()),["navigation","pagination","scrollbar"].forEach((t=>{const s=a[t]&&a[t].enabled,i=o[t]&&o[t].enabled;s&&!i&&e[t].disable(),!s&&i&&e[t].enable()}));const u=o.direction&&o.direction!==a.direction,h=a.loop&&(o.slidesPerView!==a.slidesPerView||u);u&&s&&e.changeDirection(),g(e.params,o);const f=e.params.enabled;Object.assign(e,{allowTouchMove:e.params.allowTouchMove,allowSlideNext:e.params.allowSlideNext,allowSlidePrev:e.params.allowSlidePrev}),c&&!f?e.disable():!c&&f&&e.enable(),e.currentBreakpoint=l,e.emit("_beforeBreakpoint",o),h&&s&&(e.loopDestroy(),e.loopCreate(),e.updateSlides(),e.slideTo(t-i+e.loopedSlides,0,!1)),e.emit("breakpoint",o)},getBreakpoint:function(e,t,s){if(void 0===t&&(t="window"),!e||"container"===t&&!s)return;let i=!1;const a=n(),r="window"===t?a.innerHeight:s.clientHeight,l=Object.keys(e).map((e=>{if("string"==typeof e&&0===e.indexOf("@")){const t=parseFloat(e.substr(1));return{value:r*t,point:e}}return{value:e,point:e}}));l.sort(((e,t)=>parseInt(e.value,10)-parseInt(t.value,10)));for(let e=0;e<l.length;e+=1){const{point:n,value:r}=l[e];"window"===t?a.matchMedia(`(min-width: ${r}px)`).matches&&(i=n):r<=s.clientWidth&&(i=n)}return i||"max"}},checkOverflow:{checkOverflow:function(){const e=this,{isLocked:t,params:s}=e,{slidesOffsetBefore:i}=s;if(i){const t=e.slides.length-1,s=e.slidesGrid[t]+e.slidesSizesGrid[t]+2*i;e.isLocked=e.size>s}else e.isLocked=1===e.snapGrid.length;!0===s.allowSlideNext&&(e.allowSlideNext=!e.isLocked),!0===s.allowSlidePrev&&(e.allowSlidePrev=!e.isLocked),t&&t!==e.isLocked&&(e.isEnd=!1),t!==e.isLocked&&e.emit(e.isLocked?"lock":"unlock")}},classes:F,images:{loadImage:function(e,t,s,i,a,r){const l=n();let o;function p(){r&&r()}d(e).parent("picture")[0]||e.complete&&a?p():t?(o=new l.Image,o.onload=p,o.onerror=p,i&&(o.sizes=i),s&&(o.srcset=s),t&&(o.src=t)):p()},preloadImages:function(){const e=this;function t(){null!=e&&e&&!e.destroyed&&(void 0!==e.imagesLoaded&&(e.imagesLoaded+=1),e.imagesLoaded===e.imagesToLoad.length&&(e.params.updateOnImagesReady&&e.update(),e.emit("imagesReady")))}e.imagesToLoad=e.$el.find("img");for(let s=0;s<e.imagesToLoad.length;s+=1){const i=e.imagesToLoad[s];e.loadImage(i,i.currentSrc||i.getAttribute("src"),i.srcset||i.getAttribute("srcset"),i.sizes||i.getAttribute("sizes"),!0,t)}}}},q={};class X{constructor(){let e,t;for(var s=arguments.length,i=new Array(s),a=0;a<s;a++)i[a]=arguments[a];if(1===i.length&&i[0].constructor&&"Object"===Object.prototype.toString.call(i[0]).slice(8,-1)?t=i[0]:[e,t]=i,t||(t={}),t=g({},t),e&&!t.el&&(t.el=e),t.el&&d(t.el).length>1){const e=[];return d(t.el).each((s=>{const i=g({},t,{el:s});e.push(new X(i))})),e}const n=this;n.__swiper__=!0,n.support=T(),n.device=x({userAgent:t.userAgent}),n.browser=S(),n.eventsListeners={},n.eventsAnyListeners=[],n.modules=[...n.__modules__],t.modules&&Array.isArray(t.modules)&&n.modules.push(...t.modules);const r={};n.modules.forEach((e=>{e({swiper:n,extendParams:R(t,r),on:n.on.bind(n),once:n.once.bind(n),off:n.off.bind(n),emit:n.emit.bind(n)})}));const l=g({},V,r);return n.params=g({},l,q,t),n.originalParams=g({},n.params),n.passedParams=g({},t),n.params&&n.params.on&&Object.keys(n.params.on).forEach((e=>{n.on(e,n.params.on[e])})),n.params&&n.params.onAny&&n.onAny(n.params.onAny),n.$=d,Object.assign(n,{enabled:n.params.enabled,el:e,classNames:[],slides:d(),slidesGrid:[],snapGrid:[],slidesSizesGrid:[],isHorizontal:()=>"horizontal"===n.params.direction,isVertical:()=>"vertical"===n.params.direction,activeIndex:0,realIndex:0,isBeginning:!0,isEnd:!1,translate:0,previousTranslate:0,progress:0,velocity:0,animating:!1,allowSlideNext:n.params.allowSlideNext,allowSlidePrev:n.params.allowSlidePrev,touchEvents:function(){const e=["touchstart","touchmove","touchend","touchcancel"],t=["pointerdown","pointermove","pointerup"];return n.touchEventsTouch={start:e[0],move:e[1],end:e[2],cancel:e[3]},n.touchEventsDesktop={start:t[0],move:t[1],end:t[2]},n.support.touch||!n.params.simulateTouch?n.touchEventsTouch:n.touchEventsDesktop}(),touchEventsData:{isTouched:void 0,isMoved:void 0,allowTouchCallbacks:void 0,touchStartTime:void 0,isScrolling:void 0,currentTranslate:void 0,startTranslate:void 0,allowThresholdMove:void 0,focusableElements:n.params.focusableElements,lastClickTime:u(),clickTimeout:void 0,velocities:[],allowMomentumBounce:void 0,isTouchEvent:void 0,startMoving:void 0},allowClick:!0,allowTouchMove:n.params.allowTouchMove,touches:{startX:0,startY:0,currentX:0,currentY:0,diff:0},imagesToLoad:[],imagesLoaded:0}),n.emit("_swiper"),n.params.init&&n.init(),n}enable(){const e=this;e.enabled||(e.enabled=!0,e.params.grabCursor&&e.setGrabCursor(),e.emit("enable"))}disable(){const e=this;e.enabled&&(e.enabled=!1,e.params.grabCursor&&e.unsetGrabCursor(),e.emit("disable"))}setProgress(e,t){const s=this;e=Math.min(Math.max(e,0),1);const i=s.minTranslate(),a=(s.maxTranslate()-i)*e+i;s.translateTo(a,void 0===t?0:t),s.updateActiveIndex(),s.updateSlidesClasses()}emitContainerClasses(){const e=this;if(!e.params._emitClasses||!e.el)return;const t=e.el.className.split(" ").filter((t=>0===t.indexOf("swiper")||0===t.indexOf(e.params.containerModifierClass)));e.emit("_containerClasses",t.join(" "))}getSlideClasses(e){const t=this;return t.destroyed?"":e.className.split(" ").filter((e=>0===e.indexOf("swiper-slide")||0===e.indexOf(t.params.slideClass))).join(" ")}emitSlidesClasses(){const e=this;if(!e.params._emitClasses||!e.el)return;const t=[];e.slides.each((s=>{const i=e.getSlideClasses(s);t.push({slideEl:s,classNames:i}),e.emit("_slideClass",s,i)})),e.emit("_slideClasses",t)}slidesPerViewDynamic(e,t){void 0===e&&(e="current"),void 0===t&&(t=!1);const{params:s,slides:i,slidesGrid:a,slidesSizesGrid:n,size:r,activeIndex:l}=this;let o=1;if(s.centeredSlides){let e,t=i[l].swiperSlideSize;for(let s=l+1;s<i.length;s+=1)i[s]&&!e&&(t+=i[s].swiperSlideSize,o+=1,t>r&&(e=!0));for(let s=l-1;s>=0;s-=1)i[s]&&!e&&(t+=i[s].swiperSlideSize,o+=1,t>r&&(e=!0))}else if("current"===e)for(let e=l+1;e<i.length;e+=1){(t?a[e]+n[e]-a[l]<r:a[e]-a[l]<r)&&(o+=1)}else for(let e=l-1;e>=0;e-=1){a[l]-a[e]<r&&(o+=1)}return o}update(){const e=this;if(!e||e.destroyed)return;const{snapGrid:t,params:s}=e;function i(){const t=e.rtlTranslate?-1*e.translate:e.translate,s=Math.min(Math.max(t,e.maxTranslate()),e.minTranslate());e.setTranslate(s),e.updateActiveIndex(),e.updateSlidesClasses()}let a;s.breakpoints&&e.setBreakpoint(),e.updateSize(),e.updateSlides(),e.updateProgress(),e.updateSlidesClasses(),e.params.freeMode&&e.params.freeMode.enabled?(i(),e.params.autoHeight&&e.updateAutoHeight()):(a=("auto"===e.params.slidesPerView||e.params.slidesPerView>1)&&e.isEnd&&!e.params.centeredSlides?e.slideTo(e.slides.length-1,0,!1,!0):e.slideTo(e.activeIndex,0,!1,!0),a||i()),s.watchOverflow&&t!==e.snapGrid&&e.checkOverflow(),e.emit("update")}changeDirection(e,t){void 0===t&&(t=!0);const s=this,i=s.params.direction;return e||(e="horizontal"===i?"vertical":"horizontal"),e===i||"horizontal"!==e&&"vertical"!==e||(s.$el.removeClass(`${s.params.containerModifierClass}${i}`).addClass(`${s.params.containerModifierClass}${e}`),s.emitContainerClasses(),s.params.direction=e,s.slides.each((t=>{"vertical"===e?t.style.width="":t.style.height=""})),s.emit("changeDirection"),t&&s.update()),s}changeLanguageDirection(e){const t=this;t.rtl&&"rtl"===e||!t.rtl&&"ltr"===e||(t.rtl="rtl"===e,t.rtlTranslate="horizontal"===t.params.direction&&t.rtl,t.rtl?(t.$el.addClass(`${t.params.containerModifierClass}rtl`),t.el.dir="rtl"):(t.$el.removeClass(`${t.params.containerModifierClass}rtl`),t.el.dir="ltr"),t.update())}mount(e){const t=this;if(t.mounted)return!0;const s=d(e||t.params.el);if(!(e=s[0]))return!1;e.swiper=t;const a=()=>`.${(t.params.wrapperClass||"").trim().split(" ").join(".")}`;let n=(()=>{if(e&&e.shadowRoot&&e.shadowRoot.querySelector){const t=d(e.shadowRoot.querySelector(a()));return t.children=e=>s.children(e),t}return s.children?s.children(a()):d(s).children(a())})();if(0===n.length&&t.params.createElements){const e=i().createElement("div");n=d(e),e.className=t.params.wrapperClass,s.append(e),s.children(`.${t.params.slideClass}`).each((e=>{n.append(e)}))}return Object.assign(t,{$el:s,el:e,$wrapperEl:n,wrapperEl:n[0],mounted:!0,rtl:"rtl"===e.dir.toLowerCase()||"rtl"===s.css("direction"),rtlTranslate:"horizontal"===t.params.direction&&("rtl"===e.dir.toLowerCase()||"rtl"===s.css("direction")),wrongRTL:"-webkit-box"===n.css("display")}),!0}init(e){const t=this;if(t.initialized)return t;return!1===t.mount(e)||(t.emit("beforeInit"),t.params.breakpoints&&t.setBreakpoint(),t.addClasses(),t.params.loop&&t.loopCreate(),t.updateSize(),t.updateSlides(),t.params.watchOverflow&&t.checkOverflow(),t.params.grabCursor&&t.enabled&&t.setGrabCursor(),t.params.preloadImages&&t.preloadImages(),t.params.loop?t.slideTo(t.params.initialSlide+t.loopedSlides,0,t.params.runCallbacksOnInit,!1,!0):t.slideTo(t.params.initialSlide,0,t.params.runCallbacksOnInit,!1,!0),t.attachEvents(),t.initialized=!0,t.emit("init"),t.emit("afterInit")),t}destroy(e,t){void 0===e&&(e=!0),void 0===t&&(t=!0);const s=this,{params:i,$el:a,$wrapperEl:n,slides:r}=s;return void 0===s.params||s.destroyed||(s.emit("beforeDestroy"),s.initialized=!1,s.detachEvents(),i.loop&&s.loopDestroy(),t&&(s.removeClasses(),a.removeAttr("style"),n.removeAttr("style"),r&&r.length&&r.removeClass([i.slideVisibleClass,i.slideActiveClass,i.slideNextClass,i.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index")),s.emit("destroy"),Object.keys(s.eventsListeners).forEach((e=>{s.off(e)})),!1!==e&&(s.$el[0].swiper=null,function(e){const t=e;Object.keys(t).forEach((e=>{try{t[e]=null}catch(e){}try{delete t[e]}catch(e){}}))}(s)),s.destroyed=!0),null}static extendDefaults(e){g(q,e)}static get extendedDefaults(){return q}static get defaults(){return V}static installModule(e){X.prototype.__modules__||(X.prototype.__modules__=[]);const t=X.prototype.__modules__;"function"==typeof e&&t.indexOf(e)<0&&t.push(e)}static use(e){return Array.isArray(e)?(e.forEach((e=>X.installModule(e))),X):(X.installModule(e),X)}}function Y(e,t,s,a){const n=i();return e.params.createElements&&Object.keys(a).forEach((i=>{if(!s[i]&&!0===s.auto){let r=e.$el.children(`.${a[i]}`)[0];r||(r=n.createElement("div"),r.className=a[i],e.$el.append(r)),s[i]=r,t[i]=r}})),s}function U(e){return void 0===e&&(e=""),`.${e.trim().replace(/([\.:!\/])/g,"\\$1").replace(/ /g,".")}`}function K(e){const t=this,{$wrapperEl:s,params:i}=t;if(i.loop&&t.loopDestroy(),"object"==typeof e&&"length"in e)for(let t=0;t<e.length;t+=1)e[t]&&s.append(e[t]);else s.append(e);i.loop&&t.loopCreate(),i.observer||t.update()}function Z(e){const t=this,{params:s,$wrapperEl:i,activeIndex:a}=t;s.loop&&t.loopDestroy();let n=a+1;if("object"==typeof e&&"length"in e){for(let t=0;t<e.length;t+=1)e[t]&&i.prepend(e[t]);n=a+e.length}else i.prepend(e);s.loop&&t.loopCreate(),s.observer||t.update(),t.slideTo(n,0,!1)}function J(e,t){const s=this,{$wrapperEl:i,params:a,activeIndex:n}=s;let r=n;a.loop&&(r-=s.loopedSlides,s.loopDestroy(),s.slides=i.children(`.${a.slideClass}`));const l=s.slides.length;if(e<=0)return void s.prependSlide(t);if(e>=l)return void s.appendSlide(t);let o=r>e?r+1:r;const d=[];for(let t=l-1;t>=e;t-=1){const e=s.slides.eq(t);e.remove(),d.unshift(e)}if("object"==typeof t&&"length"in t){for(let e=0;e<t.length;e+=1)t[e]&&i.append(t[e]);o=r>e?r+t.length:r}else i.append(t);for(let e=0;e<d.length;e+=1)i.append(d[e]);a.loop&&s.loopCreate(),a.observer||s.update(),a.loop?s.slideTo(o+s.loopedSlides,0,!1):s.slideTo(o,0,!1)}function Q(e){const t=this,{params:s,$wrapperEl:i,activeIndex:a}=t;let n=a;s.loop&&(n-=t.loopedSlides,t.loopDestroy(),t.slides=i.children(`.${s.slideClass}`));let r,l=n;if("object"==typeof e&&"length"in e){for(let s=0;s<e.length;s+=1)r=e[s],t.slides[r]&&t.slides.eq(r).remove(),r<l&&(l-=1);l=Math.max(l,0)}else r=e,t.slides[r]&&t.slides.eq(r).remove(),r<l&&(l-=1),l=Math.max(l,0);s.loop&&t.loopCreate(),s.observer||t.update(),s.loop?t.slideTo(l+t.loopedSlides,0,!1):t.slideTo(l,0,!1)}function ee(){const e=this,t=[];for(let s=0;s<e.slides.length;s+=1)t.push(s);e.removeSlide(t)}function te(e,t){return e.transformEl?t.find(e.transformEl).css({"backface-visibility":"hidden","-webkit-backface-visibility":"hidden"}):t}Object.keys(W).forEach((e=>{Object.keys(W[e]).forEach((t=>{X.prototype[t]=W[e][t]}))})),X.use([function(e){let{swiper:t,on:s,emit:i}=e;const a=n();let r=null,l=null;const o=()=>{t&&!t.destroyed&&t.initialized&&(i("beforeResize"),i("resize"))},d=()=>{t&&!t.destroyed&&t.initialized&&i("orientationchange")};s("init",(()=>{t.params.resizeObserver&&void 0!==a.ResizeObserver?t&&!t.destroyed&&t.initialized&&(r=new ResizeObserver((e=>{l=a.requestAnimationFrame((()=>{const{width:s,height:i}=t;let a=s,n=i;e.forEach((e=>{let{contentBoxSize:s,contentRect:i,target:r}=e;r&&r!==t.el||(a=i?i.width:(s[0]||s).inlineSize,n=i?i.height:(s[0]||s).blockSize)})),a===s&&n===i||o()}))})),r.observe(t.el)):(a.addEventListener("resize",o),a.addEventListener("orientationchange",d))})),s("destroy",(()=>{l&&a.cancelAnimationFrame(l),r&&r.unobserve&&t.el&&(r.unobserve(t.el),r=null),a.removeEventListener("resize",o),a.removeEventListener("orientationchange",d)}))},function(e){let{swiper:t,extendParams:s,on:i,emit:a}=e;const r=[],l=n(),o=function(e,t){void 0===t&&(t={});const s=new(l.MutationObserver||l.WebkitMutationObserver)((e=>{if(1===e.length)return void a("observerUpdate",e[0]);const t=function(){a("observerUpdate",e[0])};l.requestAnimationFrame?l.requestAnimationFrame(t):l.setTimeout(t,0)}));s.observe(e,{attributes:void 0===t.attributes||t.attributes,childList:void 0===t.childList||t.childList,characterData:void 0===t.characterData||t.characterData}),r.push(s)};s({observer:!1,observeParents:!1,observeSlideChildren:!1}),i("init",(()=>{if(t.params.observer){if(t.params.observeParents){const e=t.$el.parents();for(let t=0;t<e.length;t+=1)o(e[t])}o(t.$el[0],{childList:t.params.observeSlideChildren}),o(t.$wrapperEl[0],{attributes:!1})}})),i("destroy",(()=>{r.forEach((e=>{e.disconnect()})),r.splice(0,r.length)}))}]);const se=[function(e){let t,{swiper:s,extendParams:i,on:a,emit:n}=e;function r(e,t){const i=s.params.virtual;if(i.cache&&s.virtual.cache[t])return s.virtual.cache[t];const a=i.renderSlide?d(i.renderSlide.call(s,e,t)):d(`<div class="${s.params.slideClass}" data-swiper-slide-index="${t}">${e}</div>`);return a.attr("data-swiper-slide-index")||a.attr("data-swiper-slide-index",t),i.cache&&(s.virtual.cache[t]=a),a}function l(e){const{slidesPerView:t,slidesPerGroup:i,centeredSlides:a}=s.params,{addSlidesBefore:l,addSlidesAfter:o}=s.params.virtual,{from:d,to:p,slides:c,slidesGrid:u,offset:h}=s.virtual;s.params.cssMode||s.updateActiveIndex();const f=s.activeIndex||0;let m,g,v;m=s.rtlTranslate?"right":s.isHorizontal()?"left":"top",a?(g=Math.floor(t/2)+i+o,v=Math.floor(t/2)+i+l):(g=t+(i-1)+o,v=i+l);const w=Math.max((f||0)-v,0),b=Math.min((f||0)+g,c.length-1),y=(s.slidesGrid[w]||0)-(s.slidesGrid[0]||0);function C(){s.updateSlides(),s.updateProgress(),s.updateSlidesClasses(),s.lazy&&s.params.lazy.enabled&&s.lazy.load(),n("virtualUpdate")}if(Object.assign(s.virtual,{from:w,to:b,offset:y,slidesGrid:s.slidesGrid}),d===w&&p===b&&!e)return s.slidesGrid!==u&&y!==h&&s.slides.css(m,`${y}px`),s.updateProgress(),void n("virtualUpdate");if(s.params.virtual.renderExternal)return s.params.virtual.renderExternal.call(s,{offset:y,from:w,to:b,slides:function(){const e=[];for(let t=w;t<=b;t+=1)e.push(c[t]);return e}()}),void(s.params.virtual.renderExternalUpdate?C():n("virtualUpdate"));const T=[],x=[];if(e)s.$wrapperEl.find(`.${s.params.slideClass}`).remove();else for(let e=d;e<=p;e+=1)(e<w||e>b)&&s.$wrapperEl.find(`.${s.params.slideClass}[data-swiper-slide-index="${e}"]`).remove();for(let t=0;t<c.length;t+=1)t>=w&&t<=b&&(void 0===p||e?x.push(t):(t>p&&x.push(t),t<d&&T.push(t)));x.forEach((e=>{s.$wrapperEl.append(r(c[e],e))})),T.sort(((e,t)=>t-e)).forEach((e=>{s.$wrapperEl.prepend(r(c[e],e))})),s.$wrapperEl.children(".swiper-slide").css(m,`${y}px`),C()}i({virtual:{enabled:!1,slides:[],cache:!0,renderSlide:null,renderExternal:null,renderExternalUpdate:!0,addSlidesBefore:0,addSlidesAfter:0}}),s.virtual={cache:{},from:void 0,to:void 0,slides:[],offset:0,slidesGrid:[]},a("beforeInit",(()=>{s.params.virtual.enabled&&(s.virtual.slides=s.params.virtual.slides,s.classNames.push(`${s.params.containerModifierClass}virtual`),s.params.watchSlidesProgress=!0,s.originalParams.watchSlidesProgress=!0,s.params.initialSlide||l())})),a("setTranslate",(()=>{s.params.virtual.enabled&&(s.params.cssMode&&!s._immediateVirtual?(clearTimeout(t),t=setTimeout((()=>{l()}),100)):l())})),a("init update resize",(()=>{s.params.virtual.enabled&&s.params.cssMode&&v(s.wrapperEl,"--swiper-virtual-size",`${s.virtualSize}px`)})),Object.assign(s.virtual,{appendSlide:function(e){if("object"==typeof e&&"length"in e)for(let t=0;t<e.length;t+=1)e[t]&&s.virtual.slides.push(e[t]);else s.virtual.slides.push(e);l(!0)},prependSlide:function(e){const t=s.activeIndex;let i=t+1,a=1;if(Array.isArray(e)){for(let t=0;t<e.length;t+=1)e[t]&&s.virtual.slides.unshift(e[t]);i=t+e.length,a=e.length}else s.virtual.slides.unshift(e);if(s.params.virtual.cache){const e=s.virtual.cache,t={};Object.keys(e).forEach((s=>{const i=e[s],n=i.attr("data-swiper-slide-index");n&&i.attr("data-swiper-slide-index",parseInt(n,10)+a),t[parseInt(s,10)+a]=i})),s.virtual.cache=t}l(!0),s.slideTo(i,0)},removeSlide:function(e){if(null==e)return;let t=s.activeIndex;if(Array.isArray(e))for(let i=e.length-1;i>=0;i-=1)s.virtual.slides.splice(e[i],1),s.params.virtual.cache&&delete s.virtual.cache[e[i]],e[i]<t&&(t-=1),t=Math.max(t,0);else s.virtual.slides.splice(e,1),s.params.virtual.cache&&delete s.virtual.cache[e],e<t&&(t-=1),t=Math.max(t,0);l(!0),s.slideTo(t,0)},removeAllSlides:function(){s.virtual.slides=[],s.params.virtual.cache&&(s.virtual.cache={}),l(!0),s.slideTo(0,0)},update:l})},function(e){let{swiper:t,extendParams:s,on:a,emit:r}=e;const l=i(),o=n();function p(e){if(!t.enabled)return;const{rtlTranslate:s}=t;let i=e;i.originalEvent&&(i=i.originalEvent);const a=i.keyCode||i.charCode,n=t.params.keyboard.pageUpDown,d=n&&33===a,p=n&&34===a,c=37===a,u=39===a,h=38===a,f=40===a;if(!t.allowSlideNext&&(t.isHorizontal()&&u||t.isVertical()&&f||p))return!1;if(!t.allowSlidePrev&&(t.isHorizontal()&&c||t.isVertical()&&h||d))return!1;if(!(i.shiftKey||i.altKey||i.ctrlKey||i.metaKey||l.activeElement&&l.activeElement.nodeName&&("input"===l.activeElement.nodeName.toLowerCase()||"textarea"===l.activeElement.nodeName.toLowerCase()))){if(t.params.keyboard.onlyInViewport&&(d||p||c||u||h||f)){let e=!1;if(t.$el.parents(`.${t.params.slideClass}`).length>0&&0===t.$el.parents(`.${t.params.slideActiveClass}`).length)return;const i=t.$el,a=i[0].clientWidth,n=i[0].clientHeight,r=o.innerWidth,l=o.innerHeight,d=t.$el.offset();s&&(d.left-=t.$el[0].scrollLeft);const p=[[d.left,d.top],[d.left+a,d.top],[d.left,d.top+n],[d.left+a,d.top+n]];for(let t=0;t<p.length;t+=1){const s=p[t];if(s[0]>=0&&s[0]<=r&&s[1]>=0&&s[1]<=l){if(0===s[0]&&0===s[1])continue;e=!0}}if(!e)return}t.isHorizontal()?((d||p||c||u)&&(i.preventDefault?i.preventDefault():i.returnValue=!1),((p||u)&&!s||(d||c)&&s)&&t.slideNext(),((d||c)&&!s||(p||u)&&s)&&t.slidePrev()):((d||p||h||f)&&(i.preventDefault?i.preventDefault():i.returnValue=!1),(p||f)&&t.slideNext(),(d||h)&&t.slidePrev()),r("keyPress",a)}}function c(){t.keyboard.enabled||(d(l).on("keydown",p),t.keyboard.enabled=!0)}function u(){t.keyboard.enabled&&(d(l).off("keydown",p),t.keyboard.enabled=!1)}t.keyboard={enabled:!1},s({keyboard:{enabled:!1,onlyInViewport:!0,pageUpDown:!0}}),a("init",(()=>{t.params.keyboard.enabled&&c()})),a("destroy",(()=>{t.keyboard.enabled&&u()})),Object.assign(t.keyboard,{enable:c,disable:u})},function(e){let{swiper:t,extendParams:s,on:i,emit:a}=e;const r=n();let l;s({mousewheel:{enabled:!1,releaseOnEdges:!1,invert:!1,forceToAxis:!1,sensitivity:1,eventsTarget:"container",thresholdDelta:null,thresholdTime:null}}),t.mousewheel={enabled:!1};let o,p=u();const h=[];function f(){t.enabled&&(t.mouseEntered=!0)}function m(){t.enabled&&(t.mouseEntered=!1)}function g(e){return!(t.params.mousewheel.thresholdDelta&&e.delta<t.params.mousewheel.thresholdDelta)&&(!(t.params.mousewheel.thresholdTime&&u()-p<t.params.mousewheel.thresholdTime)&&(e.delta>=6&&u()-p<60||(e.direction<0?t.isEnd&&!t.params.loop||t.animating||(t.slideNext(),a("scroll",e.raw)):t.isBeginning&&!t.params.loop||t.animating||(t.slidePrev(),a("scroll",e.raw)),p=(new r.Date).getTime(),!1)))}function v(e){let s=e,i=!0;if(!t.enabled)return;const n=t.params.mousewheel;t.params.cssMode&&s.preventDefault();let r=t.$el;if("container"!==t.params.mousewheel.eventsTarget&&(r=d(t.params.mousewheel.eventsTarget)),!t.mouseEntered&&!r[0].contains(s.target)&&!n.releaseOnEdges)return!0;s.originalEvent&&(s=s.originalEvent);let p=0;const f=t.rtlTranslate?-1:1,m=function(e){let t=0,s=0,i=0,a=0;return"detail"in e&&(s=e.detail),"wheelDelta"in e&&(s=-e.wheelDelta/120),"wheelDeltaY"in e&&(s=-e.wheelDeltaY/120),"wheelDeltaX"in e&&(t=-e.wheelDeltaX/120),"axis"in e&&e.axis===e.HORIZONTAL_AXIS&&(t=s,s=0),i=10*t,a=10*s,"deltaY"in e&&(a=e.deltaY),"deltaX"in e&&(i=e.deltaX),e.shiftKey&&!i&&(i=a,a=0),(i||a)&&e.deltaMode&&(1===e.deltaMode?(i*=40,a*=40):(i*=800,a*=800)),i&&!t&&(t=i<1?-1:1),a&&!s&&(s=a<1?-1:1),{spinX:t,spinY:s,pixelX:i,pixelY:a}}(s);if(n.forceToAxis)if(t.isHorizontal()){if(!(Math.abs(m.pixelX)>Math.abs(m.pixelY)))return!0;p=-m.pixelX*f}else{if(!(Math.abs(m.pixelY)>Math.abs(m.pixelX)))return!0;p=-m.pixelY}else p=Math.abs(m.pixelX)>Math.abs(m.pixelY)?-m.pixelX*f:-m.pixelY;if(0===p)return!0;n.invert&&(p=-p);let v=t.getTranslate()+p*n.sensitivity;if(v>=t.minTranslate()&&(v=t.minTranslate()),v<=t.maxTranslate()&&(v=t.maxTranslate()),i=!!t.params.loop||!(v===t.minTranslate()||v===t.maxTranslate()),i&&t.params.nested&&s.stopPropagation(),t.params.freeMode&&t.params.freeMode.enabled){const e={time:u(),delta:Math.abs(p),direction:Math.sign(p)},i=o&&e.time<o.time+500&&e.delta<=o.delta&&e.direction===o.direction;if(!i){o=void 0,t.params.loop&&t.loopFix();let r=t.getTranslate()+p*n.sensitivity;const d=t.isBeginning,u=t.isEnd;if(r>=t.minTranslate()&&(r=t.minTranslate()),r<=t.maxTranslate()&&(r=t.maxTranslate()),t.setTransition(0),t.setTranslate(r),t.updateProgress(),t.updateActiveIndex(),t.updateSlidesClasses(),(!d&&t.isBeginning||!u&&t.isEnd)&&t.updateSlidesClasses(),t.params.freeMode.sticky){clearTimeout(l),l=void 0,h.length>=15&&h.shift();const s=h.length?h[h.length-1]:void 0,i=h[0];if(h.push(e),s&&(e.delta>s.delta||e.direction!==s.direction))h.splice(0);else if(h.length>=15&&e.time-i.time<500&&i.delta-e.delta>=1&&e.delta<=6){const s=p>0?.8:.2;o=e,h.splice(0),l=c((()=>{t.slideToClosest(t.params.speed,!0,void 0,s)}),0)}l||(l=c((()=>{o=e,h.splice(0),t.slideToClosest(t.params.speed,!0,void 0,.5)}),500))}if(i||a("scroll",s),t.params.autoplay&&t.params.autoplayDisableOnInteraction&&t.autoplay.stop(),r===t.minTranslate()||r===t.maxTranslate())return!0}}else{const s={time:u(),delta:Math.abs(p),direction:Math.sign(p),raw:e};h.length>=2&&h.shift();const i=h.length?h[h.length-1]:void 0;if(h.push(s),i?(s.direction!==i.direction||s.delta>i.delta||s.time>i.time+150)&&g(s):g(s),function(e){const s=t.params.mousewheel;if(e.direction<0){if(t.isEnd&&!t.params.loop&&s.releaseOnEdges)return!0}else if(t.isBeginning&&!t.params.loop&&s.releaseOnEdges)return!0;return!1}(s))return!0}return s.preventDefault?s.preventDefault():s.returnValue=!1,!1}function w(e){let s=t.$el;"container"!==t.params.mousewheel.eventsTarget&&(s=d(t.params.mousewheel.eventsTarget)),s[e]("mouseenter",f),s[e]("mouseleave",m),s[e]("wheel",v)}function b(){return t.params.cssMode?(t.wrapperEl.removeEventListener("wheel",v),!0):!t.mousewheel.enabled&&(w("on"),t.mousewheel.enabled=!0,!0)}function y(){return t.params.cssMode?(t.wrapperEl.addEventListener(event,v),!0):!!t.mousewheel.enabled&&(w("off"),t.mousewheel.enabled=!1,!0)}i("init",(()=>{!t.params.mousewheel.enabled&&t.params.cssMode&&y(),t.params.mousewheel.enabled&&b()})),i("destroy",(()=>{t.params.cssMode&&b(),t.mousewheel.enabled&&y()})),Object.assign(t.mousewheel,{enable:b,disable:y})},function(e){let{swiper:t,extendParams:s,on:i,emit:a}=e;function n(e){let s;return e&&(s=d(e),t.params.uniqueNavElements&&"string"==typeof e&&s.length>1&&1===t.$el.find(e).length&&(s=t.$el.find(e))),s}function r(e,s){const i=t.params.navigation;e&&e.length>0&&(e[s?"addClass":"removeClass"](i.disabledClass),e[0]&&"BUTTON"===e[0].tagName&&(e[0].disabled=s),t.params.watchOverflow&&t.enabled&&e[t.isLocked?"addClass":"removeClass"](i.lockClass))}function l(){if(t.params.loop)return;const{$nextEl:e,$prevEl:s}=t.navigation;r(s,t.isBeginning&&!t.params.rewind),r(e,t.isEnd&&!t.params.rewind)}function o(e){e.preventDefault(),(!t.isBeginning||t.params.loop||t.params.rewind)&&(t.slidePrev(),a("navigationPrev"))}function p(e){e.preventDefault(),(!t.isEnd||t.params.loop||t.params.rewind)&&(t.slideNext(),a("navigationNext"))}function c(){const e=t.params.navigation;if(t.params.navigation=Y(t,t.originalParams.navigation,t.params.navigation,{nextEl:"swiper-button-next",prevEl:"swiper-button-prev"}),!e.nextEl&&!e.prevEl)return;const s=n(e.nextEl),i=n(e.prevEl);s&&s.length>0&&s.on("click",p),i&&i.length>0&&i.on("click",o),Object.assign(t.navigation,{$nextEl:s,nextEl:s&&s[0],$prevEl:i,prevEl:i&&i[0]}),t.enabled||(s&&s.addClass(e.lockClass),i&&i.addClass(e.lockClass))}function u(){const{$nextEl:e,$prevEl:s}=t.navigation;e&&e.length&&(e.off("click",p),e.removeClass(t.params.navigation.disabledClass)),s&&s.length&&(s.off("click",o),s.removeClass(t.params.navigation.disabledClass))}s({navigation:{nextEl:null,prevEl:null,hideOnClick:!1,disabledClass:"swiper-button-disabled",hiddenClass:"swiper-button-hidden",lockClass:"swiper-button-lock",navigationDisabledClass:"swiper-navigation-disabled"}}),t.navigation={nextEl:null,$nextEl:null,prevEl:null,$prevEl:null},i("init",(()=>{!1===t.params.navigation.enabled?h():(c(),l())})),i("toEdge fromEdge lock unlock",(()=>{l()})),i("destroy",(()=>{u()})),i("enable disable",(()=>{const{$nextEl:e,$prevEl:s}=t.navigation;e&&e[t.enabled?"removeClass":"addClass"](t.params.navigation.lockClass),s&&s[t.enabled?"removeClass":"addClass"](t.params.navigation.lockClass)})),i("click",((e,s)=>{const{$nextEl:i,$prevEl:n}=t.navigation,r=s.target;if(t.params.navigation.hideOnClick&&!d(r).is(n)&&!d(r).is(i)){if(t.pagination&&t.params.pagination&&t.params.pagination.clickable&&(t.pagination.el===r||t.pagination.el.contains(r)))return;let e;i?e=i.hasClass(t.params.navigation.hiddenClass):n&&(e=n.hasClass(t.params.navigation.hiddenClass)),a(!0===e?"navigationShow":"navigationHide"),i&&i.toggleClass(t.params.navigation.hiddenClass),n&&n.toggleClass(t.params.navigation.hiddenClass)}}));const h=()=>{t.$el.addClass(t.params.navigation.navigationDisabledClass),u()};Object.assign(t.navigation,{enable:()=>{t.$el.removeClass(t.params.navigation.navigationDisabledClass),c(),l()},disable:h,update:l,init:c,destroy:u})},function(e){let{swiper:t,extendParams:s,on:i,emit:a}=e;const n="swiper-pagination";let r;s({pagination:{el:null,bulletElement:"span",clickable:!1,hideOnClick:!1,renderBullet:null,renderProgressbar:null,renderFraction:null,renderCustom:null,progressbarOpposite:!1,type:"bullets",dynamicBullets:!1,dynamicMainBullets:1,formatFractionCurrent:e=>e,formatFractionTotal:e=>e,bulletClass:`${n}-bullet`,bulletActiveClass:`${n}-bullet-active`,modifierClass:`${n}-`,currentClass:`${n}-current`,totalClass:`${n}-total`,hiddenClass:`${n}-hidden`,progressbarFillClass:`${n}-progressbar-fill`,progressbarOppositeClass:`${n}-progressbar-opposite`,clickableClass:`${n}-clickable`,lockClass:`${n}-lock`,horizontalClass:`${n}-horizontal`,verticalClass:`${n}-vertical`,paginationDisabledClass:`${n}-disabled`}}),t.pagination={el:null,$el:null,bullets:[]};let l=0;function o(){return!t.params.pagination.el||!t.pagination.el||!t.pagination.$el||0===t.pagination.$el.length}function p(e,s){const{bulletActiveClass:i}=t.params.pagination;e[s]().addClass(`${i}-${s}`)[s]().addClass(`${i}-${s}-${s}`)}function c(){const e=t.rtl,s=t.params.pagination;if(o())return;const i=t.virtual&&t.params.virtual.enabled?t.virtual.slides.length:t.slides.length,n=t.pagination.$el;let c;const u=t.params.loop?Math.ceil((i-2*t.loopedSlides)/t.params.slidesPerGroup):t.snapGrid.length;if(t.params.loop?(c=Math.ceil((t.activeIndex-t.loopedSlides)/t.params.slidesPerGroup),c>i-1-2*t.loopedSlides&&(c-=i-2*t.loopedSlides),c>u-1&&(c-=u),c<0&&"bullets"!==t.params.paginationType&&(c=u+c)):c=void 0!==t.snapIndex?t.snapIndex:t.activeIndex||0,"bullets"===s.type&&t.pagination.bullets&&t.pagination.bullets.length>0){const i=t.pagination.bullets;let a,o,u;if(s.dynamicBullets&&(r=i.eq(0)[t.isHorizontal()?"outerWidth":"outerHeight"](!0),n.css(t.isHorizontal()?"width":"height",r*(s.dynamicMainBullets+4)+"px"),s.dynamicMainBullets>1&&void 0!==t.previousIndex&&(l+=c-(t.previousIndex-t.loopedSlides||0),l>s.dynamicMainBullets-1?l=s.dynamicMainBullets-1:l<0&&(l=0)),a=Math.max(c-l,0),o=a+(Math.min(i.length,s.dynamicMainBullets)-1),u=(o+a)/2),i.removeClass(["","-next","-next-next","-prev","-prev-prev","-main"].map((e=>`${s.bulletActiveClass}${e}`)).join(" ")),n.length>1)i.each((e=>{const t=d(e),i=t.index();i===c&&t.addClass(s.bulletActiveClass),s.dynamicBullets&&(i>=a&&i<=o&&t.addClass(`${s.bulletActiveClass}-main`),i===a&&p(t,"prev"),i===o&&p(t,"next"))}));else{const e=i.eq(c),n=e.index();if(e.addClass(s.bulletActiveClass),s.dynamicBullets){const e=i.eq(a),r=i.eq(o);for(let e=a;e<=o;e+=1)i.eq(e).addClass(`${s.bulletActiveClass}-main`);if(t.params.loop)if(n>=i.length){for(let e=s.dynamicMainBullets;e>=0;e-=1)i.eq(i.length-e).addClass(`${s.bulletActiveClass}-main`);i.eq(i.length-s.dynamicMainBullets-1).addClass(`${s.bulletActiveClass}-prev`)}else p(e,"prev"),p(r,"next");else p(e,"prev"),p(r,"next")}}if(s.dynamicBullets){const a=Math.min(i.length,s.dynamicMainBullets+4),n=(r*a-r)/2-u*r,l=e?"right":"left";i.css(t.isHorizontal()?l:"top",`${n}px`)}}if("fraction"===s.type&&(n.find(U(s.currentClass)).text(s.formatFractionCurrent(c+1)),n.find(U(s.totalClass)).text(s.formatFractionTotal(u))),"progressbar"===s.type){let e;e=s.progressbarOpposite?t.isHorizontal()?"vertical":"horizontal":t.isHorizontal()?"horizontal":"vertical";const i=(c+1)/u;let a=1,r=1;"horizontal"===e?a=i:r=i,n.find(U(s.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${a}) scaleY(${r})`).transition(t.params.speed)}"custom"===s.type&&s.renderCustom?(n.html(s.renderCustom(t,c+1,u)),a("paginationRender",n[0])):a("paginationUpdate",n[0]),t.params.watchOverflow&&t.enabled&&n[t.isLocked?"addClass":"removeClass"](s.lockClass)}function u(){const e=t.params.pagination;if(o())return;const s=t.virtual&&t.params.virtual.enabled?t.virtual.slides.length:t.slides.length,i=t.pagination.$el;let n="";if("bullets"===e.type){let a=t.params.loop?Math.ceil((s-2*t.loopedSlides)/t.params.slidesPerGroup):t.snapGrid.length;t.params.freeMode&&t.params.freeMode.enabled&&!t.params.loop&&a>s&&(a=s);for(let s=0;s<a;s+=1)e.renderBullet?n+=e.renderBullet.call(t,s,e.bulletClass):n+=`<${e.bulletElement} class="${e.bulletClass}"></${e.bulletElement}>`;i.html(n),t.pagination.bullets=i.find(U(e.bulletClass))}"fraction"===e.type&&(n=e.renderFraction?e.renderFraction.call(t,e.currentClass,e.totalClass):`<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`,i.html(n)),"progressbar"===e.type&&(n=e.renderProgressbar?e.renderProgressbar.call(t,e.progressbarFillClass):`<span class="${e.progressbarFillClass}"></span>`,i.html(n)),"custom"!==e.type&&a("paginationRender",t.pagination.$el[0])}function h(){t.params.pagination=Y(t,t.originalParams.pagination,t.params.pagination,{el:"swiper-pagination"});const e=t.params.pagination;if(!e.el)return;let s=d(e.el);0!==s.length&&(t.params.uniqueNavElements&&"string"==typeof e.el&&s.length>1&&(s=t.$el.find(e.el),s.length>1&&(s=s.filter((e=>d(e).parents(".swiper")[0]===t.el)))),"bullets"===e.type&&e.clickable&&s.addClass(e.clickableClass),s.addClass(e.modifierClass+e.type),s.addClass(t.isHorizontal()?e.horizontalClass:e.verticalClass),"bullets"===e.type&&e.dynamicBullets&&(s.addClass(`${e.modifierClass}${e.type}-dynamic`),l=0,e.dynamicMainBullets<1&&(e.dynamicMainBullets=1)),"progressbar"===e.type&&e.progressbarOpposite&&s.addClass(e.progressbarOppositeClass),e.clickable&&s.on("click",U(e.bulletClass),(function(e){e.preventDefault();let s=d(this).index()*t.params.slidesPerGroup;t.params.loop&&(s+=t.loopedSlides),t.slideTo(s)})),Object.assign(t.pagination,{$el:s,el:s[0]}),t.enabled||s.addClass(e.lockClass))}function f(){const e=t.params.pagination;if(o())return;const s=t.pagination.$el;s.removeClass(e.hiddenClass),s.removeClass(e.modifierClass+e.type),s.removeClass(t.isHorizontal()?e.horizontalClass:e.verticalClass),t.pagination.bullets&&t.pagination.bullets.removeClass&&t.pagination.bullets.removeClass(e.bulletActiveClass),e.clickable&&s.off("click",U(e.bulletClass))}i("init",(()=>{!1===t.params.pagination.enabled?m():(h(),u(),c())})),i("activeIndexChange",(()=>{(t.params.loop||void 0===t.snapIndex)&&c()})),i("snapIndexChange",(()=>{t.params.loop||c()})),i("slidesLengthChange",(()=>{t.params.loop&&(u(),c())})),i("snapGridLengthChange",(()=>{t.params.loop||(u(),c())})),i("destroy",(()=>{f()})),i("enable disable",(()=>{const{$el:e}=t.pagination;e&&e[t.enabled?"removeClass":"addClass"](t.params.pagination.lockClass)})),i("lock unlock",(()=>{c()})),i("click",((e,s)=>{const i=s.target,{$el:n}=t.pagination;if(t.params.pagination.el&&t.params.pagination.hideOnClick&&n&&n.length>0&&!d(i).hasClass(t.params.pagination.bulletClass)){if(t.navigation&&(t.navigation.nextEl&&i===t.navigation.nextEl||t.navigation.prevEl&&i===t.navigation.prevEl))return;const e=n.hasClass(t.params.pagination.hiddenClass);a(!0===e?"paginationShow":"paginationHide"),n.toggleClass(t.params.pagination.hiddenClass)}}));const m=()=>{t.$el.addClass(t.params.pagination.paginationDisabledClass),t.pagination.$el&&t.pagination.$el.addClass(t.params.pagination.paginationDisabledClass),f()};Object.assign(t.pagination,{enable:()=>{t.$el.removeClass(t.params.pagination.paginationDisabledClass),t.pagination.$el&&t.pagination.$el.removeClass(t.params.pagination.paginationDisabledClass),h(),u(),c()},disable:m,render:u,update:c,init:h,destroy:f})},function(e){let{swiper:t,extendParams:s,on:i,emit:a}=e;s({lazy:{checkInView:!1,enabled:!1,loadPrevNext:!1,loadPrevNextAmount:1,loadOnTransitionStart:!1,scrollingElement:"",elementClass:"swiper-lazy",loadingClass:"swiper-lazy-loading",loadedClass:"swiper-lazy-loaded",preloaderClass:"swiper-lazy-preloader"}}),t.lazy={};let r=!1,l=!1;function o(e,s){void 0===s&&(s=!0);const i=t.params.lazy;if(void 0===e)return;if(0===t.slides.length)return;const n=t.virtual&&t.params.virtual.enabled?t.$wrapperEl.children(`.${t.params.slideClass}[data-swiper-slide-index="${e}"]`):t.slides.eq(e),r=n.find(`.${i.elementClass}:not(.${i.loadedClass}):not(.${i.loadingClass})`);!n.hasClass(i.elementClass)||n.hasClass(i.loadedClass)||n.hasClass(i.loadingClass)||r.push(n[0]),0!==r.length&&r.each((e=>{const r=d(e);r.addClass(i.loadingClass);const l=r.attr("data-background"),p=r.attr("data-src"),c=r.attr("data-srcset"),u=r.attr("data-sizes"),h=r.parent("picture");t.loadImage(r[0],p||l,c,u,!1,(()=>{if(null!=t&&t&&(!t||t.params)&&!t.destroyed){if(l?(r.css("background-image",`url("${l}")`),r.removeAttr("data-background")):(c&&(r.attr("srcset",c),r.removeAttr("data-srcset")),u&&(r.attr("sizes",u),r.removeAttr("data-sizes")),h.length&&h.children("source").each((e=>{const t=d(e);t.attr("data-srcset")&&(t.attr("srcset",t.attr("data-srcset")),t.removeAttr("data-srcset"))})),p&&(r.attr("src",p),r.removeAttr("data-src"))),r.addClass(i.loadedClass).removeClass(i.loadingClass),n.find(`.${i.preloaderClass}`).remove(),t.params.loop&&s){const e=n.attr("data-swiper-slide-index");if(n.hasClass(t.params.slideDuplicateClass)){o(t.$wrapperEl.children(`[data-swiper-slide-index="${e}"]:not(.${t.params.slideDuplicateClass})`).index(),!1)}else{o(t.$wrapperEl.children(`.${t.params.slideDuplicateClass}[data-swiper-slide-index="${e}"]`).index(),!1)}}a("lazyImageReady",n[0],r[0]),t.params.autoHeight&&t.updateAutoHeight()}})),a("lazyImageLoad",n[0],r[0])}))}function p(){const{$wrapperEl:e,params:s,slides:i,activeIndex:a}=t,n=t.virtual&&s.virtual.enabled,r=s.lazy;let p=s.slidesPerView;function c(t){if(n){if(e.children(`.${s.slideClass}[data-swiper-slide-index="${t}"]`).length)return!0}else if(i[t])return!0;return!1}function u(e){return n?d(e).attr("data-swiper-slide-index"):d(e).index()}if("auto"===p&&(p=0),l||(l=!0),t.params.watchSlidesProgress)e.children(`.${s.slideVisibleClass}`).each((e=>{o(n?d(e).attr("data-swiper-slide-index"):d(e).index())}));else if(p>1)for(let e=a;e<a+p;e+=1)c(e)&&o(e);else o(a);if(r.loadPrevNext)if(p>1||r.loadPrevNextAmount&&r.loadPrevNextAmount>1){const e=r.loadPrevNextAmount,t=Math.ceil(p),s=Math.min(a+t+Math.max(e,t),i.length),n=Math.max(a-Math.max(t,e),0);for(let e=a+t;e<s;e+=1)c(e)&&o(e);for(let e=n;e<a;e+=1)c(e)&&o(e)}else{const t=e.children(`.${s.slideNextClass}`);t.length>0&&o(u(t));const i=e.children(`.${s.slidePrevClass}`);i.length>0&&o(u(i))}}function c(){const e=n();if(!t||t.destroyed)return;const s=t.params.lazy.scrollingElement?d(t.params.lazy.scrollingElement):d(e),i=s[0]===e,a=i?e.innerWidth:s[0].offsetWidth,l=i?e.innerHeight:s[0].offsetHeight,o=t.$el.offset(),{rtlTranslate:u}=t;let h=!1;u&&(o.left-=t.$el[0].scrollLeft);const f=[[o.left,o.top],[o.left+t.width,o.top],[o.left,o.top+t.height],[o.left+t.width,o.top+t.height]];for(let e=0;e<f.length;e+=1){const t=f[e];if(t[0]>=0&&t[0]<=a&&t[1]>=0&&t[1]<=l){if(0===t[0]&&0===t[1])continue;h=!0}}const m=!("touchstart"!==t.touchEvents.start||!t.support.passiveListener||!t.params.passiveListeners)&&{passive:!0,capture:!1};h?(p(),s.off("scroll",c,m)):r||(r=!0,s.on("scroll",c,m))}i("beforeInit",(()=>{t.params.lazy.enabled&&t.params.preloadImages&&(t.params.preloadImages=!1)})),i("init",(()=>{t.params.lazy.enabled&&(t.params.lazy.checkInView?c():p())})),i("scroll",(()=>{t.params.freeMode&&t.params.freeMode.enabled&&!t.params.freeMode.sticky&&p()})),i("scrollbarDragMove resize _freeModeNoMomentumRelease",(()=>{t.params.lazy.enabled&&(t.params.lazy.checkInView?c():p())})),i("transitionStart",(()=>{t.params.lazy.enabled&&(t.params.lazy.loadOnTransitionStart||!t.params.lazy.loadOnTransitionStart&&!l)&&(t.params.lazy.checkInView?c():p())})),i("transitionEnd",(()=>{t.params.lazy.enabled&&!t.params.lazy.loadOnTransitionStart&&(t.params.lazy.checkInView?c():p())})),i("slideChange",(()=>{const{lazy:e,cssMode:s,watchSlidesProgress:i,touchReleaseOnEdges:a,resistanceRatio:n}=t.params;e.enabled&&(s||i&&(a||0===n))&&p()})),i("destroy",(()=>{t.$el&&t.$el.find(`.${t.params.lazy.loadingClass}`).removeClass(t.params.lazy.loadingClass)})),Object.assign(t.lazy,{load:p,loadInSlide:o})},function(e){let{swiper:t,extendParams:s,on:i}=e;function a(e,t){const s=function(){let e,t,s;return(i,a)=>{for(t=-1,e=i.length;e-t>1;)s=e+t>>1,i[s]<=a?t=s:e=s;return e}}();let i,a;return this.x=e,this.y=t,this.lastIndex=e.length-1,this.interpolate=function(e){return e?(a=s(this.x,e),i=a-1,(e-this.x[i])*(this.y[a]-this.y[i])/(this.x[a]-this.x[i])+this.y[i]):0},this}function n(){t.controller.control&&t.controller.spline&&(t.controller.spline=void 0,delete t.controller.spline)}s({controller:{control:void 0,inverse:!1,by:"slide"}}),t.controller={control:void 0},i("beforeInit",(()=>{t.controller.control=t.params.controller.control})),i("update",(()=>{n()})),i("resize",(()=>{n()})),i("observerUpdate",(()=>{n()})),i("setTranslate",((e,s,i)=>{t.controller.control&&t.controller.setTranslate(s,i)})),i("setTransition",((e,s,i)=>{t.controller.control&&t.controller.setTransition(s,i)})),Object.assign(t.controller,{setTranslate:function(e,s){const i=t.controller.control;let n,r;const l=t.constructor;function o(e){const s=t.rtlTranslate?-t.translate:t.translate;"slide"===t.params.controller.by&&(!function(e){t.controller.spline||(t.controller.spline=t.params.loop?new a(t.slidesGrid,e.slidesGrid):new a(t.snapGrid,e.snapGrid))}(e),r=-t.controller.spline.interpolate(-s)),r&&"container"!==t.params.controller.by||(n=(e.maxTranslate()-e.minTranslate())/(t.maxTranslate()-t.minTranslate()),r=(s-t.minTranslate())*n+e.minTranslate()),t.params.controller.inverse&&(r=e.maxTranslate()-r),e.updateProgress(r),e.setTranslate(r,t),e.updateActiveIndex(),e.updateSlidesClasses()}if(Array.isArray(i))for(let e=0;e<i.length;e+=1)i[e]!==s&&i[e]instanceof l&&o(i[e]);else i instanceof l&&s!==i&&o(i)},setTransition:function(e,s){const i=t.constructor,a=t.controller.control;let n;function r(s){s.setTransition(e,t),0!==e&&(s.transitionStart(),s.params.autoHeight&&c((()=>{s.updateAutoHeight()})),s.$wrapperEl.transitionEnd((()=>{a&&(s.params.loop&&"slide"===t.params.controller.by&&s.loopFix(),s.transitionEnd())})))}if(Array.isArray(a))for(n=0;n<a.length;n+=1)a[n]!==s&&a[n]instanceof i&&r(a[n]);else a instanceof i&&s!==a&&r(a)}})},function(e){let{swiper:t,extendParams:s,on:i}=e;s({a11y:{enabled:!0,notificationClass:"swiper-notification",prevSlideMessage:"Previous slide",nextSlideMessage:"Next slide",firstSlideMessage:"This is the first slide",lastSlideMessage:"This is the last slide",paginationBulletMessage:"Go to slide {{index}}",slideLabelMessage:"{{index}} / {{slidesLength}}",containerMessage:null,containerRoleDescriptionMessage:null,itemRoleDescriptionMessage:null,slideRole:"group",id:null}});let a=null;function n(e){const t=a;0!==t.length&&(t.html(""),t.html(e))}function r(e){e.attr("tabIndex","0")}function l(e){e.attr("tabIndex","-1")}function o(e,t){e.attr("role",t)}function p(e,t){e.attr("aria-roledescription",t)}function c(e,t){e.attr("aria-label",t)}function u(e){e.attr("aria-disabled",!0)}function h(e){e.attr("aria-disabled",!1)}function f(e){if(13!==e.keyCode&&32!==e.keyCode)return;const s=t.params.a11y,i=d(e.target);t.navigation&&t.navigation.$nextEl&&i.is(t.navigation.$nextEl)&&(t.isEnd&&!t.params.loop||t.slideNext(),t.isEnd?n(s.lastSlideMessage):n(s.nextSlideMessage)),t.navigation&&t.navigation.$prevEl&&i.is(t.navigation.$prevEl)&&(t.isBeginning&&!t.params.loop||t.slidePrev(),t.isBeginning?n(s.firstSlideMessage):n(s.prevSlideMessage)),t.pagination&&i.is(U(t.params.pagination.bulletClass))&&i[0].click()}function m(){return t.pagination&&t.pagination.bullets&&t.pagination.bullets.length}function g(){return m()&&t.params.pagination.clickable}const v=(e,t,s)=>{r(e),"BUTTON"!==e[0].tagName&&(o(e,"button"),e.on("keydown",f)),c(e,s),function(e,t){e.attr("aria-controls",t)}(e,t)},w=e=>{const s=e.target.closest(`.${t.params.slideClass}`);if(!s||!t.slides.includes(s))return;const i=t.slides.indexOf(s)===t.activeIndex,a=t.params.watchSlidesProgress&&t.visibleSlides&&t.visibleSlides.includes(s);i||a||t.slideTo(t.slides.indexOf(s),0)},b=()=>{const e=t.params.a11y;e.itemRoleDescriptionMessage&&p(d(t.slides),e.itemRoleDescriptionMessage),e.slideRole&&o(d(t.slides),e.slideRole);const s=t.params.loop?t.slides.filter((e=>!e.classList.contains(t.params.slideDuplicateClass))).length:t.slides.length;e.slideLabelMessage&&t.slides.each(((i,a)=>{const n=d(i),r=t.params.loop?parseInt(n.attr("data-swiper-slide-index"),10):a;c(n,e.slideLabelMessage.replace(/\{\{index\}\}/,r+1).replace(/\{\{slidesLength\}\}/,s))}))},y=()=>{const e=t.params.a11y;t.$el.append(a);const s=t.$el;e.containerRoleDescriptionMessage&&p(s,e.containerRoleDescriptionMessage),e.containerMessage&&c(s,e.containerMessage);const i=t.$wrapperEl,n=e.id||i.attr("id")||`swiper-wrapper-${r=16,void 0===r&&(r=16),"x".repeat(r).replace(/x/g,(()=>Math.round(16*Math.random()).toString(16)))}`;var r;const l=t.params.autoplay&&t.params.autoplay.enabled?"off":"polite";var o;let d,u;o=n,i.attr("id",o),function(e,t){e.attr("aria-live",t)}(i,l),b(),t.navigation&&t.navigation.$nextEl&&(d=t.navigation.$nextEl),t.navigation&&t.navigation.$prevEl&&(u=t.navigation.$prevEl),d&&d.length&&v(d,n,e.nextSlideMessage),u&&u.length&&v(u,n,e.prevSlideMessage),g()&&t.pagination.$el.on("keydown",U(t.params.pagination.bulletClass),f),t.$el.on("focus",w,!0)};i("beforeInit",(()=>{a=d(`<span class="${t.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`)})),i("afterInit",(()=>{t.params.a11y.enabled&&y()})),i("slidesLengthChange snapGridLengthChange slidesGridLengthChange",(()=>{t.params.a11y.enabled&&b()})),i("fromEdge toEdge afterInit lock unlock",(()=>{t.params.a11y.enabled&&function(){if(t.params.loop||t.params.rewind||!t.navigation)return;const{$nextEl:e,$prevEl:s}=t.navigation;s&&s.length>0&&(t.isBeginning?(u(s),l(s)):(h(s),r(s))),e&&e.length>0&&(t.isEnd?(u(e),l(e)):(h(e),r(e)))}()})),i("paginationUpdate",(()=>{t.params.a11y.enabled&&function(){const e=t.params.a11y;m()&&t.pagination.bullets.each((s=>{const i=d(s);t.params.pagination.clickable&&(r(i),t.params.pagination.renderBullet||(o(i,"button"),c(i,e.paginationBulletMessage.replace(/\{\{index\}\}/,i.index()+1)))),i.is(`.${t.params.pagination.bulletActiveClass}`)?i.attr("aria-current","true"):i.removeAttr("aria-current")}))}()})),i("destroy",(()=>{t.params.a11y.enabled&&function(){let e,s;a&&a.length>0&&a.remove(),t.navigation&&t.navigation.$nextEl&&(e=t.navigation.$nextEl),t.navigation&&t.navigation.$prevEl&&(s=t.navigation.$prevEl),e&&e.off("keydown",f),s&&s.off("keydown",f),g()&&t.pagination.$el.off("keydown",U(t.params.pagination.bulletClass),f),t.$el.off("focus",w,!0)}()}))},function(e){let t,{swiper:s,extendParams:a,on:n,emit:r}=e;function l(){const e=s.slides.eq(s.activeIndex);let i=s.params.autoplay.delay;e.attr("data-swiper-autoplay")&&(i=e.attr("data-swiper-autoplay")||s.params.autoplay.delay),clearTimeout(t),t=c((()=>{let e;s.params.autoplay.reverseDirection?s.params.loop?(s.loopFix(),e=s.slidePrev(s.params.speed,!0,!0),r("autoplay")):s.isBeginning?s.params.autoplay.stopOnLastSlide?d():(e=s.slideTo(s.slides.length-1,s.params.speed,!0,!0),r("autoplay")):(e=s.slidePrev(s.params.speed,!0,!0),r("autoplay")):s.params.loop?(s.loopFix(),e=s.slideNext(s.params.speed,!0,!0),r("autoplay")):s.isEnd?s.params.autoplay.stopOnLastSlide?d():(e=s.slideTo(0,s.params.speed,!0,!0),r("autoplay")):(e=s.slideNext(s.params.speed,!0,!0),r("autoplay")),(s.params.cssMode&&s.autoplay.running||!1===e)&&l()}),i)}function o(){return void 0===t&&(!s.autoplay.running&&(s.autoplay.running=!0,r("autoplayStart"),l(),!0))}function d(){return!!s.autoplay.running&&(void 0!==t&&(t&&(clearTimeout(t),t=void 0),s.autoplay.running=!1,r("autoplayStop"),!0))}function p(e){s.autoplay.running&&(s.autoplay.paused||(t&&clearTimeout(t),s.autoplay.paused=!0,0!==e&&s.params.autoplay.waitForTransition?["transitionend","webkitTransitionEnd"].forEach((e=>{s.$wrapperEl[0].addEventListener(e,h)})):(s.autoplay.paused=!1,l())))}function u(){const e=i();"hidden"===e.visibilityState&&s.autoplay.running&&p(),"visible"===e.visibilityState&&s.autoplay.paused&&(l(),s.autoplay.paused=!1)}function h(e){s&&!s.destroyed&&s.$wrapperEl&&e.target===s.$wrapperEl[0]&&(["transitionend","webkitTransitionEnd"].forEach((e=>{s.$wrapperEl[0].removeEventListener(e,h)})),s.autoplay.paused=!1,s.autoplay.running?l():d())}function f(){s.params.autoplay.disableOnInteraction?d():(r("autoplayPause"),p()),["transitionend","webkitTransitionEnd"].forEach((e=>{s.$wrapperEl[0].removeEventListener(e,h)}))}function m(){s.params.autoplay.disableOnInteraction||(s.autoplay.paused=!1,r("autoplayResume"),l())}s.autoplay={running:!1,paused:!1},a({autoplay:{enabled:!1,delay:3e3,waitForTransition:!0,disableOnInteraction:!0,stopOnLastSlide:!1,reverseDirection:!1,pauseOnMouseEnter:!1}}),n("init",(()=>{if(s.params.autoplay.enabled){o();i().addEventListener("visibilitychange",u),s.params.autoplay.pauseOnMouseEnter&&(s.$el.on("mouseenter",f),s.$el.on("mouseleave",m))}})),n("beforeTransitionStart",((e,t,i)=>{s.autoplay.running&&(i||!s.params.autoplay.disableOnInteraction?s.autoplay.pause(t):d())})),n("sliderFirstMove",(()=>{s.autoplay.running&&(s.params.autoplay.disableOnInteraction?d():p())})),n("touchEnd",(()=>{s.params.cssMode&&s.autoplay.paused&&!s.params.autoplay.disableOnInteraction&&l()})),n("destroy",(()=>{s.$el.off("mouseenter",f),s.$el.off("mouseleave",m),s.autoplay.running&&d();i().removeEventListener("visibilitychange",u)})),Object.assign(s.autoplay,{pause:p,run:l,start:o,stop:d})},function(e){let{swiper:t}=e;Object.assign(t,{appendSlide:K.bind(t),prependSlide:Z.bind(t),addSlide:J.bind(t),removeSlide:Q.bind(t),removeAllSlides:ee.bind(t)})},function(e){let{swiper:t,extendParams:s,on:i}=e;s({fadeEffect:{crossFade:!1,transformEl:null}}),function(e){const{effect:t,swiper:s,on:i,setTranslate:a,setTransition:n,overwriteParams:r,perspective:l,recreateShadows:o,getEffectParams:d}=e;let p;i("beforeInit",(()=>{if(s.params.effect!==t)return;s.classNames.push(`${s.params.containerModifierClass}${t}`),l&&l()&&s.classNames.push(`${s.params.containerModifierClass}3d`);const e=r?r():{};Object.assign(s.params,e),Object.assign(s.originalParams,e)})),i("setTranslate",(()=>{s.params.effect===t&&a()})),i("setTransition",((e,i)=>{s.params.effect===t&&n(i)})),i("transitionEnd",(()=>{if(s.params.effect===t&&o){if(!d||!d().slideShadows)return;s.slides.each((e=>{s.$(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").remove()})),o()}})),i("virtualUpdate",(()=>{s.params.effect===t&&(s.slides.length||(p=!0),requestAnimationFrame((()=>{p&&s.slides&&s.slides.length&&(a(),p=!1)})))}))}({effect:"fade",swiper:t,on:i,setTranslate:()=>{const{slides:e}=t,s=t.params.fadeEffect;for(let i=0;i<e.length;i+=1){const e=t.slides.eq(i);let a=-e[0].swiperSlideOffset;t.params.virtualTranslate||(a-=t.translate);let n=0;t.isHorizontal()||(n=a,a=0);const r=t.params.fadeEffect.crossFade?Math.max(1-Math.abs(e[0].progress),0):1+Math.min(Math.max(e[0].progress,-1),0);te(s,e).css({opacity:r}).transform(`translate3d(${a}px, ${n}px, 0px)`)}},setTransition:e=>{const{transformEl:s}=t.params.fadeEffect;(s?t.slides.find(s):t.slides).transition(e),function(e){let{swiper:t,duration:s,transformEl:i,allSlides:a}=e;const{slides:n,activeIndex:r,$wrapperEl:l}=t;if(t.params.virtualTranslate&&0!==s){let e,s=!1;e=a?i?n.find(i):n:i?n.eq(r).find(i):n.eq(r),e.transitionEnd((()=>{if(s)return;if(!t||t.destroyed)return;s=!0,t.animating=!1;const e=["webkitTransitionEnd","transitionend"];for(let t=0;t<e.length;t+=1)l.trigger(e[t])}))}}({swiper:t,duration:e,transformEl:s,allSlides:!0})},overwriteParams:()=>({slidesPerView:1,slidesPerGroup:1,watchSlidesProgress:!0,spaceBetween:0,virtualTranslate:!t.params.cssMode})})}];return X.use(se),X}));

/*!
	js-cookie
	Copyright	Klaus Hartl, Fagner Brack, GitHub Contributors
	License		MIT
	Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions: The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	Version		3.0.1

	https://github.com/js-cookie/js-cookie
*/
!(function (e, t) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = t())
    : "function" == typeof define && define.amd
      ? define(t)
      : ((e = e || self),
        (function () {
          var n = e.Cookies,
            o = (e.Cookies = t());
          o.noConflict = function () {
            return ((e.Cookies = n), o);
          };
        })());
})(this, function () {
  "use strict";
  function e(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n) e[o] = n[o];
    }
    return e;
  }
  return (function t(n, o) {
    function r(t, r, i) {
      if ("undefined" != typeof document) {
        ("number" == typeof (i = e({}, o, i)).expires &&
          (i.expires = new Date(Date.now() + 864e5 * i.expires)),
          i.expires && (i.expires = i.expires.toUTCString()),
          (t = encodeURIComponent(t)
            .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
            .replace(/[()]/g, escape)));
        var c = "";
        for (var u in i) i[u] && ((c += "; " + u), !0 !== i[u] && (c += "=" + i[u].split(";")[0]));
        return (document.cookie = t + "=" + n.write(r, t) + c);
      }
    }
    return Object.create(
      {
        set: r,
        get: function (e) {
          if ("undefined" != typeof document && (!arguments.length || e)) {
            for (
              var t = document.cookie ? document.cookie.split("; ") : [], o = {}, r = 0;
              r < t.length;
              r++
            ) {
              var i = t[r].split("="),
                c = i.slice(1).join("=");
              try {
                var u = decodeURIComponent(i[0]);
                if (((o[u] = n.read(c, u)), e === u)) break;
              } catch (e) {}
            }
            return e ? o[e] : o;
          }
        },
        remove: function (t, n) {
          r(t, "", e({}, n, { expires: -1 }));
        },
        withAttributes: function (n) {
          return t(this.converter, e({}, this.attributes, n));
        },
        withConverter: function (n) {
          return t(e({}, this.converter, n), this.attributes);
        },
      },
      { attributes: { value: Object.freeze(o) }, converter: { value: Object.freeze(n) } },
    );
  })(
    {
      read: function (e) {
        return (
          '"' === e[0] && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
        );
      },
      write: function (e) {
        return encodeURIComponent(e).replace(
          /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
          decodeURIComponent,
        );
      },
    },
    { path: "/" },
  );
});

// Ratings
function createRatingsHtmlElement(rating, total) {
  var ratingElem = createElementWithClass("span", "rating");
  var split = rating.toString().split(".");
  var intRating = +split[0];
  var intDecimalRating = +split[1] || 0;
  for (var i = 1; i <= total; i++) {
    if (i <= intRating) {
      ratingElem.appendChild(createStarHtmlElement(100));
    } else if (intDecimalRating > 0) {
      var baseTenValue = (intDecimalRating + "0").substr(0, 2);
      ratingElem.appendChild(createStarHtmlElement(baseTenValue));
      intDecimalRating = 0;
    } else {
      ratingElem.appendChild(createStarHtmlElement(0));
    }
  }
  return ratingElem;
}

function createElementWithClass(tag, classList) {
  var tagElem = document.createElement(tag);
  if (!Array.isArray(classList)) {
    classList = [classList];
  }
  for (var i = 0; i < classList.length; i++) {
    tagElem.classList.add(classList[i]);
  }
  return tagElem;
}

function createStarHtmlElement(fillPercentage) {
  var star = createElementWithClass("span", "star");
  var fill = createElementWithClass("span", "fill");
  fill.style.setProperty("width", fillPercentage + "%");
  star.appendChild(fill);
  return star;
}
// Tabs
function semanticTabs(en) {
  "use strict";
  var tabs_header = en.children[0],
    tabs_header_items = tabs_header.querySelectorAll("li"),
    tabs_content = en.children[1],
    classes;
  Array.from(tabs_content.children).forEach(function (el, index) {
    if (el.classList.contains("tab-closed")) {
      classes = "tabs-header";
    } else {
      classes = "tabs-header toggle";
    }
    el.setAttribute("data-index", tabs_header_items.length - index);
    // PermaGreen: same markup as the vendor's innerHTML rebuild, but built with DOM methods,
    // so the tab's own children are moved into .tabs-inner instead of re-parsed from a string.
    var tab_header = document.createElement("a"),
      tab_inner = document.createElement("div");
    tab_header.setAttribute("href", "#");
    tab_header.className = classes;
    tab_header.textContent = "Tabs Header";
    tab_inner.className = "tabs-inner";
    while (el.firstChild) {
      tab_inner.appendChild(el.firstChild);
    }
    el.appendChild(tab_header);
    el.appendChild(document.createTextNode(" "));
    el.appendChild(tab_inner);
  });
  Array.from(tabs_content.querySelectorAll(".tabs-header")).forEach(function (el) {
    el.addEventListener("click", function (e) {
      el.classList.toggle("toggle");
      e.preventDefault();
    });
  });
  Array.from(tabs_header_items).forEach(function (el, index) {
    el.setAttribute("data-index", tabs_header_items.length - index);
    var d = el.dataset.index,
      alias = el.innerText;
    Array.from(tabs_content.querySelectorAll('[data-index="' + d + '"] .tabs-header')).forEach(
      function (el) {
        el.innerText = alias;
      },
    );
    if (!en.classList.contains("static")) {
      Array.from(el.querySelectorAll("a")).forEach(function (el) {
        el.addEventListener("click", function (e) {
          el.parentElement.classList.add("active");
          Array.from(siblings(el.parentElement)).forEach(function (el) {
            el.classList.remove("active");
          });
          Array.from(tabs_content.children).forEach(function (el) {
            el.classList.add("hidden");
            if (el.matches('[data-index="' + d + '"]')) {
              el.classList.remove("hidden");
            }
          });
          e.preventDefault();
        });
      });
    }
  });
}
